import {
  Unit_instance104q5opgivhr8 as Unit_instance,
  protoOf180f3jzyo7rfj as protoOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Continuation1aa2oekvx7jm7 as Continuation,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  EmptyCoroutineContext_getInstance2bxophqwsfm9n as EmptyCoroutineContext_getInstance,
  createCoroutineUnintercepted3gya308dmbbtg as createCoroutineUnintercepted,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  UnsupportedOperationException_init_$Create$1j11kynu3hen2 as UnsupportedOperationException_init_$Create$,
  toString1pkumu07cwy4m as toString,
  isInterface3d6p8outrmvmk as isInterface,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  toString30pk9tzaqopn as toString_0,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  CancellationException_init_$Create$tastk7hwpe6q as CancellationException_init_$Create$,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  AbstractCoroutineContextKey9xr9r6wlj5bm as AbstractCoroutineContextKey,
  Key_instance2d3ch37kcwr5h as Key_instance,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  getxe4seun860fg as get,
  minusKey2uxs00uz5ceqp as minusKey,
  ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor,
  RuntimeException_init_$Create$2bna3ujtv2xfg as RuntimeException_init_$Create$,
  addSuppressedu5jwjfvsc039 as addSuppressed,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Enum3alwj03lh1n41 as Enum,
  startCoroutine327fwvtqvedik as startCoroutine,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  Long2qws0ah9gnpki as Long,
  intercepted2ogpsikxxj4u0 as intercepted,
  ArrayDeque_init_$Create$h67uqnktr40s as ArrayDeque_init_$Create$,
  RuntimeException1r3t0zl97011n as RuntimeException,
  RuntimeException_init_$Init$pie20kq3b0k5 as RuntimeException_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  Error3ofk6owajcepa as Error_0,
  Error_init_$Init$1mferl5sasanp as Error_init_$Init$,
  Element2gr7ezmxqaln7 as Element,
  StringBuilder_init_$Create$2mwec1027v00x as StringBuilder_init_$Create$,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$,
  CancellationException3b36o9qz53rgr as CancellationException,
  ArrayList3it5z8td81qkl as ArrayList,
  IllegalStateException_init_$Create$3oc7yxbr91okv as IllegalStateException_init_$Create$_0,
  plusolev77jfy5r9 as plus,
  get6d5x931vk0s as get_0,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey_0,
  anyToString3ho3k49fc56mj as anyToString,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  CancellationException_init_$Init$n55z32xt5rdh as CancellationException_init_$Init$,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstance1vv9i8zf23p5u as DurationUnit_MILLISECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration,
  returnIfSuspended31u0py81m9mma as returnIfSuspended,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  toLongw1zpgk99d84b as toLong,
  IllegalArgumentException_init_$Create$310sysrobvll9 as IllegalArgumentException_init_$Create$,
  listOf1jh22dvmctj1r as listOf,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$_0,
  NoSuchElementException_init_$Create$wjvpfebkn9od as NoSuchElementException_init_$Create$,
  compareTo3ankvs086tmwq as compareTo,
  last2n4gf5az1lkn4 as last,
  _Char___init__impl__6a9atx281r2pd9o601g as _Char___init__impl__6a9atx,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalStateException_init_$Init$13tvpwythio9e as IllegalStateException_init_$Init$,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  NoSuchElementException_init_$Init$t057lwce4s32 as NoSuchElementException_init_$Init$,
  getKClass1s3j9wy1cofik as getKClass,
  Unitkvevlwgzwiuc as Unit,
  copyOf2ng0t8oizk6it as copyOf,
  throwKotlinNothingValueException2lxmvl03dor6f as throwKotlinNothingValueException,
  Exceptiondt2hlxn7j7vw as Exception,
  Exception_init_$Init$2fx1sms2m4tu1 as Exception_init_$Init$,
  defineProp3hxgpk2knu2px as defineProp,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  createCoroutineUnintercepted21q5ochlctscl as createCoroutineUnintercepted_0,
  startCoroutineUninterceptedOrReturnNonGeneratorVersionyfrrvzbtl8bf as startCoroutineUninterceptedOrReturnNonGeneratorVersion,
  plus20p0vtfmu0596 as plus_0,
  KtList3hktaavzmj137 as KtList,
  listOfvhqybd2zx248 as listOf_0,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  Exception_init_$Create$2kid4wexypdn as Exception_init_$Create$,
  removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull,
  KtMutableList1beimitadwkna as KtMutableList,
  coerceIn302bduskdb54x as coerceIn,
  CancellationException_init_$Init$2ahklm0bmfmy1 as CancellationException_init_$Init$_0,
  CancellationException_init_$Create$35hy9ztjr481d as CancellationException_init_$Create$_0,
  HashSet_init_$Create$7yrdg7emowlg as HashSet_init_$Create$,
  RuntimeException_init_$Init$tgzj522na926 as RuntimeException_init_$Init$_0,
  LinkedHashSet_init_$Create$3qv13l7kzf0ni as LinkedHashSet_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  atomicfu$AtomicRefArray$ofNulls2kz3j9ehigwa3 as atomicfu$AtomicRefArray$ofNulls,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
} from './kotlinx-atomicfu.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
function cancel$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.r1f(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.r1f.call(this, cause);
  }
  return tmp;
}
function invokeOnCompletion$default(onCancelling, invokeImmediately, handler, $super) {
  onCancelling = onCancelling === VOID ? false : onCancelling;
  invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
  return $super === VOID ? this.l1f(onCancelling, invokeImmediately, handler) : $super.l1f.call(this, onCancelling, invokeImmediately, handler);
}
initMetadataForInterface(Job, 'Job', VOID, VOID, [Element], [0]);
initMetadataForInterface(ParentJob, 'ParentJob', VOID, VOID, [Job], [0]);
initMetadataForClass(JobSupport, 'JobSupport', VOID, VOID, [Job, ParentJob], [0]);
initMetadataForInterface(CoroutineScope, 'CoroutineScope');
initMetadataForClass(AbstractCoroutine, 'AbstractCoroutine', VOID, JobSupport, [JobSupport, Job, Continuation, CoroutineScope], [0]);
initMetadataForClass(StandaloneCoroutine, 'StandaloneCoroutine', VOID, AbstractCoroutine, VOID, [0]);
initMetadataForClass(LazyStandaloneCoroutine, 'LazyStandaloneCoroutine', VOID, StandaloneCoroutine, VOID, [0]);
initMetadataForCoroutine($awaitCOROUTINE$2, CoroutineImpl);
initMetadataForClass(DeferredCoroutine, 'DeferredCoroutine', VOID, AbstractCoroutine, [AbstractCoroutine, Job], [0]);
initMetadataForClass(LazyDeferredCoroutine, 'LazyDeferredCoroutine', VOID, DeferredCoroutine, VOID, [0]);
initMetadataForInterface(CancellableContinuation, 'CancellableContinuation', VOID, VOID, [Continuation]);
initMetadataForInterface(NotCompleted, 'NotCompleted');
initMetadataForInterface(CancelHandler, 'CancelHandler', VOID, VOID, [NotCompleted]);
initMetadataForClass(DisposeOnCancel, 'DisposeOnCancel', VOID, VOID, [CancelHandler]);
initMetadataForInterface(Runnable, 'Runnable');
initMetadataForClass(SchedulerTask, 'SchedulerTask', VOID, VOID, [Runnable]);
initMetadataForClass(DispatchedTask, 'DispatchedTask', VOID, SchedulerTask);
initMetadataForInterface(Waiter, 'Waiter');
initMetadataForClass(CancellableContinuationImpl, 'CancellableContinuationImpl', VOID, DispatchedTask, [DispatchedTask, CancellableContinuation, Waiter]);
initMetadataForClass(UserSupplied, 'UserSupplied', VOID, VOID, [CancelHandler]);
initMetadataForObject(Active, 'Active', VOID, VOID, [NotCompleted]);
initMetadataForClass(CompletedContinuation, 'CompletedContinuation');
initMetadataForClass(LockFreeLinkedListNode, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
initMetadataForInterface(Incomplete, 'Incomplete');
initMetadataForClass(JobNode, 'JobNode', VOID, LockFreeLinkedListNode, [LockFreeLinkedListNode, Incomplete]);
initMetadataForClass(ChildContinuation, 'ChildContinuation', VOID, JobNode);
initMetadataForCoroutine($awaitCOROUTINE$3, CoroutineImpl);
initMetadataForClass(CompletableDeferredImpl, 'CompletableDeferredImpl', VOID, JobSupport, [JobSupport, Job], [0]);
initMetadataForInterface(CompletableJob, 'CompletableJob', VOID, VOID, [Job], [0]);
initMetadataForClass(CompletedExceptionally, 'CompletedExceptionally');
initMetadataForClass(CancelledContinuation, 'CancelledContinuation', VOID, CompletedExceptionally);
initMetadataForObject(Key, 'Key', VOID, AbstractCoroutineContextKey);
initMetadataForClass(CoroutineDispatcher, 'CoroutineDispatcher', VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, ContinuationInterceptor]);
initMetadataForObject(Key_0, 'Key');
initMetadataForObject(Key_1, 'Key');
initMetadataForClass(CoroutineName, 'CoroutineName', VOID, AbstractCoroutineContextElement);
initMetadataForObject(GlobalScope, 'GlobalScope', VOID, VOID, [CoroutineScope]);
initMetadataForClass(CoroutineStart, 'CoroutineStart', VOID, Enum);
initMetadataForInterface(CopyableThrowable, 'CopyableThrowable');
function invokeOnTimeout(timeMillis, block, context) {
  return get_DefaultDelay().p1l(timeMillis, block, context);
}
initMetadataForInterface(Delay, 'Delay', VOID, VOID, VOID, [1]);
initMetadataForInterface(DelayWithTimeoutDiagnostics, 'DelayWithTimeoutDiagnostics', VOID, VOID, [Delay], [1]);
initMetadataForClass(EventLoop, 'EventLoop', VOID, CoroutineDispatcher);
initMetadataForObject(ThreadLocalEventLoop, 'ThreadLocalEventLoop');
initMetadataForClass(CompletionHandlerException, 'CompletionHandlerException', VOID, RuntimeException);
initMetadataForClass(CoroutinesInternalError, 'CoroutinesInternalError', VOID, Error_0);
initMetadataForObject(Key_2, 'Key');
initMetadataForObject(NonDisposableHandle, 'NonDisposableHandle');
initMetadataForClass(DisposeOnCompletion, 'DisposeOnCompletion', VOID, JobNode);
initMetadataForClass(Empty, 'Empty', VOID, VOID, [Incomplete]);
initMetadataForClass(LockFreeLinkedListHead, 'LockFreeLinkedListHead', LockFreeLinkedListHead, LockFreeLinkedListNode);
initMetadataForClass(NodeList, 'NodeList', NodeList, LockFreeLinkedListHead, [LockFreeLinkedListHead, Incomplete]);
initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
initMetadataForClass(Finishing, 'Finishing', VOID, SynchronizedObject, [SynchronizedObject, Incomplete]);
initMetadataForClass(ChildCompletion, 'ChildCompletion', VOID, JobNode);
initMetadataForClass(AwaitContinuation, 'AwaitContinuation', VOID, CancellableContinuationImpl);
initMetadataForClass(InactiveNodeList, 'InactiveNodeList', VOID, VOID, [Incomplete]);
initMetadataForClass(InvokeOnCompletion, 'InvokeOnCompletion', VOID, JobNode);
initMetadataForClass(InvokeOnCancelling, 'InvokeOnCancelling', VOID, JobNode);
initMetadataForClass(ResumeOnCompletion, 'ResumeOnCompletion', VOID, JobNode);
initMetadataForClass(ChildHandleNode, 'ChildHandleNode', VOID, JobNode);
initMetadataForClass(ResumeAwaitOnCompletion, 'ResumeAwaitOnCompletion', VOID, JobNode);
initMetadataForClass(IncompleteStateBox, 'IncompleteStateBox');
initMetadataForClass(JobImpl, 'JobImpl', VOID, JobSupport, [JobSupport, CompletableJob], [0]);
initMetadataForClass(MainCoroutineDispatcher, 'MainCoroutineDispatcher', VOID, CoroutineDispatcher);
initMetadataForClass(SupervisorJobImpl, 'SupervisorJobImpl', VOID, JobImpl, VOID, [0]);
initMetadataForClass(TimeoutCancellationException, 'TimeoutCancellationException', VOID, CancellationException, [CancellationException, CopyableThrowable]);
initMetadataForClass(ScopeCoroutine, 'ScopeCoroutine', VOID, AbstractCoroutine, VOID, [0]);
initMetadataForClass(TimeoutCoroutine, 'TimeoutCoroutine', VOID, ScopeCoroutine, [ScopeCoroutine, Runnable], [0]);
initMetadataForCoroutine($withTimeoutOrNullCOROUTINE$4, CoroutineImpl);
initMetadataForObject(Unconfined, 'Unconfined', VOID, CoroutineDispatcher);
initMetadataForObject(Key_3, 'Key');
initMetadataForClass(BufferOverflow, 'BufferOverflow', VOID, Enum);
initMetadataForClass(ConcurrentLinkedListNode, 'ConcurrentLinkedListNode');
initMetadataForClass(Segment, 'Segment', VOID, ConcurrentLinkedListNode, [ConcurrentLinkedListNode, NotCompleted]);
initMetadataForClass(ChannelSegment, 'ChannelSegment', VOID, Segment);
initMetadataForCoroutine($hasNextCOROUTINE$8, CoroutineImpl);
initMetadataForClass(SendBroadcast, 'SendBroadcast', VOID, VOID, [Waiter]);
initMetadataForClass(BufferedChannelIterator, 'BufferedChannelIterator', VOID, VOID, [Waiter], [0, 3]);
initMetadataForCoroutine($sendCOROUTINE$5, CoroutineImpl);
initMetadataForCoroutine($receiveCOROUTINE$6, CoroutineImpl);
function cancel$default_0(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.r1f(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.r1f.call(this, cause);
  }
  return tmp;
}
initMetadataForInterface(ReceiveChannel, 'ReceiveChannel', VOID, VOID, VOID, [0]);
function close$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  return $super === VOID ? this.u1w(cause) : $super.u1w.call(this, cause);
}
initMetadataForInterface(SendChannel, 'SendChannel', VOID, VOID, VOID, [1]);
initMetadataForClass(BufferedChannel, 'BufferedChannel', VOID, VOID, [ReceiveChannel, SendChannel], [1, 4, 0, 3]);
initMetadataForClass(WaiterEB, 'WaiterEB');
initMetadataForClass(ReceiveCatching, 'ReceiveCatching', VOID, VOID, [Waiter]);
initMetadataForObject(Factory, 'Factory');
initMetadataForClass(Failed, 'Failed', Failed);
initMetadataForClass(Closed, 'Closed', VOID, Failed);
initMetadataForCompanion(Companion);
initMetadataForClass(ChannelResult, 'ChannelResult');
initMetadataForClass(ClosedSendChannelException, 'ClosedSendChannelException', VOID, IllegalStateException);
initMetadataForClass(ClosedReceiveChannelException, 'ClosedReceiveChannelException', VOID, NoSuchElementException);
initMetadataForClass(ChannelCoroutine, 'ChannelCoroutine', VOID, AbstractCoroutine, [AbstractCoroutine, ReceiveChannel, SendChannel], [1, 0]);
initMetadataForClass(ConflatedBufferedChannel, 'ConflatedBufferedChannel', VOID, BufferedChannel, VOID, [1, 0]);
initMetadataForInterface(ProducerScope, 'ProducerScope', VOID, VOID, [CoroutineScope, SendChannel], [1]);
initMetadataForClass(ProducerCoroutine, 'ProducerCoroutine', VOID, ChannelCoroutine, [ChannelCoroutine, ProducerScope], [1, 0]);
initMetadataForClass(AbstractFlow, 'AbstractFlow', VOID, VOID, VOID, [1]);
initMetadataForClass(SafeFlow, 'SafeFlow', VOID, AbstractFlow, VOID, [1]);
initMetadataForCoroutine($collectCOROUTINE$12, CoroutineImpl);
initMetadataForClass(asFlow$$inlined$unsafeFlow$1, VOID, VOID, VOID, VOID, [1]);
initMetadataForCoroutine($collectCOROUTINE$15, CoroutineImpl);
initMetadataForInterface(FlowCollector, 'FlowCollector', VOID, VOID, VOID, [1]);
initMetadataForClass(Emitter, 'Emitter');
initMetadataForCoroutine($collectCOROUTINE$16, CoroutineImpl);
initMetadataForClass(AbstractSharedFlow, 'AbstractSharedFlow', VOID, SynchronizedObject);
initMetadataForClass(SharedFlowImpl, 'SharedFlowImpl', VOID, AbstractSharedFlow, [AbstractSharedFlow, FlowCollector], [1]);
initMetadataForClass(AbstractSharedFlowSlot, 'AbstractSharedFlowSlot');
initMetadataForClass(SharedFlowSlot, 'SharedFlowSlot', SharedFlowSlot, AbstractSharedFlowSlot);
initMetadataForCoroutine($collectCOROUTINE$17, CoroutineImpl);
initMetadataForClass(StateFlowImpl, 'StateFlowImpl', VOID, AbstractSharedFlow, [AbstractSharedFlow, FlowCollector], [1]);
initMetadataForClass(StateFlowSlot, 'StateFlowSlot', StateFlowSlot, AbstractSharedFlowSlot, VOID, [0]);
initMetadataForClass(ThrowingCollector, 'ThrowingCollector', VOID, VOID, [FlowCollector], [1]);
initMetadataForCoroutine($onSubscriptionCOROUTINE$26, CoroutineImpl);
initMetadataForClass(SubscribedFlowCollector, 'SubscribedFlowCollector', VOID, VOID, [FlowCollector], [0, 1]);
initMetadataForCoroutine($collectCOROUTINE$27, CoroutineImpl);
initMetadataForClass(ReadonlyStateFlow, 'ReadonlyStateFlow', VOID, VOID, VOID, [1]);
initMetadataForCoroutine($collectCOROUTINE$28, CoroutineImpl);
initMetadataForClass(ReadonlySharedFlow, 'ReadonlySharedFlow', VOID, VOID, VOID, [1]);
initMetadataForClass(firstOrNull$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
initMetadataForCoroutine($emitCOROUTINE$38, CoroutineImpl);
initMetadataForClass(firstOrNull$$inlined$collectWhile$2, VOID, VOID, VOID, [FlowCollector], [1]);
initMetadataForCoroutine($firstOrNullCOROUTINE$35, CoroutineImpl);
initMetadataForCoroutine($firstOrNullCOROUTINE$37, CoroutineImpl);
initMetadataForClass(SegmentOrClosed, 'SegmentOrClosed');
initMetadataForObject(ExceptionSuccessfullyProcessed, 'ExceptionSuccessfullyProcessed', VOID, Exception);
initMetadataForClass(DispatchedContinuation, 'DispatchedContinuation', VOID, DispatchedTask, [DispatchedTask, Continuation]);
initMetadataForClass(DispatchException, 'DispatchException', VOID, Exception);
initMetadataForClass(UndeliveredElementException, 'UndeliveredElementException', VOID, RuntimeException);
initMetadataForClass(ContextScope, 'ContextScope', VOID, VOID, [CoroutineScope]);
initMetadataForClass(Symbol, 'Symbol');
initMetadataForInterface(SelectInstance, 'SelectInstance');
initMetadataForClass(ClauseData, 'ClauseData', VOID, VOID, VOID, [1]);
initMetadataForClass(SelectImplementation, 'SelectImplementation', VOID, VOID, [CancelHandler, SelectInstance, Waiter], [0, 2]);
initMetadataForClass(TrySelectDetailedResult, 'TrySelectDetailedResult', VOID, Enum);
initMetadataForClass(CancellableContinuationWithOwner, 'CancellableContinuationWithOwner', VOID, VOID, [CancellableContinuation, Waiter]);
initMetadataForClass(SemaphoreAndMutexImpl, 'SemaphoreAndMutexImpl', VOID, VOID, VOID, [0]);
initMetadataForClass(MutexImpl, 'MutexImpl', VOID, SemaphoreAndMutexImpl, VOID, [1, 0]);
initMetadataForClass(SemaphoreSegment, 'SemaphoreSegment', VOID, Segment);
initMetadataForClass(SetTimeoutBasedDispatcher, 'SetTimeoutBasedDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
initMetadataForObject(NodeDispatcher, 'NodeDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
initMetadataForClass(MessageQueue, 'MessageQueue', VOID, VOID, [KtMutableList]);
initMetadataForClass(ScheduledMessageQueue, 'ScheduledMessageQueue', VOID, MessageQueue);
initMetadataForClass(WindowMessageQueue, 'WindowMessageQueue', VOID, MessageQueue);
initMetadataForClass(UnconfinedEventLoop, 'UnconfinedEventLoop', UnconfinedEventLoop, EventLoop);
initMetadataForObject(SetTimeoutDispatcher, 'SetTimeoutDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
initMetadataForClass(ClearTimeout, 'ClearTimeout', VOID, VOID, [CancelHandler]);
initMetadataForClass(WindowClearTimeout, 'WindowClearTimeout', VOID, ClearTimeout);
initMetadataForClass(WindowDispatcher, 'WindowDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
initMetadataForObject(Dispatchers, 'Dispatchers');
initMetadataForClass(JsMainDispatcher, 'JsMainDispatcher', VOID, MainCoroutineDispatcher);
initMetadataForClass(JobCancellationException, 'JobCancellationException', VOID, CancellationException);
initMetadataForClass(AbortFlowException, 'AbortFlowException', VOID, CancellationException);
initMetadataForClass(SafeCollector, 'SafeCollector', VOID, VOID, [FlowCollector], [1]);
initMetadataForClass(WorkaroundAtomicReference, 'WorkaroundAtomicReference');
initMetadataForClass(DiagnosticCoroutineContextException, 'DiagnosticCoroutineContextException', VOID, RuntimeException);
initMetadataForClass(ListClosed, 'ListClosed', VOID, LockFreeLinkedListNode);
initMetadataForClass(CommonThreadLocal, 'CommonThreadLocal', CommonThreadLocal);
//endregion
function AbstractCoroutine(parentContext, initParentJob, active) {
  JobSupport.call(this, active);
  if (initParentJob) {
    this.d1e(parentContext.a9(Key_instance_3));
  }
  this.g1e_1 = parentContext.jg(this);
}
protoOf(AbstractCoroutine).t8 = function () {
  return this.g1e_1;
};
protoOf(AbstractCoroutine).h1e = function () {
  return this.g1e_1;
};
protoOf(AbstractCoroutine).i1e = function () {
  return protoOf(JobSupport).i1e.call(this);
};
protoOf(AbstractCoroutine).j1e = function (value) {
};
protoOf(AbstractCoroutine).k1e = function (cause, handled) {
};
protoOf(AbstractCoroutine).l1e = function () {
  return get_classSimpleName(this) + ' was cancelled';
};
protoOf(AbstractCoroutine).m1e = function (state) {
  if (state instanceof CompletedExceptionally) {
    this.k1e(state.n1e_1, state.p1e());
  } else {
    this.j1e((state == null ? true : !(state == null)) ? state : THROW_CCE());
  }
};
protoOf(AbstractCoroutine).y8 = function (result) {
  var state = this.q1e(toState_0(result));
  if (state === get_COMPLETING_WAITING_CHILDREN())
    return Unit_instance;
  this.r1e(state);
};
protoOf(AbstractCoroutine).r1e = function (state) {
  return this.s1e(state);
};
protoOf(AbstractCoroutine).t1e = function (exception) {
  handleCoroutineException(this.g1e_1, exception);
};
protoOf(AbstractCoroutine).u1e = function () {
  var tmp0_elvis_lhs = get_coroutineName(this.g1e_1);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return protoOf(JobSupport).u1e.call(this);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var coroutineName = tmp;
  return '"' + coroutineName + '":' + protoOf(JobSupport).u1e.call(this);
};
protoOf(AbstractCoroutine).v1e = function (start, receiver, block) {
  start.y1e(block, receiver, this);
};
function launch(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.j1g() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
  coroutine.v1e(start, coroutine, block);
  return coroutine;
}
function async(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.j1g() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
  coroutine.v1e(start, coroutine, block);
  return coroutine;
}
function StandaloneCoroutine(parentContext, active) {
  AbstractCoroutine.call(this, parentContext, true, active);
}
protoOf(StandaloneCoroutine).e1g = function (exception) {
  handleCoroutineException(this.g1e_1, exception);
  return true;
};
function LazyStandaloneCoroutine(parentContext, block) {
  StandaloneCoroutine.call(this, parentContext, false);
  this.q1g_1 = createCoroutineUnintercepted(block, this, this);
}
protoOf(LazyStandaloneCoroutine).g1f = function () {
  startCoroutineCancellable_0(this.q1g_1, this);
};
function $awaitCOROUTINE$2(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.z1g_1 = _this__u8e3s4;
}
protoOf($awaitCOROUTINE$2).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.z1g_1.i1g(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return (suspendResult == null ? true : !(suspendResult == null)) ? suspendResult : THROW_CCE();
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function DeferredCoroutine(parentContext, active) {
  AbstractCoroutine.call(this, parentContext, true, active);
}
protoOf(DeferredCoroutine).d1h = function () {
  var tmp = this.h1g();
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(DeferredCoroutine).e1h = function ($completion) {
  var tmp = new $awaitCOROUTINE$2(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function LazyDeferredCoroutine(parentContext, block) {
  DeferredCoroutine.call(this, parentContext, false);
  this.i1h_1 = createCoroutineUnintercepted(block, this, this);
}
protoOf(LazyDeferredCoroutine).g1f = function () {
  startCoroutineCancellable_0(this.i1h_1, this);
};
function CancellableContinuation() {
}
function disposeOnCancellation(_this__u8e3s4, handle) {
  return invokeOnCancellation(_this__u8e3s4, new DisposeOnCancel(handle));
}
function invokeOnCancellation(_this__u8e3s4, handler) {
  var tmp;
  if (_this__u8e3s4 instanceof CancellableContinuationImpl) {
    _this__u8e3s4.u1h(handler);
    tmp = Unit_instance;
  } else {
    throw UnsupportedOperationException_init_$Create$('third-party implementation of CancellableContinuation is not supported');
  }
  return tmp;
}
function DisposeOnCancel(handle) {
  this.v1h_1 = handle;
}
protoOf(DisposeOnCancel).w1h = function (cause) {
  return this.v1h_1.x1h();
};
protoOf(DisposeOnCancel).toString = function () {
  return 'DisposeOnCancel[' + toString(this.v1h_1) + ']';
};
function getOrCreateCancellableContinuation(delegate) {
  if (!(delegate instanceof DispatchedContinuation)) {
    return new CancellableContinuationImpl(delegate, 1);
  }
  var tmp0_safe_receiver = delegate.e1i();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp0_safe_receiver.f1i()) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return new CancellableContinuationImpl(delegate, 2);
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function get_RESUME_TOKEN() {
  _init_properties_CancellableContinuationImpl_kt__6rrtdd();
  return RESUME_TOKEN;
}
var RESUME_TOKEN;
function _get_parentHandle__f8dcex($this) {
  return $this.t1h_1.kotlinx$atomicfu$value;
}
function _get_stateDebugRepresentation__bf18u4($this) {
  var tmp0_subject = $this.c1f();
  var tmp;
  if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) {
    tmp = 'Active';
  } else {
    if (tmp0_subject instanceof CancelledContinuation) {
      tmp = 'Cancelled';
    } else {
      tmp = 'Completed';
    }
  }
  return tmp;
}
function isReusable($this) {
  var tmp;
  if (get_isReusableMode($this.h1i_1)) {
    var tmp_0 = $this.p1h_1;
    tmp = (tmp_0 instanceof DispatchedContinuation ? tmp_0 : THROW_CCE()).g1i();
  } else {
    tmp = false;
  }
  return tmp;
}
function cancelLater($this, cause) {
  if (!isReusable($this))
    return false;
  var tmp = $this.p1h_1;
  var dispatched = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
  return dispatched.i1i(cause);
}
function callSegmentOnCancellation($this, segment, cause) {
  // Inline function 'kotlinx.coroutines.index' call
  var index = $this.r1h_1.kotlinx$atomicfu$value & 536870911;
  // Inline function 'kotlin.check' call
  if (!!(index === 536870911)) {
    var message = 'The index for Segment.onCancellation(..) is broken';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
  try {
    segment.n1i(index, cause, $this.t8());
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException($this.t8(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + $this.toString(), ex));
    } else {
      throw $p;
    }
  }
}
function trySuspend($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.r1h_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.decision' call
    switch (cur >> 29) {
      case 0:
        // Inline function 'kotlinx.coroutines.index' call

        // Inline function 'kotlinx.coroutines.decisionAndIndex' call

        var tmp$ret$2 = (1 << 29) + (cur & 536870911) | 0;
        if ($this.r1h_1.atomicfu$compareAndSet(cur, tmp$ret$2))
          return true;
        break;
      case 2:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already suspended';
        throw IllegalStateException_init_$Create$(toString(message));
    }
  }
}
function tryResume($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.r1h_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.decision' call
    switch (cur >> 29) {
      case 0:
        // Inline function 'kotlinx.coroutines.index' call

        // Inline function 'kotlinx.coroutines.decisionAndIndex' call

        var tmp$ret$2 = (2 << 29) + (cur & 536870911) | 0;
        if ($this.r1h_1.atomicfu$compareAndSet(cur, tmp$ret$2))
          return true;
        break;
      case 1:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already resumed';
        throw IllegalStateException_init_$Create$(toString(message));
    }
  }
}
function installParentHandle($this) {
  var tmp0_elvis_lhs = $this.t8().a9(Key_instance_3);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var parent = tmp;
  var handle = invokeOnCompletion(parent, VOID, new ChildContinuation($this));
  $this.t1h_1.atomicfu$compareAndSet(null, handle);
  return handle;
}
function invokeOnCancellationImpl($this, handler) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.s1h_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (state instanceof Active) {
      if ($this.s1h_1.atomicfu$compareAndSet(state, handler))
        return Unit_instance;
    } else {
      var tmp;
      if (!(state == null) ? isInterface(state, CancelHandler) : false) {
        tmp = true;
      } else {
        tmp = state instanceof Segment;
      }
      if (tmp) {
        multipleHandlersError($this, handler, state);
      } else {
        if (state instanceof CompletedExceptionally) {
          if (!state.w1i()) {
            multipleHandlersError($this, handler, state);
          }
          if (state instanceof CancelledContinuation) {
            var tmp1_safe_receiver = state instanceof CompletedExceptionally ? state : null;
            var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n1e_1;
            if (isInterface(handler, CancelHandler)) {
              $this.t1i(handler, cause);
            } else {
              var segment = handler instanceof Segment ? handler : THROW_CCE();
              callSegmentOnCancellation($this, segment, cause);
            }
          }
          return Unit_instance;
        } else {
          if (state instanceof CompletedContinuation) {
            if (!(state.p1i_1 == null)) {
              multipleHandlersError($this, handler, state);
            }
            if (handler instanceof Segment)
              return Unit_instance;
            if (!isInterface(handler, CancelHandler))
              THROW_CCE();
            if (state.u1i()) {
              $this.t1i(handler, state.s1i_1);
              return Unit_instance;
            }
            var update = state.v1i(VOID, handler);
            if ($this.s1h_1.atomicfu$compareAndSet(state, update))
              return Unit_instance;
          } else {
            if (handler instanceof Segment)
              return Unit_instance;
            if (!isInterface(handler, CancelHandler))
              THROW_CCE();
            var update_0 = new CompletedContinuation(state, handler);
            if ($this.s1h_1.atomicfu$compareAndSet(state, update_0))
              return Unit_instance;
          }
        }
      }
    }
  }
}
function multipleHandlersError($this, handler, state) {
  // Inline function 'kotlin.error' call
  var message = "It's prohibited to register multiple handlers, tried to register " + toString(handler) + ', already has ' + toString_0(state);
  throw IllegalStateException_init_$Create$(toString(message));
}
function dispatchResume($this, mode) {
  if (tryResume($this))
    return Unit_instance;
  dispatch($this, mode);
}
function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
  var tmp;
  if (proposedUpdate instanceof CompletedExceptionally) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    tmp = proposedUpdate;
  } else {
    if (!get_isCancellableMode(resumeMode) && idempotent == null) {
      tmp = proposedUpdate;
    } else {
      var tmp_0;
      var tmp_1;
      if (!(onCancellation == null)) {
        tmp_1 = true;
      } else {
        tmp_1 = isInterface(state, CancelHandler);
      }
      if (tmp_1) {
        tmp_0 = true;
      } else {
        tmp_0 = !(idempotent == null);
      }
      if (tmp_0) {
        tmp = new CompletedContinuation(proposedUpdate, isInterface(state, CancelHandler) ? state : null, onCancellation, idempotent);
      } else {
        tmp = proposedUpdate;
      }
    }
  }
  return tmp;
}
function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.s1h_1;
  while (true) {
    var tmp1 = this_0.kotlinx$atomicfu$value;
    $l$block: {
      if (!(tmp1 == null) ? isInterface(tmp1, NotCompleted) : false) {
        var update = resumedState($this, tmp1, proposedUpdate, $this.h1i_1, onCancellation, idempotent);
        if (!$this.s1h_1.atomicfu$compareAndSet(tmp1, update)) {
          break $l$block;
        }
        detachChildIfNonReusable($this);
        return get_RESUME_TOKEN();
      } else {
        if (tmp1 instanceof CompletedContinuation) {
          var tmp;
          if (!(idempotent == null) && tmp1.r1i_1 === idempotent) {
            // Inline function 'kotlinx.coroutines.assert' call
            tmp = get_RESUME_TOKEN();
          } else {
            tmp = null;
          }
          return tmp;
        } else {
          return null;
        }
      }
    }
  }
}
function alreadyResumedError($this, proposedUpdate) {
  // Inline function 'kotlin.error' call
  var message = 'Already resumed, but proposed with update ' + toString_0(proposedUpdate);
  throw IllegalStateException_init_$Create$(toString(message));
}
function detachChildIfNonReusable($this) {
  if (!isReusable($this)) {
    $this.x1i();
  }
}
function CancellableContinuationImpl$resume$lambda($onCancellation) {
  return function (cause, _unused_var__etf5q3, _unused_var__etf5q3_0) {
    $onCancellation(cause);
    return Unit_instance;
  };
}
function CancellableContinuationImpl(delegate, resumeMode) {
  DispatchedTask.call(this, resumeMode);
  this.p1h_1 = delegate;
  // Inline function 'kotlinx.coroutines.assert' call
  this.q1h_1 = this.p1h_1.t8();
  var tmp = this;
  // Inline function 'kotlinx.coroutines.decisionAndIndex' call
  var tmp$ret$1 = (0 << 29) + 536870911 | 0;
  tmp.r1h_1 = atomic$int$1(tmp$ret$1);
  this.s1h_1 = atomic$ref$1(Active_instance);
  this.t1h_1 = atomic$ref$1(null);
}
protoOf(CancellableContinuationImpl).y1i = function () {
  return this.p1h_1;
};
protoOf(CancellableContinuationImpl).t8 = function () {
  return this.q1h_1;
};
protoOf(CancellableContinuationImpl).c1f = function () {
  return this.s1h_1.kotlinx$atomicfu$value;
};
protoOf(CancellableContinuationImpl).d1f = function () {
  var tmp = this.c1f();
  return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
};
protoOf(CancellableContinuationImpl).e1f = function () {
  var tmp = this.c1f();
  return tmp instanceof CancelledContinuation;
};
protoOf(CancellableContinuationImpl).z1i = function () {
  var tmp0_elvis_lhs = installParentHandle(this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var handle = tmp;
  if (this.d1f()) {
    handle.x1h();
    this.t1h_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
  }
};
protoOf(CancellableContinuationImpl).f1i = function () {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var state = this.s1h_1.kotlinx$atomicfu$value;
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp;
  if (state instanceof CompletedContinuation) {
    tmp = !(state.r1i_1 == null);
  } else {
    tmp = false;
  }
  if (tmp) {
    this.x1i();
    return false;
  }
  var tmp_0 = this.r1h_1;
  // Inline function 'kotlinx.coroutines.decisionAndIndex' call
  tmp_0.kotlinx$atomicfu$value = (0 << 29) + 536870911 | 0;
  this.s1h_1.kotlinx$atomicfu$value = Active_instance;
  return true;
};
protoOf(CancellableContinuationImpl).a1j = function () {
  return this.c1f();
};
protoOf(CancellableContinuationImpl).b1j = function (takenState, cause) {
  var this_0 = this.s1h_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (!(state == null) ? isInterface(state, NotCompleted) : false) {
      // Inline function 'kotlin.error' call
      var message = 'Not completed';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      if (state instanceof CompletedExceptionally)
        return Unit_instance;
      else {
        if (state instanceof CompletedContinuation) {
          // Inline function 'kotlin.check' call
          if (!!state.u1i()) {
            var message_0 = 'Must be called at most once';
            throw IllegalStateException_init_$Create$(toString(message_0));
          }
          var update = state.v1i(VOID, VOID, VOID, VOID, cause);
          if (this.s1h_1.atomicfu$compareAndSet(state, update)) {
            state.c1j(this, cause);
            return Unit_instance;
          }
        } else {
          if (this.s1h_1.atomicfu$compareAndSet(state, new CompletedContinuation(state, VOID, VOID, VOID, cause))) {
            return Unit_instance;
          }
        }
      }
    }
  }
  return Unit_instance;
};
protoOf(CancellableContinuationImpl).d1j = function (cause) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.s1h_1;
  while (true) {
    var tmp1 = this_0.kotlinx$atomicfu$value;
    $l$block: {
      if (!(!(tmp1 == null) ? isInterface(tmp1, NotCompleted) : false))
        return false;
      var tmp;
      if (isInterface(tmp1, CancelHandler)) {
        tmp = true;
      } else {
        tmp = tmp1 instanceof Segment;
      }
      var update = new CancelledContinuation(this, cause, tmp);
      if (!this.s1h_1.atomicfu$compareAndSet(tmp1, update)) {
        break $l$block;
      }
      if (isInterface(tmp1, CancelHandler)) {
        this.t1i(tmp1, cause);
      } else {
        if (tmp1 instanceof Segment) {
          callSegmentOnCancellation(this, tmp1, cause);
        }
      }
      detachChildIfNonReusable(this);
      dispatchResume(this, this.h1i_1);
      return true;
    }
  }
};
protoOf(CancellableContinuationImpl).e1j = function (cause) {
  if (cancelLater(this, cause))
    return Unit_instance;
  this.d1j(cause);
  detachChildIfNonReusable(this);
};
protoOf(CancellableContinuationImpl).t1i = function (handler, cause) {
  // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
  try {
    handler.w1h(cause);
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException(this.t8(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + this.toString(), ex));
    } else {
      throw $p;
    }
  }
  return Unit_instance;
};
protoOf(CancellableContinuationImpl).f1j = function (onCancellation, cause, value) {
  try {
    onCancellation(cause, value, this.t8());
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException(this.t8(), new CompletionHandlerException('Exception in resume onCancellation handler for ' + this.toString(), ex));
    } else {
      throw $p;
    }
  }
};
protoOf(CancellableContinuationImpl).g1j = function (parent) {
  return parent.h1f();
};
protoOf(CancellableContinuationImpl).h1j = function () {
  var isReusable_0 = isReusable(this);
  if (trySuspend(this)) {
    if (_get_parentHandle__f8dcex(this) == null) {
      installParentHandle(this);
    }
    if (isReusable_0) {
      this.i1j();
    }
    return get_COROUTINE_SUSPENDED();
  }
  if (isReusable_0) {
    this.i1j();
  }
  var state = this.c1f();
  if (state instanceof CompletedExceptionally)
    throw recoverStackTrace(state.n1e_1, this);
  if (get_isCancellableMode(this.h1i_1)) {
    var job = this.t8().a9(Key_instance_3);
    if (!(job == null) && !job.i1e()) {
      var cause = job.h1f();
      this.b1j(state, cause);
      throw recoverStackTrace(cause, this);
    }
  }
  return this.j1j(state);
};
protoOf(CancellableContinuationImpl).i1j = function () {
  var tmp = this.p1h_1;
  var tmp0_safe_receiver = tmp instanceof DispatchedContinuation ? tmp : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k1j(this);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var cancellationCause = tmp_0;
  this.x1i();
  this.d1j(cancellationCause);
};
protoOf(CancellableContinuationImpl).y8 = function (result) {
  return this.l1j(toState(result, this), this.h1i_1);
};
protoOf(CancellableContinuationImpl).m1j = function (value, onCancellation) {
  var tmp = this.h1i_1;
  var tmp_0;
  if (onCancellation == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = CancellableContinuationImpl$resume$lambda(onCancellation);
  }
  return this.n1j(value, tmp, tmp_0);
};
protoOf(CancellableContinuationImpl).n1h = function (value, onCancellation) {
  return this.n1j(value, this.h1i_1, onCancellation);
};
protoOf(CancellableContinuationImpl).o1j = function (segment, index) {
  var tmp0 = this.r1h_1;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.index' call
      // Inline function 'kotlin.check' call
      if (!((cur & 536870911) === 536870911)) {
        var message = 'invokeOnCancellation should be called at most once';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      // Inline function 'kotlinx.coroutines.decision' call
      // Inline function 'kotlinx.coroutines.decisionAndIndex' call
      var upd = (cur >> 29 << 29) + index | 0;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        break $l$block;
      }
    }
  }
  invokeOnCancellationImpl(this, segment);
};
protoOf(CancellableContinuationImpl).l1h = function (handler) {
  return invokeOnCancellation(this, new UserSupplied(handler));
};
protoOf(CancellableContinuationImpl).u1h = function (handler) {
  return invokeOnCancellationImpl(this, handler);
};
protoOf(CancellableContinuationImpl).n1j = function (proposedUpdate, resumeMode, onCancellation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.s1h_1;
  while (true) {
    var tmp1 = this_0.kotlinx$atomicfu$value;
    $l$block: {
      if (!(tmp1 == null) ? isInterface(tmp1, NotCompleted) : false) {
        var update = resumedState(this, tmp1, proposedUpdate, resumeMode, onCancellation, null);
        if (!this.s1h_1.atomicfu$compareAndSet(tmp1, update)) {
          break $l$block;
        }
        detachChildIfNonReusable(this);
        dispatchResume(this, resumeMode);
        return Unit_instance;
      } else {
        if (tmp1 instanceof CancelledContinuation) {
          if (tmp1.s1j()) {
            if (onCancellation == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              this.f1j(onCancellation, tmp1.n1e_1, proposedUpdate);
            }
            return Unit_instance;
          }
        }
      }
      alreadyResumedError(this, proposedUpdate);
    }
  }
};
protoOf(CancellableContinuationImpl).l1j = function (proposedUpdate, resumeMode, onCancellation, $super) {
  onCancellation = onCancellation === VOID ? null : onCancellation;
  var tmp;
  if ($super === VOID) {
    this.n1j(proposedUpdate, resumeMode, onCancellation);
    tmp = Unit_instance;
  } else {
    tmp = $super.n1j.call(this, proposedUpdate, resumeMode, onCancellation);
  }
  return tmp;
};
protoOf(CancellableContinuationImpl).x1i = function () {
  var tmp0_elvis_lhs = _get_parentHandle__f8dcex(this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var handle = tmp;
  handle.x1h();
  this.t1h_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
};
protoOf(CancellableContinuationImpl).j1h = function (value, idempotent, onCancellation) {
  return tryResumeImpl(this, value, idempotent, onCancellation);
};
protoOf(CancellableContinuationImpl).k1h = function (token) {
  // Inline function 'kotlinx.coroutines.assert' call
  dispatchResume(this, this.h1i_1);
};
protoOf(CancellableContinuationImpl).m1h = function (_this__u8e3s4, value) {
  var tmp = this.p1h_1;
  var dc = tmp instanceof DispatchedContinuation ? tmp : null;
  var tmp_0;
  if ((dc == null ? null : dc.z1h_1) === _this__u8e3s4) {
    tmp_0 = 4;
  } else {
    tmp_0 = this.h1i_1;
  }
  this.l1j(value, tmp_0);
};
protoOf(CancellableContinuationImpl).j1j = function (state) {
  var tmp;
  if (state instanceof CompletedContinuation) {
    var tmp_0 = state.o1i_1;
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    tmp = (state == null ? true : !(state == null)) ? state : THROW_CCE();
  }
  return tmp;
};
protoOf(CancellableContinuationImpl).t1j = function (state) {
  var tmp0_safe_receiver = protoOf(DispatchedTask).t1j.call(this, state);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = recoverStackTrace(tmp0_safe_receiver, this.p1h_1);
  }
  return tmp;
};
protoOf(CancellableContinuationImpl).toString = function () {
  return this.u1j() + '(' + toDebugString(this.p1h_1) + '){' + _get_stateDebugRepresentation__bf18u4(this) + '}@' + get_hexAddress(this);
};
protoOf(CancellableContinuationImpl).u1j = function () {
  return 'CancellableContinuation';
};
function NotCompleted() {
}
function UserSupplied(handler) {
  this.x1j_1 = handler;
}
protoOf(UserSupplied).w1h = function (cause) {
  this.x1j_1(cause);
};
protoOf(UserSupplied).toString = function () {
  return 'CancelHandler.UserSupplied[' + get_classSimpleName(this.x1j_1) + '@' + get_hexAddress(this) + ']';
};
function CancelHandler() {
}
function Active() {
}
protoOf(Active).toString = function () {
  return 'Active';
};
var Active_instance;
function Active_getInstance() {
  return Active_instance;
}
function CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
  cancelHandler = cancelHandler === VOID ? null : cancelHandler;
  onCancellation = onCancellation === VOID ? null : onCancellation;
  idempotentResume = idempotentResume === VOID ? null : idempotentResume;
  cancelCause = cancelCause === VOID ? null : cancelCause;
  this.o1i_1 = result;
  this.p1i_1 = cancelHandler;
  this.q1i_1 = onCancellation;
  this.r1i_1 = idempotentResume;
  this.s1i_1 = cancelCause;
}
protoOf(CompletedContinuation).u1i = function () {
  return !(this.s1i_1 == null);
};
protoOf(CompletedContinuation).c1j = function (cont, cause) {
  var tmp0_safe_receiver = this.p1i_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    cont.t1i(tmp0_safe_receiver, cause);
  }
  var tmp1_safe_receiver = this.q1i_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    cont.f1j(tmp1_safe_receiver, cause, this.o1i_1);
  }
};
protoOf(CompletedContinuation).y1j = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
  return new CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
};
protoOf(CompletedContinuation).v1i = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $super) {
  result = result === VOID ? this.o1i_1 : result;
  cancelHandler = cancelHandler === VOID ? this.p1i_1 : cancelHandler;
  onCancellation = onCancellation === VOID ? this.q1i_1 : onCancellation;
  idempotentResume = idempotentResume === VOID ? this.r1i_1 : idempotentResume;
  cancelCause = cancelCause === VOID ? this.s1i_1 : cancelCause;
  return $super === VOID ? this.y1j(result, cancelHandler, onCancellation, idempotentResume, cancelCause) : $super.y1j.call(this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
};
protoOf(CompletedContinuation).toString = function () {
  return 'CompletedContinuation(result=' + toString_0(this.o1i_1) + ', cancelHandler=' + toString_0(this.p1i_1) + ', onCancellation=' + toString_0(this.q1i_1) + ', idempotentResume=' + toString_0(this.r1i_1) + ', cancelCause=' + toString_0(this.s1i_1) + ')';
};
protoOf(CompletedContinuation).hashCode = function () {
  var result = this.o1i_1 == null ? 0 : hashCode(this.o1i_1);
  result = imul(result, 31) + (this.p1i_1 == null ? 0 : hashCode(this.p1i_1)) | 0;
  result = imul(result, 31) + (this.q1i_1 == null ? 0 : hashCode(this.q1i_1)) | 0;
  result = imul(result, 31) + (this.r1i_1 == null ? 0 : hashCode(this.r1i_1)) | 0;
  result = imul(result, 31) + (this.s1i_1 == null ? 0 : hashCode(this.s1i_1)) | 0;
  return result;
};
protoOf(CompletedContinuation).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CompletedContinuation))
    return false;
  var tmp0_other_with_cast = other instanceof CompletedContinuation ? other : THROW_CCE();
  if (!equals(this.o1i_1, tmp0_other_with_cast.o1i_1))
    return false;
  if (!equals(this.p1i_1, tmp0_other_with_cast.p1i_1))
    return false;
  if (!equals(this.q1i_1, tmp0_other_with_cast.q1i_1))
    return false;
  if (!equals(this.r1i_1, tmp0_other_with_cast.r1i_1))
    return false;
  if (!equals(this.s1i_1, tmp0_other_with_cast.s1i_1))
    return false;
  return true;
};
function ChildContinuation(child) {
  JobNode.call(this);
  this.d1k_1 = child;
}
protoOf(ChildContinuation).e1k = function () {
  return true;
};
protoOf(ChildContinuation).w1h = function (cause) {
  this.d1k_1.e1j(this.d1k_1.g1j(this.j1k()));
};
var properties_initialized_CancellableContinuationImpl_kt_xtzb03;
function _init_properties_CancellableContinuationImpl_kt__6rrtdd() {
  if (!properties_initialized_CancellableContinuationImpl_kt_xtzb03) {
    properties_initialized_CancellableContinuationImpl_kt_xtzb03 = true;
    RESUME_TOKEN = new Symbol('RESUME_TOKEN');
  }
}
function CompletableDeferred(parent) {
  parent = parent === VOID ? null : parent;
  return new CompletableDeferredImpl(parent);
}
function $awaitCOROUTINE$3(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.z1k_1 = _this__u8e3s4;
}
protoOf($awaitCOROUTINE$3).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.z1k_1.i1g(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return (suspendResult == null ? true : !(suspendResult == null)) ? suspendResult : THROW_CCE();
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function CompletableDeferredImpl(parent) {
  JobSupport.call(this, true);
  this.d1e(parent);
}
protoOf(CompletableDeferredImpl).q1f = function () {
  return true;
};
protoOf(CompletableDeferredImpl).d1h = function () {
  var tmp = this.h1g();
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(CompletableDeferredImpl).e1h = function ($completion) {
  var tmp = new $awaitCOROUTINE$3(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(CompletableDeferredImpl).c1l = function (value) {
  return this.z1f(value);
};
protoOf(CompletableDeferredImpl).d1l = function (exception) {
  return this.z1f(new CompletedExceptionally(exception));
};
function CompletableJob() {
}
function CompletedExceptionally(cause, handled) {
  handled = handled === VOID ? false : handled;
  this.n1e_1 = cause;
  this.o1e_1 = atomic$boolean$1(handled);
}
protoOf(CompletedExceptionally).p1e = function () {
  return this.o1e_1.kotlinx$atomicfu$value;
};
protoOf(CompletedExceptionally).w1i = function () {
  return this.o1e_1.atomicfu$compareAndSet(false, true);
};
protoOf(CompletedExceptionally).toString = function () {
  return get_classSimpleName(this) + '[' + this.n1e_1.toString() + ']';
};
function CancelledContinuation(continuation, cause, handled) {
  CompletedExceptionally.call(this, cause == null ? CancellationException_init_$Create$('Continuation ' + toString(continuation) + ' was cancelled normally') : cause, handled);
  this.r1j_1 = atomic$boolean$1(false);
}
protoOf(CancelledContinuation).s1j = function () {
  return this.r1j_1.atomicfu$compareAndSet(false, true);
};
function toState(_this__u8e3s4, caller) {
  // Inline function 'kotlin.getOrElse' call
  var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
  var tmp;
  if (exception == null) {
    var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    tmp = new CompletedExceptionally(recoverStackTrace(exception, caller));
  }
  return tmp;
}
function toState_0(_this__u8e3s4) {
  // Inline function 'kotlin.getOrElse' call
  var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
  var tmp;
  if (exception == null) {
    var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    tmp = new CompletedExceptionally(exception);
  }
  return tmp;
}
function recoverResult(state, uCont) {
  var tmp;
  if (state instanceof CompletedExceptionally) {
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace(state.n1e_1, uCont);
    tmp = _Result___init__impl__xyqfz8(createFailure(exception));
  } else {
    // Inline function 'kotlin.Companion.success' call
    var value = (state == null ? true : !(state == null)) ? state : THROW_CCE();
    tmp = _Result___init__impl__xyqfz8(value);
  }
  return tmp;
}
function CoroutineDispatcher$Key$_init_$lambda_akl8b5(it) {
  return it instanceof CoroutineDispatcher ? it : null;
}
function Key() {
  Key_instance_0 = this;
  var tmp = Key_instance;
  AbstractCoroutineContextKey.call(this, tmp, CoroutineDispatcher$Key$_init_$lambda_akl8b5);
}
var Key_instance_0;
function Key_getInstance() {
  if (Key_instance_0 == null)
    new Key();
  return Key_instance_0;
}
function CoroutineDispatcher() {
  Key_getInstance();
  AbstractCoroutineContextElement.call(this, Key_instance);
}
protoOf(CoroutineDispatcher).g1l = function (context) {
  return true;
};
protoOf(CoroutineDispatcher).b9 = function (continuation) {
  return new DispatchedContinuation(this, continuation);
};
protoOf(CoroutineDispatcher).c9 = function (continuation) {
  var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
  dispatched.i1l();
};
protoOf(CoroutineDispatcher).toString = function () {
  return get_classSimpleName(this) + '@' + get_hexAddress(this);
};
function handleCoroutineException(context, exception) {
  var tmp;
  if (exception instanceof DispatchException) {
    tmp = exception.j1l_1;
  } else {
    tmp = exception;
  }
  var reportException = tmp;
  try {
    var tmp0_safe_receiver = context.a9(Key_instance_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.k1l(context, reportException);
      return Unit_instance;
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      handleUncaughtCoroutineException(context, handlerException(reportException, t));
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  handleUncaughtCoroutineException(context, reportException);
}
function Key_0() {
}
var Key_instance_1;
function Key_getInstance_0() {
  return Key_instance_1;
}
function handlerException(originalException, thrownException) {
  if (originalException === thrownException)
    return originalException;
  // Inline function 'kotlin.apply' call
  var this_0 = RuntimeException_init_$Create$('Exception while trying to handle coroutine exception', thrownException);
  addSuppressed(this_0, originalException);
  return this_0;
}
function Key_1() {
}
var Key_instance_2;
function Key_getInstance_1() {
  return Key_instance_2;
}
function CoroutineName(name) {
  AbstractCoroutineContextElement.call(this, Key_instance_2);
  this.m1l_1 = name;
}
protoOf(CoroutineName).toString = function () {
  return 'CoroutineName(' + this.m1l_1 + ')';
};
protoOf(CoroutineName).hashCode = function () {
  return getStringHashCode(this.m1l_1);
};
protoOf(CoroutineName).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CoroutineName))
    return false;
  var tmp0_other_with_cast = other instanceof CoroutineName ? other : THROW_CCE();
  if (!(this.m1l_1 === tmp0_other_with_cast.m1l_1))
    return false;
  return true;
};
function CoroutineScope() {
}
function GlobalScope() {
}
protoOf(GlobalScope).h1e = function () {
  return EmptyCoroutineContext_getInstance();
};
var GlobalScope_instance;
function GlobalScope_getInstance() {
  return GlobalScope_instance;
}
function CoroutineScope_0(context) {
  return new ContextScope(!(context.a9(Key_instance_3) == null) ? context : context.jg(Job_0()));
}
function cancel(_this__u8e3s4, message, cause) {
  cause = cause === VOID ? null : cause;
  return cancel_0(_this__u8e3s4, CancellationException_0(message, cause));
}
function cancel_0(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp0_elvis_lhs = _this__u8e3s4.h1e().a9(Key_instance_3);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'Scope cannot be cancelled because it does not have a job: ' + toString(_this__u8e3s4);
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var job = tmp;
  job.r1f(cause);
}
function coroutineScope(block, $completion) {
  var coroutine = new ScopeCoroutine($completion.t8(), $completion);
  return startUndispatchedOrReturn(coroutine, coroutine, block);
}
function get_isActive(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.h1e().a9(Key_instance_3);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i1e();
  return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
}
var CoroutineStart_DEFAULT_instance;
var CoroutineStart_LAZY_instance;
var CoroutineStart_ATOMIC_instance;
var CoroutineStart_UNDISPATCHED_instance;
var CoroutineStart_entriesInitialized;
function CoroutineStart_initEntries() {
  if (CoroutineStart_entriesInitialized)
    return Unit_instance;
  CoroutineStart_entriesInitialized = true;
  CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
  CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
  CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
  CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
}
function CoroutineStart(name, ordinal) {
  Enum.call(this, name, ordinal);
}
protoOf(CoroutineStart).y1e = function (block, receiver, completion) {
  var tmp;
  switch (this.l2_1) {
    case 0:
      startCoroutineCancellable(block, receiver, completion);
      tmp = Unit_instance;
      break;
    case 2:
      startCoroutine(block, receiver, completion);
      tmp = Unit_instance;
      break;
    case 3:
      startCoroutineUndispatched(block, receiver, completion);
      tmp = Unit_instance;
      break;
    case 1:
      tmp = Unit_instance;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(CoroutineStart).j1g = function () {
  return this === CoroutineStart_LAZY_getInstance();
};
function CoroutineStart_DEFAULT_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_DEFAULT_instance;
}
function CoroutineStart_LAZY_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_LAZY_instance;
}
function CoroutineStart_UNDISPATCHED_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_UNDISPATCHED_instance;
}
function CopyableThrowable() {
}
function Delay() {
}
function get_delay(_this__u8e3s4) {
  var tmp = _this__u8e3s4.a9(Key_instance);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
}
function delay(timeMillis, $completion) {
  if (timeMillis.b1(new Long(0, 0)) <= 0)
    return Unit_instance;
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.z1i();
  if (timeMillis.b1(new Long(-1, 2147483647)) < 0) {
    get_delay(cancellable.t8()).o1l(timeMillis, cancellable);
  }
  return cancellable.h1j();
}
function DelayWithTimeoutDiagnostics() {
}
function delta($this, unconfined) {
  return unconfined ? new Long(0, 1) : new Long(1, 0);
}
function EventLoop() {
  CoroutineDispatcher.call(this);
  this.s1l_1 = new Long(0, 0);
  this.t1l_1 = false;
  this.u1l_1 = null;
}
protoOf(EventLoop).v1l = function () {
  var tmp0_elvis_lhs = this.u1l_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var queue = tmp;
  var tmp1_elvis_lhs = queue.qe();
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var task = tmp_0;
  task.v1j();
  return true;
};
protoOf(EventLoop).w1l = function (task) {
  var tmp0_elvis_lhs = this.u1l_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = ArrayDeque_init_$Create$();
    this.u1l_1 = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var queue = tmp;
  queue.oe(task);
};
protoOf(EventLoop).x1l = function () {
  return this.s1l_1.b1(delta(this, true)) >= 0;
};
protoOf(EventLoop).y1l = function () {
  var tmp0_safe_receiver = this.u1l_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p();
  return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
};
protoOf(EventLoop).z1l = function (unconfined) {
  this.s1l_1 = this.s1l_1.r2(delta(this, unconfined));
  if (!unconfined)
    this.t1l_1 = true;
};
protoOf(EventLoop).a1m = function (unconfined) {
  this.s1l_1 = this.s1l_1.s2(delta(this, unconfined));
  if (this.s1l_1.b1(new Long(0, 0)) > 0)
    return Unit_instance;
  // Inline function 'kotlinx.coroutines.assert' call
  if (this.t1l_1) {
    this.b1m();
  }
};
protoOf(EventLoop).b1m = function () {
};
function ThreadLocalEventLoop() {
  ThreadLocalEventLoop_instance = this;
  this.c1m_1 = commonThreadLocal(new Symbol('ThreadLocalEventLoop'));
}
protoOf(ThreadLocalEventLoop).d1m = function () {
  var tmp0_elvis_lhs = this.c1m_1.n18();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = createEventLoop();
    ThreadLocalEventLoop_getInstance().c1m_1.f1m(this_0);
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
var ThreadLocalEventLoop_instance;
function ThreadLocalEventLoop_getInstance() {
  if (ThreadLocalEventLoop_instance == null)
    new ThreadLocalEventLoop();
  return ThreadLocalEventLoop_instance;
}
function CompletionHandlerException(message, cause) {
  RuntimeException_init_$Init$(message, cause, this);
  captureStack(this, CompletionHandlerException);
}
function CoroutinesInternalError(message, cause) {
  Error_init_$Init$(message, cause, this);
  captureStack(this, CoroutinesInternalError);
}
function Key_2() {
}
var Key_instance_3;
function Key_getInstance_2() {
  return Key_instance_3;
}
function Job() {
}
function ParentJob() {
}
function NonDisposableHandle() {
}
protoOf(NonDisposableHandle).b1f = function () {
  return null;
};
protoOf(NonDisposableHandle).x1h = function () {
};
protoOf(NonDisposableHandle).v1f = function (cause) {
  return false;
};
protoOf(NonDisposableHandle).toString = function () {
  return 'NonDisposableHandle';
};
var NonDisposableHandle_instance;
function NonDisposableHandle_getInstance() {
  return NonDisposableHandle_instance;
}
function ensureActive(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.a9(Key_instance_3);
  if (tmp0_safe_receiver == null)
    null;
  else {
    ensureActive_0(tmp0_safe_receiver);
  }
}
function invokeOnCompletion(_this__u8e3s4, invokeImmediately, handler) {
  invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
  var tmp;
  if (_this__u8e3s4 instanceof JobSupport) {
    tmp = _this__u8e3s4.n1f(invokeImmediately, handler);
  } else {
    var tmp_0 = handler.e1k();
    tmp = _this__u8e3s4.l1f(tmp_0, invokeImmediately, JobNode$invoke$ref(handler));
  }
  return tmp;
}
function ensureActive_0(_this__u8e3s4) {
  if (!_this__u8e3s4.i1e())
    throw _this__u8e3s4.h1f();
}
function cancel_1(_this__u8e3s4, message, cause) {
  cause = cause === VOID ? null : cause;
  return _this__u8e3s4.r1f(CancellationException_0(message, cause));
}
function get_job(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.a9(Key_instance_3);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = "Current context doesn't contain Job in it: " + toString(_this__u8e3s4);
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function cancel_2(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp0_safe_receiver = _this__u8e3s4.a9(Key_instance_3);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.r1f(cause);
  }
}
function Job_0(parent) {
  parent = parent === VOID ? null : parent;
  return new JobImpl(parent);
}
function cancelAndJoin(_this__u8e3s4, $completion) {
  _this__u8e3s4.s1f();
  return _this__u8e3s4.o1f($completion);
}
function disposeOnCompletion(_this__u8e3s4, handle) {
  return invokeOnCompletion(_this__u8e3s4, VOID, new DisposeOnCompletion(handle));
}
function DisposeOnCompletion(handle) {
  JobNode.call(this);
  this.k1m_1 = handle;
}
protoOf(DisposeOnCompletion).e1k = function () {
  return false;
};
protoOf(DisposeOnCompletion).w1h = function (cause) {
  return this.k1m_1.x1h();
};
function JobNode$invoke$ref($boundThis) {
  var l = function (p0) {
    $boundThis.w1h(p0);
    return Unit_instance;
  };
  l.callableName = 'invoke';
  return l;
}
function get_COMPLETING_ALREADY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_ALREADY;
}
var COMPLETING_ALREADY;
function get_COMPLETING_WAITING_CHILDREN() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_WAITING_CHILDREN;
}
var COMPLETING_WAITING_CHILDREN;
function get_COMPLETING_RETRY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_RETRY;
}
var COMPLETING_RETRY;
function get_TOO_LATE_TO_CANCEL() {
  _init_properties_JobSupport_kt__68f172();
  return TOO_LATE_TO_CANCEL;
}
var TOO_LATE_TO_CANCEL;
function get_SEALED() {
  _init_properties_JobSupport_kt__68f172();
  return SEALED;
}
var SEALED;
function get_EMPTY_NEW() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_NEW;
}
var EMPTY_NEW;
function get_EMPTY_ACTIVE() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_ACTIVE;
}
var EMPTY_ACTIVE;
function Empty(isActive) {
  this.l1m_1 = isActive;
}
protoOf(Empty).i1e = function () {
  return this.l1m_1;
};
protoOf(Empty).k1k = function () {
  return null;
};
protoOf(Empty).toString = function () {
  return 'Empty{' + (this.l1m_1 ? 'Active' : 'New') + '}';
};
function Incomplete() {
}
function NodeList() {
  LockFreeLinkedListHead.call(this);
}
protoOf(NodeList).i1e = function () {
  return true;
};
protoOf(NodeList).k1k = function () {
  return this;
};
protoOf(NodeList).p1m = function (state) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.b8('List{');
  this_0.b8(state);
  this_0.b8('}[');
  var first = true;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = this.l1k_1;
  while (!equals(cur, this)) {
    var node = cur;
    if (node instanceof JobNode) {
      if (first) {
        first = false;
      } else
        this_0.b8(', ');
      this_0.a8(node);
    }
    cur = cur.l1k_1;
  }
  this_0.b8(']');
  return this_0.toString();
};
protoOf(NodeList).toString = function () {
  return get_DEBUG() ? this.p1m('Active') : protoOf(LockFreeLinkedListHead).toString.call(this);
};
function JobNode() {
  LockFreeLinkedListNode.call(this);
}
protoOf(JobNode).j1k = function () {
  var tmp = this.i1k_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('job');
  }
};
protoOf(JobNode).i1e = function () {
  return true;
};
protoOf(JobNode).k1k = function () {
  return null;
};
protoOf(JobNode).x1h = function () {
  return this.j1k().p1f(this);
};
protoOf(JobNode).toString = function () {
  return get_classSimpleName(this) + '@' + get_hexAddress(this) + '[job@' + get_hexAddress(this.j1k()) + ']';
};
function _set_exceptionsHolder__tqm22h($this, value) {
  $this.u1m_1.kotlinx$atomicfu$value = value;
}
function _get_exceptionsHolder__nhszp($this) {
  return $this.u1m_1.kotlinx$atomicfu$value;
}
function allocateList($this) {
  return ArrayList_init_$Create$(4);
}
function finalizeFinishingState($this, state, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
  var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1e_1;
  var wasCancelling;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  wasCancelling = state.v1m();
  var exceptions = state.w1m(proposedException);
  var finalCause = getFinalRootCause($this, state, exceptions);
  if (!(finalCause == null)) {
    addSuppressedExceptions($this, finalCause, exceptions);
  }
  var finalException = finalCause;
  var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new CompletedExceptionally(finalException);
  if (!(finalException == null)) {
    var handled = cancelParent($this, finalException) || $this.e1g(finalException);
    if (handled) {
      (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).w1i();
    }
  }
  if (!wasCancelling) {
    $this.b1g(finalException);
  }
  $this.m1e(finalState);
  var casSuccess = $this.b1e_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
  // Inline function 'kotlinx.coroutines.assert' call
  completeStateFinalization($this, state, finalState);
  return finalState;
}
function getFinalRootCause($this, state, exceptions) {
  if (exceptions.p()) {
    if (state.v1m()) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      return new JobCancellationException(null == null ? $this.l1e() : null, null, $this);
    }
    return null;
  }
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = exceptions.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(element instanceof CancellationException)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var firstNonCancellation = tmp$ret$2;
  if (!(firstNonCancellation == null))
    return firstNonCancellation;
  var first = exceptions.o(0);
  if (first instanceof TimeoutCancellationException) {
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = exceptions.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        var tmp;
        if (!(element_0 === first)) {
          tmp = element_0 instanceof TimeoutCancellationException;
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$4 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$4 = null;
    }
    var detailedTimeoutException = tmp$ret$4;
    if (!(detailedTimeoutException == null))
      return detailedTimeoutException;
  }
  return first;
}
function addSuppressedExceptions($this, rootCause, exceptions) {
  if (exceptions.m() <= 1)
    return Unit_instance;
  var seenExceptions = identitySet(exceptions.m());
  var unwrappedCause = unwrap(rootCause);
  var _iterator__ex2g4s = exceptions.j();
  while (_iterator__ex2g4s.k()) {
    var exception = _iterator__ex2g4s.l();
    var unwrapped = unwrap(exception);
    var tmp;
    var tmp_0;
    if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) {
      tmp_0 = !(unwrapped instanceof CancellationException);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = seenExceptions.e(unwrapped);
    } else {
      tmp = false;
    }
    if (tmp) {
      addSuppressed(rootCause, unwrapped);
    }
  }
}
function tryFinalizeSimpleState($this, state, update) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  if (!$this.b1e_1.atomicfu$compareAndSet(state, boxIncomplete(update)))
    return false;
  $this.b1g(null);
  $this.m1e(update);
  completeStateFinalization($this, state, update);
  return true;
}
function completeStateFinalization($this, state, update) {
  var tmp0_safe_receiver = $this.a1f();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    tmp0_safe_receiver.x1h();
    $this.z1e(NonDisposableHandle_instance);
  }
  var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
  var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n1e_1;
  if (state instanceof JobNode) {
    try {
      state.w1h(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        $this.t1e(new CompletionHandlerException('Exception in completion handler ' + state.toString() + ' for ' + $this.toString(), ex));
      } else {
        throw $p;
      }
    }
  } else {
    var tmp2_safe_receiver = state.k1k();
    if (tmp2_safe_receiver == null)
      null;
    else {
      notifyCompletion($this, tmp2_safe_receiver, cause);
    }
  }
}
function notifyCancelling($this, list, cause) {
  $this.b1g(cause);
  list.q1m(4);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = list.l1k_1;
  while (!equals(cur, list)) {
    var node = cur;
    var tmp;
    if (node instanceof JobNode) {
      tmp = node.e1k();
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.w1h(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.l1k_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.t1e(tmp0_safe_receiver_0);
  }
  cancelParent($this, cause);
}
function cancelParent($this, cause) {
  if ($this.c1g())
    return true;
  var isCancellation = cause instanceof CancellationException;
  var parent = $this.a1f();
  if (parent === null || parent === NonDisposableHandle_instance) {
    return isCancellation;
  }
  return parent.v1f(cause) || isCancellation;
}
function notifyCompletion($this, _this__u8e3s4, cause) {
  _this__u8e3s4.q1m(1);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = _this__u8e3s4.l1k_1;
  while (!equals(cur, _this__u8e3s4)) {
    var node = cur;
    var tmp;
    if (node instanceof JobNode) {
      tmp = true;
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.w1h(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.l1k_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.t1e(tmp0_safe_receiver_0);
  }
}
function startInternal($this, state) {
  if (state instanceof Empty) {
    if (state.l1m_1)
      return 0;
    if (!$this.b1e_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
      return -1;
    $this.g1f();
    return 1;
  } else {
    if (state instanceof InactiveNodeList) {
      if (!$this.b1e_1.atomicfu$compareAndSet(state, state.x1m_1))
        return -1;
      $this.g1f();
      return 1;
    } else {
      return 0;
    }
  }
}
function promoteEmptyToNodeList($this, state) {
  var list = new NodeList();
  var update = state.l1m_1 ? list : new InactiveNodeList(list);
  $this.b1e_1.atomicfu$compareAndSet(state, update);
}
function promoteSingleToNodeList($this, state) {
  state.q1k(new NodeList());
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
  var list = state.l1k_1;
  $this.b1e_1.atomicfu$compareAndSet(state, list);
}
function joinInternal($this) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = $this.c1f();
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return false;
    if (startInternal($this, state) >= 0)
      return true;
  }
}
function joinSuspend($this, $completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.z1i();
  disposeOnCancellation(cancellable, invokeOnCompletion($this, VOID, new ResumeOnCompletion(cancellable)));
  return cancellable.h1j();
}
function cancelMakeCompleting($this, cause) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = $this.c1f();
    var tmp;
    if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing) {
        tmp_0 = state.y1m();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      return get_COMPLETING_ALREADY();
    }
    var proposedUpdate = new CompletedExceptionally(createCauseException($this, cause));
    var finalState = tryMakeCompleting($this, state, proposedUpdate);
    if (!(finalState === get_COMPLETING_RETRY()))
      return finalState;
  }
}
function createCauseException($this, cause) {
  var tmp;
  if (cause == null ? true : cause instanceof Error) {
    var tmp_0;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp_0 = new JobCancellationException(null == null ? $this.l1e() : null, null, $this);
    } else {
      tmp_0 = cause;
    }
    tmp = tmp_0;
  } else {
    tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).y1f();
  }
  return tmp;
}
function makeCancelling($this, cause) {
  var causeExceptionCache = null;
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp1 = $this.c1f();
    $l$block: {
      if (tmp1 instanceof Finishing) {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        if (tmp1.z1m())
          return get_TOO_LATE_TO_CANCEL();
        var wasCancelling = tmp1.v1m();
        if (!(cause == null) || !wasCancelling) {
          var tmp0_elvis_lhs = causeExceptionCache;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = createCauseException($this, cause);
            causeExceptionCache = this_0;
            tmp = this_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var causeException = tmp;
          tmp1.a1n(causeException);
        }
        // Inline function 'kotlin.takeIf' call
        var this_1 = tmp1.b1n();
        var tmp_0;
        if (!wasCancelling) {
          tmp_0 = this_1;
        } else {
          tmp_0 = null;
        }
        var notifyRootCause = tmp_0;
        if (notifyRootCause == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          notifyCancelling($this, tmp1.r1m_1, notifyRootCause);
        }
        return get_COMPLETING_ALREADY();
      } else {
        if (!(tmp1 == null) ? isInterface(tmp1, Incomplete) : false) {
          var tmp2_elvis_lhs = causeExceptionCache;
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_2 = createCauseException($this, cause);
            causeExceptionCache = this_2;
            tmp_1 = this_2;
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var causeException_0 = tmp_1;
          if (tmp1.i1e()) {
            if (tryMakeCancelling($this, tmp1, causeException_0))
              return get_COMPLETING_ALREADY();
          } else {
            var finalState = tryMakeCompleting($this, tmp1, new CompletedExceptionally(causeException_0));
            if (finalState === get_COMPLETING_ALREADY()) {
              // Inline function 'kotlin.error' call
              var message = 'Cannot happen in ' + toString(tmp1);
              throw IllegalStateException_init_$Create$(toString(message));
            } else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else
              return finalState;
          }
        } else {
          return get_TOO_LATE_TO_CANCEL();
        }
      }
    }
  }
}
function getOrPromoteCancellingList($this, state) {
  var tmp0_elvis_lhs = state.k1k();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (state instanceof Empty) {
      tmp_0 = new NodeList();
    } else {
      if (state instanceof JobNode) {
        promoteSingleToNodeList($this, state);
        tmp_0 = null;
      } else {
        var message = 'State should have list: ' + toString(state);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function tryMakeCancelling($this, state, rootCause) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var cancelling = new Finishing(list, false, rootCause);
  if (!$this.b1e_1.atomicfu$compareAndSet(state, cancelling))
    return false;
  notifyCancelling($this, list, rootCause);
  return true;
}
function tryMakeCompleting($this, state, proposedUpdate) {
  if (!(!(state == null) ? isInterface(state, Incomplete) : false))
    return get_COMPLETING_ALREADY();
  var tmp;
  var tmp_0;
  var tmp_1;
  if (state instanceof Empty) {
    tmp_1 = true;
  } else {
    tmp_1 = state instanceof JobNode;
  }
  if (tmp_1) {
    tmp_0 = !(state instanceof ChildHandleNode);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = !(proposedUpdate instanceof CompletedExceptionally);
  } else {
    tmp = false;
  }
  if (tmp) {
    if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
      return proposedUpdate;
    }
    return get_COMPLETING_RETRY();
  }
  return tryMakeCompletingSlowPath($this, state, proposedUpdate);
}
function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return get_COMPLETING_RETRY();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
  var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
  var notifyRootCause;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  if (finishing.y1m())
    return get_COMPLETING_ALREADY();
  finishing.c1n(true);
  if (!(finishing === state)) {
    if (!$this.b1e_1.atomicfu$compareAndSet(state, finishing))
      return get_COMPLETING_RETRY();
  }
  // Inline function 'kotlinx.coroutines.assert' call
  var wasCancelling = finishing.v1m();
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    finishing.a1n(tmp0_safe_receiver.n1e_1);
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = finishing.b1n();
  var tmp_0;
  if (!wasCancelling) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  notifyRootCause = tmp_0;
  if (notifyRootCause == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    notifyCancelling($this, list, notifyRootCause);
  }
  var child = nextChild($this, list);
  if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  list.q1m(2);
  var anotherChild = nextChild($this, list);
  if (!(anotherChild == null) && tryWaitForChild($this, finishing, anotherChild, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  return finalizeFinishingState($this, finishing, proposedUpdate);
}
function _get_exceptionOrNull__b3j7js($this, _this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4 instanceof CompletedExceptionally ? _this__u8e3s4 : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1e_1;
}
function tryWaitForChild($this, state, child, proposedUpdate) {
  var $this_0 = $this;
  var state_0 = state;
  var child_0 = child;
  var proposedUpdate_0 = proposedUpdate;
  $l$1: do {
    $l$0: do {
      var handle = invokeOnCompletion(child_0.h1n_1, false, new ChildCompletion($this_0, state_0, child_0, proposedUpdate_0));
      if (!(handle === NonDisposableHandle_instance))
        return true;
      var tmp0_elvis_lhs = nextChild($this_0, child_0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      var tmp0 = $this_0;
      var tmp1 = state_0;
      var tmp3 = proposedUpdate_0;
      $this_0 = tmp0;
      state_0 = tmp1;
      child_0 = nextChild_0;
      proposedUpdate_0 = tmp3;
      continue $l$0;
    }
     while (false);
  }
   while (true);
}
function continueCompleting($this, state, lastChild, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  var waitChild = nextChild($this, lastChild);
  if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate))
    return Unit_instance;
  state.r1m_1.q1m(2);
  var waitChildAgain = nextChild($this, lastChild);
  if (!(waitChildAgain == null) && tryWaitForChild($this, state, waitChildAgain, proposedUpdate)) {
    return Unit_instance;
  }
  var finalState = finalizeFinishingState($this, state, proposedUpdate);
  $this.s1e(finalState);
}
function nextChild($this, _this__u8e3s4) {
  var cur = _this__u8e3s4;
  $l$loop: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (!cur.n1k_1) {
      break $l$loop;
    }
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.prevNode' call
    cur = cur.m1k_1;
  }
  $l$loop_0: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
    cur = cur.l1k_1;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (cur.n1k_1)
      continue $l$loop_0;
    if (cur instanceof ChildHandleNode)
      return cur;
    if (cur instanceof NodeList)
      return null;
  }
}
function stateString($this, state) {
  var tmp;
  if (state instanceof Finishing) {
    tmp = state.v1m() ? 'Cancelling' : state.y1m() ? 'Completing' : 'Active';
  } else {
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state.i1e() ? 'Active' : 'New';
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = 'Cancelled';
      } else {
        tmp = 'Completed';
      }
    }
  }
  return tmp;
}
function Finishing(list, isCompleting, rootCause) {
  SynchronizedObject.call(this);
  this.r1m_1 = list;
  this.s1m_1 = atomic$boolean$1(isCompleting);
  this.t1m_1 = atomic$ref$1(rootCause);
  this.u1m_1 = atomic$ref$1(null);
}
protoOf(Finishing).k1k = function () {
  return this.r1m_1;
};
protoOf(Finishing).c1n = function (value) {
  this.s1m_1.kotlinx$atomicfu$value = value;
};
protoOf(Finishing).y1m = function () {
  return this.s1m_1.kotlinx$atomicfu$value;
};
protoOf(Finishing).i1n = function (value) {
  this.t1m_1.kotlinx$atomicfu$value = value;
};
protoOf(Finishing).b1n = function () {
  return this.t1m_1.kotlinx$atomicfu$value;
};
protoOf(Finishing).z1m = function () {
  return _get_exceptionsHolder__nhszp(this) === get_SEALED();
};
protoOf(Finishing).v1m = function () {
  return !(this.b1n() == null);
};
protoOf(Finishing).i1e = function () {
  return this.b1n() == null;
};
protoOf(Finishing).w1m = function (proposedException) {
  var eh = _get_exceptionsHolder__nhszp(this);
  var tmp;
  if (eh == null) {
    tmp = allocateList(this);
  } else {
    if (eh instanceof Error) {
      // Inline function 'kotlin.also' call
      var this_0 = allocateList(this);
      this_0.e(eh);
      tmp = this_0;
    } else {
      if (eh instanceof ArrayList) {
        tmp = eh instanceof ArrayList ? eh : THROW_CCE();
      } else {
        var message = 'State is ' + toString_0(eh);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  var list = tmp;
  var rootCause = this.b1n();
  if (rootCause == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    list.f2(0, rootCause);
  }
  if (!(proposedException == null) && !equals(proposedException, rootCause)) {
    list.e(proposedException);
  }
  _set_exceptionsHolder__tqm22h(this, get_SEALED());
  return list;
};
protoOf(Finishing).a1n = function (exception) {
  var rootCause = this.b1n();
  if (rootCause == null) {
    this.i1n(exception);
    return Unit_instance;
  }
  if (exception === rootCause)
    return Unit_instance;
  var eh = _get_exceptionsHolder__nhszp(this);
  if (eh == null) {
    _set_exceptionsHolder__tqm22h(this, exception);
  } else {
    if (eh instanceof Error) {
      if (exception === eh)
        return Unit_instance;
      // Inline function 'kotlin.apply' call
      var this_0 = allocateList(this);
      this_0.e(eh);
      this_0.e(exception);
      _set_exceptionsHolder__tqm22h(this, this_0);
    } else {
      if (eh instanceof ArrayList) {
        (eh instanceof ArrayList ? eh : THROW_CCE()).e(exception);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'State is ' + toString_0(eh);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
};
protoOf(Finishing).toString = function () {
  return 'Finishing[cancelling=' + this.v1m() + ', completing=' + this.y1m() + ', rootCause=' + toString_0(this.b1n()) + ', exceptions=' + toString_0(_get_exceptionsHolder__nhszp(this)) + ', list=' + this.r1m_1.toString() + ']';
};
function ChildCompletion(parent, state, child, proposedUpdate) {
  JobNode.call(this);
  this.n1n_1 = parent;
  this.o1n_1 = state;
  this.p1n_1 = child;
  this.q1n_1 = proposedUpdate;
}
protoOf(ChildCompletion).e1k = function () {
  return false;
};
protoOf(ChildCompletion).w1h = function (cause) {
  continueCompleting(this.n1n_1, this.o1n_1, this.p1n_1, this.q1n_1);
};
function AwaitContinuation(delegate, job) {
  CancellableContinuationImpl.call(this, delegate, 1);
  this.x1n_1 = job;
}
protoOf(AwaitContinuation).g1j = function (parent) {
  var state = this.x1n_1.c1f();
  if (state instanceof Finishing) {
    var tmp0_safe_receiver = state.b1n();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
  }
  if (state instanceof CompletedExceptionally)
    return state.n1e_1;
  return parent.h1f();
};
protoOf(AwaitContinuation).u1j = function () {
  return 'AwaitContinuation';
};
function awaitSuspend($this, $completion) {
  var cont = new AwaitContinuation(intercepted($completion), $this);
  cont.z1i();
  disposeOnCancellation(cont, invokeOnCompletion($this, VOID, new ResumeAwaitOnCompletion(cont)));
  return cont.h1j();
}
function JobSupport(active) {
  this.b1e_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
  this.c1e_1 = atomic$ref$1(null);
}
protoOf(JobSupport).s = function () {
  return Key_instance_3;
};
protoOf(JobSupport).z1e = function (value) {
  this.c1e_1.kotlinx$atomicfu$value = value;
};
protoOf(JobSupport).a1f = function () {
  return this.c1e_1.kotlinx$atomicfu$value;
};
protoOf(JobSupport).b1f = function () {
  var tmp0_safe_receiver = this.a1f();
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b1f();
};
protoOf(JobSupport).d1e = function (parent) {
  // Inline function 'kotlinx.coroutines.assert' call
  if (parent == null) {
    this.z1e(NonDisposableHandle_instance);
    return Unit_instance;
  }
  parent.f1f();
  var handle = parent.a1g(this);
  this.z1e(handle);
  if (this.d1f()) {
    handle.x1h();
    this.z1e(NonDisposableHandle_instance);
  }
};
protoOf(JobSupport).c1f = function () {
  return this.b1e_1.kotlinx$atomicfu$value;
};
protoOf(JobSupport).i1e = function () {
  var state = this.c1f();
  var tmp;
  if (!(state == null) ? isInterface(state, Incomplete) : false) {
    tmp = state.i1e();
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(JobSupport).d1f = function () {
  var tmp = this.c1f();
  return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
};
protoOf(JobSupport).e1f = function () {
  var state = this.c1f();
  var tmp;
  if (state instanceof CompletedExceptionally) {
    tmp = true;
  } else {
    var tmp_0;
    if (state instanceof Finishing) {
      tmp_0 = state.v1m();
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(JobSupport).f1f = function () {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = this.c1f();
    var tmp0_subject = startInternal(this, state);
    if (tmp0_subject === 0)
      return false;
    else if (tmp0_subject === 1)
      return true;
  }
};
protoOf(JobSupport).g1f = function () {
};
protoOf(JobSupport).h1f = function () {
  var state = this.c1f();
  var tmp;
  if (state instanceof Finishing) {
    var tmp0_safe_receiver = state.b1n();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.i1f(tmp0_safe_receiver, get_classSimpleName(this) + ' is cancelling');
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var message = 'Job is still new or active: ' + this.toString();
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    tmp = tmp_0;
  } else {
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      var message_0 = 'Job is still new or active: ' + this.toString();
      throw IllegalStateException_init_$Create$(toString(message_0));
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = this.j1f(state.n1e_1);
      } else {
        tmp = new JobCancellationException(get_classSimpleName(this) + ' has completed normally', null, this);
      }
    }
  }
  return tmp;
};
protoOf(JobSupport).i1f = function (_this__u8e3s4, message) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
    tmp = new JobCancellationException(message == null ? this.l1e() : message, _this__u8e3s4, this);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(JobSupport).j1f = function (_this__u8e3s4, message, $super) {
  message = message === VOID ? null : message;
  return $super === VOID ? this.i1f(_this__u8e3s4, message) : $super.i1f.call(this, _this__u8e3s4, message);
};
protoOf(JobSupport).k1f = function (handler) {
  return this.n1f(true, new InvokeOnCompletion(handler));
};
protoOf(JobSupport).l1f = function (onCancelling, invokeImmediately, handler) {
  var tmp;
  if (onCancelling) {
    tmp = new InvokeOnCancelling(handler);
  } else {
    tmp = new InvokeOnCompletion(handler);
  }
  return this.n1f(invokeImmediately, tmp);
};
protoOf(JobSupport).n1f = function (invokeImmediately, node) {
  node.i1k_1 = this;
  var tmp$ret$0;
  $l$block_1: {
    // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = this.c1f();
      if (state instanceof Empty) {
        if (state.l1m_1) {
          if (this.b1e_1.atomicfu$compareAndSet(state, node)) {
            tmp$ret$0 = true;
            break $l$block_1;
          }
        } else {
          promoteEmptyToNodeList(this, state);
        }
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          var list = state.k1k();
          if (list == null) {
            promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
          } else {
            var tmp;
            if (node.e1k()) {
              var tmp0_safe_receiver = state instanceof Finishing ? state : null;
              var rootCause = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b1n();
              var tmp_0;
              if (rootCause == null) {
                tmp_0 = list.o1k(node, 5);
              } else {
                if (invokeImmediately) {
                  node.w1h(rootCause);
                }
                return NonDisposableHandle_instance;
              }
              tmp = tmp_0;
            } else {
              tmp = list.o1k(node, 1);
            }
            if (tmp) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
          }
        } else {
          tmp$ret$0 = false;
          break $l$block_1;
        }
      }
    }
  }
  var added = tmp$ret$0;
  if (added)
    return node;
  else if (invokeImmediately) {
    var tmp_1 = this.c1f();
    var tmp0_safe_receiver_0 = tmp_1 instanceof CompletedExceptionally ? tmp_1 : null;
    node.w1h(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.n1e_1);
  }
  return NonDisposableHandle_instance;
};
protoOf(JobSupport).o1f = function ($completion) {
  if (!joinInternal(this)) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.t8();
    ensureActive(tmp$ret$0);
    return Unit_instance;
  }
  return joinSuspend(this, $completion);
};
protoOf(JobSupport).p1f = function (node) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = this.c1f();
    if (state instanceof JobNode) {
      if (!(state === node))
        return Unit_instance;
      if (this.b1e_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
        return Unit_instance;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        if (!(state.k1k() == null)) {
          node.p1k();
        }
        return Unit_instance;
      } else {
        return Unit_instance;
      }
    }
  }
};
protoOf(JobSupport).q1f = function () {
  return false;
};
protoOf(JobSupport).r1f = function (cause) {
  var tmp;
  if (cause == null) {
    // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
    tmp = new JobCancellationException(null == null ? this.l1e() : null, null, this);
  } else {
    tmp = cause;
  }
  this.t1f(tmp);
};
protoOf(JobSupport).l1e = function () {
  return 'Job was cancelled';
};
protoOf(JobSupport).t1f = function (cause) {
  this.x1f(cause);
};
protoOf(JobSupport).u1f = function (parentJob) {
  this.x1f(parentJob);
};
protoOf(JobSupport).v1f = function (cause) {
  if (cause instanceof CancellationException)
    return true;
  return this.x1f(cause) && this.d1g();
};
protoOf(JobSupport).w1f = function (cause) {
  return this.x1f(cause);
};
protoOf(JobSupport).x1f = function (cause) {
  var finalState = get_COMPLETING_ALREADY();
  if (this.q1f()) {
    finalState = cancelMakeCompleting(this, cause);
    if (finalState === get_COMPLETING_WAITING_CHILDREN())
      return true;
  }
  if (finalState === get_COMPLETING_ALREADY()) {
    finalState = makeCancelling(this, cause);
  }
  var tmp;
  if (finalState === get_COMPLETING_ALREADY()) {
    tmp = true;
  } else if (finalState === get_COMPLETING_WAITING_CHILDREN()) {
    tmp = true;
  } else if (finalState === get_TOO_LATE_TO_CANCEL()) {
    tmp = false;
  } else {
    this.s1e(finalState);
    tmp = true;
  }
  return tmp;
};
protoOf(JobSupport).y1f = function () {
  var state = this.c1f();
  var tmp;
  if (state instanceof Finishing) {
    tmp = state.b1n();
  } else {
    if (state instanceof CompletedExceptionally) {
      tmp = state.n1e_1;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var message = 'Cannot be cancelling child in this state: ' + toString(state);
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp = null;
      }
    }
  }
  var rootCause = tmp;
  var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
  return tmp1_elvis_lhs == null ? new JobCancellationException('Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
};
protoOf(JobSupport).z1f = function (proposedUpdate) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp1 = this.c1f();
    $l$block: {
      var finalState = tryMakeCompleting(this, tmp1, proposedUpdate);
      if (finalState === get_COMPLETING_ALREADY())
        return false;
      else if (finalState === get_COMPLETING_WAITING_CHILDREN())
        return true;
      else if (finalState === get_COMPLETING_RETRY()) {
        break $l$block;
      } else {
        this.s1e(finalState);
        return true;
      }
    }
  }
};
protoOf(JobSupport).q1e = function (proposedUpdate) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp1 = this.c1f();
    $l$block: {
      var finalState = tryMakeCompleting(this, tmp1, proposedUpdate);
      if (finalState === get_COMPLETING_ALREADY())
        throw IllegalStateException_init_$Create$_0('Job ' + this.toString() + ' is already complete or completing, ' + ('but is being completed with ' + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(this, proposedUpdate));
      else if (finalState === get_COMPLETING_RETRY()) {
        break $l$block;
      } else
        return finalState;
    }
  }
};
protoOf(JobSupport).a1g = function (child) {
  // Inline function 'kotlin.also' call
  var this_0 = new ChildHandleNode(child);
  this_0.i1k_1 = this;
  var node = this_0;
  var tmp$ret$2;
  $l$block_1: {
    // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = this.c1f();
      if (state instanceof Empty) {
        if (state.l1m_1) {
          if (this.b1e_1.atomicfu$compareAndSet(state, node)) {
            tmp$ret$2 = true;
            break $l$block_1;
          }
        } else {
          promoteEmptyToNodeList(this, state);
        }
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          var list = state.k1k();
          if (list == null) {
            promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
          } else {
            var addedBeforeCancellation = list.o1k(node, 7);
            var tmp;
            if (addedBeforeCancellation) {
              tmp = true;
            } else {
              var addedBeforeCompletion = list.o1k(node, 3);
              var latestState = this.c1f();
              var tmp_0;
              if (latestState instanceof Finishing) {
                tmp_0 = latestState.b1n();
              } else {
                // Inline function 'kotlinx.coroutines.assert' call
                var tmp0_safe_receiver = latestState instanceof CompletedExceptionally ? latestState : null;
                tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1e_1;
              }
              var rootCause = tmp_0;
              node.w1h(rootCause);
              var tmp_1;
              if (addedBeforeCompletion) {
                // Inline function 'kotlinx.coroutines.assert' call
                tmp_1 = true;
              } else {
                return NonDisposableHandle_instance;
              }
              tmp = tmp_1;
            }
            if (tmp) {
              tmp$ret$2 = true;
              break $l$block_1;
            }
          }
        } else {
          tmp$ret$2 = false;
          break $l$block_1;
        }
      }
    }
  }
  var added = tmp$ret$2;
  if (added)
    return node;
  var tmp_2 = this.c1f();
  var tmp0_safe_receiver_0 = tmp_2 instanceof CompletedExceptionally ? tmp_2 : null;
  node.w1h(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.n1e_1);
  return NonDisposableHandle_instance;
};
protoOf(JobSupport).t1e = function (exception) {
  throw exception;
};
protoOf(JobSupport).b1g = function (cause) {
};
protoOf(JobSupport).c1g = function () {
  return false;
};
protoOf(JobSupport).d1g = function () {
  return true;
};
protoOf(JobSupport).e1g = function (exception) {
  return false;
};
protoOf(JobSupport).m1e = function (state) {
};
protoOf(JobSupport).s1e = function (state) {
};
protoOf(JobSupport).toString = function () {
  return this.f1g() + '@' + get_hexAddress(this);
};
protoOf(JobSupport).f1g = function () {
  return this.u1e() + '{' + stateString(this, this.c1f()) + '}';
};
protoOf(JobSupport).u1e = function () {
  return get_classSimpleName(this);
};
protoOf(JobSupport).g1g = function () {
  var state = this.c1f();
  // Inline function 'kotlin.check' call
  if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
    var message = 'This job has not completed yet';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  return _get_exceptionOrNull__b3j7js(this, state);
};
protoOf(JobSupport).h1g = function () {
  var state = this.c1f();
  // Inline function 'kotlin.check' call
  if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
    var message = 'This job has not completed yet';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  if (state instanceof CompletedExceptionally)
    throw state.n1e_1;
  return unboxState(state);
};
protoOf(JobSupport).i1g = function ($completion) {
  $l$loop: while (true) {
    var state = this.c1f();
    if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      if (state instanceof CompletedExceptionally) {
        // Inline function 'kotlinx.coroutines.internal.recoverAndThrow' call
        throw state.n1e_1;
      }
      return unboxState(state);
    }
    if (startInternal(this, state) >= 0)
      break $l$loop;
  }
  return awaitSuspend(this, $completion);
};
function boxIncomplete(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp;
  if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete) : false) {
    tmp = new IncompleteStateBox(_this__u8e3s4);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function InactiveNodeList(list) {
  this.x1m_1 = list;
}
protoOf(InactiveNodeList).k1k = function () {
  return this.x1m_1;
};
protoOf(InactiveNodeList).i1e = function () {
  return false;
};
protoOf(InactiveNodeList).toString = function () {
  return get_DEBUG() ? this.x1m_1.p1m('New') : anyToString(this);
};
function InvokeOnCompletion(handler) {
  JobNode.call(this);
  this.c1o_1 = handler;
}
protoOf(InvokeOnCompletion).e1k = function () {
  return false;
};
protoOf(InvokeOnCompletion).w1h = function (cause) {
  return this.c1o_1(cause);
};
function InvokeOnCancelling(handler) {
  JobNode.call(this);
  this.h1o_1 = handler;
  this.i1o_1 = atomic$boolean$1(false);
}
protoOf(InvokeOnCancelling).e1k = function () {
  return true;
};
protoOf(InvokeOnCancelling).w1h = function (cause) {
  if (this.i1o_1.atomicfu$compareAndSet(false, true))
    this.h1o_1(cause);
};
function ResumeOnCompletion(continuation) {
  JobNode.call(this);
  this.n1o_1 = continuation;
}
protoOf(ResumeOnCompletion).e1k = function () {
  return false;
};
protoOf(ResumeOnCompletion).w1h = function (cause) {
  // Inline function 'kotlin.coroutines.resume' call
  var this_0 = this.n1o_1;
  // Inline function 'kotlin.Companion.success' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
  this_0.y8(tmp$ret$0);
  return Unit_instance;
};
function ChildHandleNode(childJob) {
  JobNode.call(this);
  this.h1n_1 = childJob;
}
protoOf(ChildHandleNode).b1f = function () {
  return this.j1k();
};
protoOf(ChildHandleNode).e1k = function () {
  return true;
};
protoOf(ChildHandleNode).w1h = function (cause) {
  return this.h1n_1.u1f(this.j1k());
};
protoOf(ChildHandleNode).v1f = function (cause) {
  return this.j1k().v1f(cause);
};
function unboxState(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o1o_1;
  return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
}
function ResumeAwaitOnCompletion(continuation) {
  JobNode.call(this);
  this.t1o_1 = continuation;
}
protoOf(ResumeAwaitOnCompletion).e1k = function () {
  return false;
};
protoOf(ResumeAwaitOnCompletion).w1h = function (cause) {
  var state = this.j1k().c1f();
  // Inline function 'kotlinx.coroutines.assert' call
  if (state instanceof CompletedExceptionally) {
    var tmp0 = this.t1o_1;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = state.n1e_1;
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.y8(tmp$ret$1);
  } else {
    var tmp2 = this.t1o_1;
    var tmp = unboxState(state);
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    var tmp$ret$3 = _Result___init__impl__xyqfz8(value);
    tmp2.y8(tmp$ret$3);
  }
};
function IncompleteStateBox(state) {
  this.o1o_1 = state;
}
function handlesExceptionF($this) {
  var tmp = $this.a1f();
  var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j1k();
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var parentJob = tmp_0;
  while (true) {
    if (parentJob.d1g())
      return true;
    var tmp_1 = parentJob.a1f();
    var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.j1k();
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      return false;
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    parentJob = tmp_2;
  }
}
function JobImpl(parent) {
  JobSupport.call(this, true);
  this.d1e(parent);
  this.w1o_1 = handlesExceptionF(this);
}
protoOf(JobImpl).q1f = function () {
  return true;
};
protoOf(JobImpl).d1g = function () {
  return this.w1o_1;
};
protoOf(JobImpl).e1l = function () {
  return this.z1f(Unit_instance);
};
protoOf(JobImpl).d1l = function (exception) {
  return this.z1f(new CompletedExceptionally(exception));
};
var properties_initialized_JobSupport_kt_5iq8a4;
function _init_properties_JobSupport_kt__68f172() {
  if (!properties_initialized_JobSupport_kt_5iq8a4) {
    properties_initialized_JobSupport_kt_5iq8a4 = true;
    COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
    COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
    COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
    TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
    SEALED = new Symbol('SEALED');
    EMPTY_NEW = new Empty(false);
    EMPTY_ACTIVE = new Empty(true);
  }
}
function MainCoroutineDispatcher() {
  CoroutineDispatcher.call(this);
}
protoOf(MainCoroutineDispatcher).toString = function () {
  var tmp0_elvis_lhs = this.z1o();
  return tmp0_elvis_lhs == null ? get_classSimpleName(this) + '@' + get_hexAddress(this) : tmp0_elvis_lhs;
};
protoOf(MainCoroutineDispatcher).z1o = function () {
  var main = Dispatchers_getInstance().e1p();
  if (this === main)
    return 'Dispatchers.Main';
  var tmp;
  try {
    tmp = main.y1o();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof UnsupportedOperationException) {
      var e = $p;
      tmp_0 = null;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  var immediate = tmp;
  if (this === immediate)
    return 'Dispatchers.Main.immediate';
  return null;
};
function SupervisorJob(parent) {
  parent = parent === VOID ? null : parent;
  return new SupervisorJobImpl(parent);
}
function SupervisorJobImpl(parent) {
  JobImpl.call(this, parent);
}
protoOf(SupervisorJobImpl).v1f = function (cause) {
  return false;
};
function TimeoutCancellationException(message, coroutine) {
  CancellationException_init_$Init$(message, this);
  captureStack(this, TimeoutCancellationException);
  this.i1p_1 = coroutine;
}
protoOf(TimeoutCancellationException).n1l = function () {
  var tmp0_elvis_lhs = this.message;
  // Inline function 'kotlin.also' call
  var this_0 = new TimeoutCancellationException(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, this.i1p_1);
  initCause(this_0, this);
  return this_0;
};
function withTimeoutOrNull(timeMillis, block, $completion) {
  var tmp = new $withTimeoutOrNullCOROUTINE$4(timeMillis, block, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function TimeoutCoroutine(time, uCont) {
  ScopeCoroutine.call(this, uCont.t8(), uCont);
  this.y1p_1 = time;
}
protoOf(TimeoutCoroutine).v1j = function () {
  this.w1f(TimeoutCancellationException_0(this.y1p_1, get_delay(this.g1e_1), this));
};
protoOf(TimeoutCoroutine).u1e = function () {
  return protoOf(ScopeCoroutine).u1e.call(this) + '(timeMillis=' + this.y1p_1.toString() + ')';
};
function setupTimeout(coroutine, block) {
  var cont = coroutine.c1q_1;
  var context = cont.t8();
  disposeOnCompletion(coroutine, get_delay(context).p1l(coroutine.y1p_1, coroutine, coroutine.g1e_1));
  return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
}
function TimeoutCancellationException_0(time, delay, coroutine) {
  var tmp0_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics) ? delay : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(time, DurationUnit_MILLISECONDS_getInstance());
    tmp = tmp0_safe_receiver.q1l(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp;
  var message = tmp1_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp1_elvis_lhs;
  return new TimeoutCancellationException(message, coroutine);
}
function $withTimeoutOrNullCOROUTINE$4(timeMillis, block, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.r1p_1 = timeMillis;
  this.s1p_1 = block;
}
protoOf($withTimeoutOrNullCOROUTINE$4).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          if (this.r1p_1.b1(new Long(0, 0)) <= 0)
            return null;
          this.t1p_1 = {_v: null};
          this.o8_1 = 2;
          this.n8_1 = 1;
          var timeoutCoroutine = new TimeoutCoroutine(this.r1p_1, this);
          this.t1p_1._v = timeoutCoroutine;
          suspendResult = returnIfSuspended(setupTimeout(timeoutCoroutine, this.s1p_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          this.o8_1 = 3;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof TimeoutCancellationException) {
            var e = this.q8_1;
            if (e.i1p_1 === this.t1p_1._v) {
              return null;
            }
            throw e;
          } else {
            throw this.q8_1;
          }

        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 3) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
function Unconfined() {
  Unconfined_instance = this;
  CoroutineDispatcher.call(this);
}
protoOf(Unconfined).g1l = function (context) {
  return false;
};
protoOf(Unconfined).h1l = function (context, block) {
  var yieldContext = context.a9(Key_instance_4);
  if (!(yieldContext == null)) {
    yieldContext.g1q_1 = true;
    return Unit_instance;
  }
  throw UnsupportedOperationException_init_$Create$('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
};
protoOf(Unconfined).toString = function () {
  return 'Dispatchers.Unconfined';
};
var Unconfined_instance;
function Unconfined_getInstance() {
  if (Unconfined_instance == null)
    new Unconfined();
  return Unconfined_instance;
}
function Key_3() {
}
var Key_instance_4;
function Key_getInstance_3() {
  return Key_instance_4;
}
function Waiter() {
}
var BufferOverflow_SUSPEND_instance;
var BufferOverflow_DROP_OLDEST_instance;
var BufferOverflow_DROP_LATEST_instance;
var BufferOverflow_entriesInitialized;
function BufferOverflow_initEntries() {
  if (BufferOverflow_entriesInitialized)
    return Unit_instance;
  BufferOverflow_entriesInitialized = true;
  BufferOverflow_SUSPEND_instance = new BufferOverflow('SUSPEND', 0);
  BufferOverflow_DROP_OLDEST_instance = new BufferOverflow('DROP_OLDEST', 1);
  BufferOverflow_DROP_LATEST_instance = new BufferOverflow('DROP_LATEST', 2);
}
function BufferOverflow(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function BufferOverflow_SUSPEND_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_SUSPEND_instance;
}
function BufferOverflow_DROP_OLDEST_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_DROP_OLDEST_instance;
}
function BufferOverflow_DROP_LATEST_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_DROP_LATEST_instance;
}
function get_NULL_SEGMENT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NULL_SEGMENT;
}
var NULL_SEGMENT;
function get_SEGMENT_SIZE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SEGMENT_SIZE;
}
var SEGMENT_SIZE;
function get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
}
var EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
function get_BUFFERED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return BUFFERED;
}
var BUFFERED;
function get_IN_BUFFER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return IN_BUFFER;
}
var IN_BUFFER;
function get_RESUMING_BY_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_RCV;
}
var RESUMING_BY_RCV;
function get_RESUMING_BY_EB() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_EB;
}
var RESUMING_BY_EB;
function get_POISONED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return POISONED;
}
var POISONED;
function get_DONE_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return DONE_RCV;
}
var DONE_RCV;
function get_INTERRUPTED_SEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_SEND;
}
var INTERRUPTED_SEND;
function get_INTERRUPTED_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_RCV;
}
var INTERRUPTED_RCV;
function get_CHANNEL_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CHANNEL_CLOSED;
}
var CHANNEL_CLOSED;
function get_SUSPEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND;
}
var SUSPEND;
function get_SUSPEND_NO_WAITER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND_NO_WAITER;
}
var SUSPEND_NO_WAITER;
function get_FAILED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return FAILED;
}
var FAILED;
function get_NO_RECEIVE_RESULT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_RECEIVE_RESULT;
}
var NO_RECEIVE_RESULT;
function get_CLOSE_HANDLER_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CLOSE_HANDLER_CLOSED;
}
var CLOSE_HANDLER_CLOSED;
function get_CLOSE_HANDLER_INVOKED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CLOSE_HANDLER_INVOKED;
}
var CLOSE_HANDLER_INVOKED;
function get_NO_CLOSE_CAUSE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_CLOSE_CAUSE;
}
var NO_CLOSE_CAUSE;
function setElementLazy($this, index, value) {
  // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
  $this.m1q_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value = value;
}
function ChannelSegment(id, prev, channel, pointers) {
  Segment.call(this, id, prev, pointers);
  this.l1q_1 = channel;
  this.m1q_1 = atomicfu$AtomicRefArray$ofNulls(imul(get_SEGMENT_SIZE(), 2));
}
protoOf(ChannelSegment).n1q = function () {
  return ensureNotNull(this.l1q_1);
};
protoOf(ChannelSegment).o1q = function () {
  return get_SEGMENT_SIZE();
};
protoOf(ChannelSegment).p1q = function (index, element) {
  setElementLazy(this, index, element);
};
protoOf(ChannelSegment).q1q = function (index) {
  var tmp = this.m1q_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value;
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(ChannelSegment).r1q = function (index) {
  // Inline function 'kotlin.also' call
  var this_0 = this.q1q(index);
  this.s1q(index);
  return this_0;
};
protoOf(ChannelSegment).s1q = function (index) {
  setElementLazy(this, index, null);
};
protoOf(ChannelSegment).t1q = function (index) {
  return this.m1q_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value;
};
protoOf(ChannelSegment).u1q = function (index, value) {
  this.m1q_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value = value;
};
protoOf(ChannelSegment).v1q = function (index, from, to) {
  return this.m1q_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$compareAndSet(from, to);
};
protoOf(ChannelSegment).w1q = function (index, update) {
  return this.m1q_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$getAndSet(update);
};
protoOf(ChannelSegment).n1i = function (index, cause, context) {
  var isSender = index >= get_SEGMENT_SIZE();
  var index_0 = isSender ? index - get_SEGMENT_SIZE() | 0 : index;
  var element = this.q1q(index_0);
  $l$loop: while (true) {
    var cur = this.t1q(index_0);
    var tmp;
    if (!(cur == null) ? isInterface(cur, Waiter) : false) {
      tmp = true;
    } else {
      tmp = cur instanceof WaiterEB;
    }
    if (tmp) {
      var update = isSender ? get_INTERRUPTED_SEND() : get_INTERRUPTED_RCV();
      if (this.v1q(index_0, cur, update)) {
        this.s1q(index_0);
        this.j1r(index_0, !isSender);
        if (isSender) {
          var tmp0_safe_receiver = this.n1q().y1q_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            callUndeliveredElement(tmp0_safe_receiver, element, context);
          }
        }
        return Unit_instance;
      }
    } else {
      if (cur === get_INTERRUPTED_SEND() || cur === get_INTERRUPTED_RCV()) {
        this.s1q(index_0);
        if (isSender) {
          var tmp1_safe_receiver = this.n1q().y1q_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            callUndeliveredElement(tmp1_safe_receiver, element, context);
          }
        }
        return Unit_instance;
      } else {
        if (cur === get_RESUMING_BY_EB() || cur === get_RESUMING_BY_RCV())
          continue $l$loop;
        else {
          if (cur === get_DONE_RCV() || cur === get_BUFFERED())
            return Unit_instance;
          else {
            if (cur === get_CHANNEL_CLOSED())
              return Unit_instance;
            else {
              // Inline function 'kotlin.error' call
              var message = 'unexpected state: ' + toString_0(cur);
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }
      }
    }
  }
};
protoOf(ChannelSegment).j1r = function (index, receiver) {
  if (receiver) {
    var tmp = this.n1q();
    var tmp0 = this.l1i_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$1 = tmp0.t2(toLong(other)).r2(toLong(index));
    tmp.k1r(tmp$ret$1);
  }
  this.l1r();
};
function onClosedHasNext($this) {
  $this.x1r_1 = get_CHANNEL_CLOSED();
  var tmp0_elvis_lhs = $this.z1r_1.a1s();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var cause = tmp;
  throw recoverStackTrace_0(cause);
}
function hasNextOnNoWaiterSuspend($this, segment, index, r, $completion) {
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    $this.y1r_1 = cancellable;
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
    var this_0 = $this.z1r_1;
    var updCellResult = updateCellReceive(this_0, segment, index, r, $this);
    if (updCellResult === get_SUSPEND()) {
      prepareReceiverForSuspension(this_0, $this, segment, index);
    } else if (updCellResult === get_FAILED()) {
      if (r.b1(this_0.b1s()) < 0) {
        segment.v1r();
      }
      $l$block_0: {
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
        var segment_0 = this_0.e1r_1.kotlinx$atomicfu$value;
        $l$loop_0: while (true) {
          if (this_0.c1s()) {
            onClosedHasNextNoWaiterSuspend($this);
            break $l$block_0;
          }
          var r_0 = this_0.a1r_1.atomicfu$getAndIncrement$long();
          // Inline function 'kotlin.Long.div' call
          var other = get_SEGMENT_SIZE();
          var id = r_0.u2(toLong(other));
          // Inline function 'kotlin.Long.rem' call
          var other_0 = get_SEGMENT_SIZE();
          var i = r_0.v2(toLong(other_0)).d1();
          if (!segment_0.l1i_1.equals(id)) {
            var tmp0_elvis_lhs = findSegmentReceive(this_0, id, segment_0);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            segment_0 = tmp;
          }
          var updCellResult_0 = updateCellReceive(this_0, segment_0, i, r_0, $this);
          if (updCellResult_0 === get_SUSPEND()) {
            var tmp1_safe_receiver = (!($this == null) ? isInterface($this, Waiter) : false) ? $this : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              prepareReceiverForSuspension(this_0, tmp1_safe_receiver, segment_0, i);
            }
          } else if (updCellResult_0 === get_FAILED()) {
            if (r_0.b1(this_0.b1s()) < 0) {
              segment_0.v1r();
            }
            continue $l$loop_0;
          } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
            // Inline function 'kotlin.error' call
            var message = 'unexpected';
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            segment_0.v1r();
            var element = (updCellResult_0 == null ? true : !(updCellResult_0 == null)) ? updCellResult_0 : THROW_CCE();
            $this.x1r_1 = element;
            $this.y1r_1 = null;
            var tmp0_safe_receiver = $this.z1r_1.y1q_1;
            cancellable.n1h(true, tmp0_safe_receiver == null ? null : bindCancellationFun($this.z1r_1, tmp0_safe_receiver, element));
          }
          break $l$block_0;
        }
      }
    } else {
      segment.v1r();
      var element_0 = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
      $this.x1r_1 = element_0;
      $this.y1r_1 = null;
      var tmp0_safe_receiver_0 = $this.z1r_1.y1q_1;
      cancellable.n1h(true, tmp0_safe_receiver_0 == null ? null : bindCancellationFun($this.z1r_1, tmp0_safe_receiver_0, element_0));
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.i1j();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.h1j();
}
function onClosedHasNextNoWaiterSuspend($this) {
  var cont = ensureNotNull($this.y1r_1);
  $this.y1r_1 = null;
  $this.x1r_1 = get_CHANNEL_CLOSED();
  var cause = $this.z1r_1.a1s();
  if (cause == null) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
    cont.y8(tmp$ret$0);
  } else {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace(cause, cont);
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.y8(tmp$ret$2);
  }
}
function $hasNextCOROUTINE$8(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.l1s_1 = _this__u8e3s4;
}
protoOf($hasNextCOROUTINE$8).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 8;
          if (!(this.l1s_1.x1r_1 === get_NO_RECEIVE_RESULT()) && !(this.l1s_1.x1r_1 === get_CHANNEL_CLOSED())) {
            var tmp_0 = this;
            tmp_0.m1s_1 = true;
            this.n8_1 = 11;
            continue $sm;
          } else {
            var tmp_1 = this;
            tmp_1.n1s_1 = this.l1s_1.z1r_1;
            var tmp_2 = this;
            tmp_2.o1s_1 = null;
            this.n8_1 = 1;
            continue $sm;
          }

        case 1:
          this.q1s_1 = this.n1s_1;
          this.r1s_1 = this.o1s_1;
          this.s1s_1 = this.q1s_1.e1r_1.kotlinx$atomicfu$value;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (!true) {
            this.n8_1 = 9;
            continue $sm;
          }

          if (this.q1s_1.c1s()) {
            var tmp_3 = this;
            tmp_3.p1s_1 = onClosedHasNext(this.l1s_1);
            this.n8_1 = 10;
            continue $sm;
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 3:
          this.t1s_1 = this.q1s_1.a1r_1.atomicfu$getAndIncrement$long();
          var tmp_4 = this;
          var tmp0 = this.t1s_1;
          var other = get_SEGMENT_SIZE();
          tmp_4.u1s_1 = tmp0.u2(toLong(other));
          var tmp_5 = this;
          var tmp2 = this.t1s_1;
          var other_0 = get_SEGMENT_SIZE();
          tmp_5.v1s_1 = tmp2.v2(toLong(other_0)).d1();
          if (!this.s1s_1.l1i_1.equals(this.u1s_1)) {
            this.w1s_1 = findSegmentReceive(this.q1s_1, this.u1s_1, this.s1s_1);
            if (this.w1s_1 == null) {
              this.n8_1 = 2;
              var tmp_6 = this;
              continue $sm;
            } else {
              this.x1s_1 = this.w1s_1;
              this.n8_1 = 4;
              continue $sm;
            }
          } else {
            this.n8_1 = 5;
            continue $sm;
          }

        case 4:
          this.s1s_1 = this.x1s_1;
          this.n8_1 = 5;
          continue $sm;
        case 5:
          this.y1s_1 = updateCellReceive(this.q1s_1, this.s1s_1, this.v1s_1, this.t1s_1, this.r1s_1);
          if (this.y1s_1 === get_SUSPEND()) {
            var tmp_7 = this;
            var tmp_8 = this.r1s_1;
            var tmp1_safe_receiver = (!(tmp_8 == null) ? isInterface(tmp_8, Waiter) : false) ? tmp_8 : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              prepareReceiverForSuspension(this.q1s_1, tmp1_safe_receiver, this.s1s_1, this.v1s_1);
            }
            this.s1s_1;
            this.v1s_1;
            this.t1s_1;
            var message = 'unreachable';
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            if (this.y1s_1 === get_FAILED()) {
              if (this.t1s_1.b1(this.q1s_1.b1s()) < 0) {
                this.s1s_1.v1r();
              }
              this.n8_1 = 2;
              var tmp_9 = this;
              continue $sm;
            } else {
              if (this.y1s_1 === get_SUSPEND_NO_WAITER()) {
                var tmp_10 = this;
                tmp_10.a1t_1 = this.s1s_1;
                var tmp_11 = this;
                tmp_11.b1t_1 = this.v1s_1;
                var tmp_12 = this;
                tmp_12.c1t_1 = this.t1s_1;
                this.d1t_1 = this.a1t_1;
                this.e1t_1 = this.b1t_1;
                this.f1t_1 = this.c1t_1;
                this.n8_1 = 6;
                suspendResult = hasNextOnNoWaiterSuspend(this.l1s_1, this.d1t_1, this.e1t_1, this.f1t_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_13 = this;
                this.s1s_1.v1r();
                var tmp_14 = this.y1s_1;
                var element = (tmp_14 == null ? true : !(tmp_14 == null)) ? tmp_14 : THROW_CCE();
                this.l1s_1.x1r_1 = element;
                tmp_13.z1s_1 = true;
                this.n8_1 = 7;
                continue $sm;
              }
            }
          }

        case 6:
          var tmp_15 = this;
          return suspendResult;
        case 7:
          this.p1s_1 = this.z1s_1;
          this.n8_1 = 10;
          continue $sm;
        case 8:
          throw this.q8_1;
        case 9:
          if (false) {
            this.n8_1 = 1;
            continue $sm;
          }

          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.m1s_1 = this.p1s_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          return this.m1s_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 8) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function _get_bufferEndCounter__2d4hee($this) {
  return $this.b1r_1.kotlinx$atomicfu$value;
}
function _get_isRendezvousOrUnlimited__3mdufi($this) {
  // Inline function 'kotlin.let' call
  var it = _get_bufferEndCounter__2d4hee($this);
  return it.equals(new Long(0, 0)) || it.equals(new Long(-1, 2147483647));
}
function onClosedSend($this, element, $completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.z1i();
  $l$block: {
    var tmp0_safe_receiver = $this.y1q_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      addSuppressed(tmp1_safe_receiver, $this.g1t());
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(tmp1_safe_receiver, cancellable);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      cancellable.y8(tmp$ret$0);
      break $l$block;
    }
    // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
    var exception_0 = $this.g1t();
    // Inline function 'kotlin.Companion.failure' call
    var exception_1 = recoverStackTrace(exception_0, cancellable);
    var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(exception_1));
    cancellable.y8(tmp$ret$4);
  }
  return cancellable.h1j();
}
function sendOnNoWaiterSuspend($this, segment, index, element, s, $completion) {
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter' call
    switch (updateCellSend($this, segment, index, element, s, cancellable, false)) {
      case 0:
        segment.v1r();
        // Inline function 'kotlin.coroutines.resume' call

        // Inline function 'kotlin.Companion.success' call

        var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.y8(tmp$ret$0);
        break;
      case 1:
        // Inline function 'kotlin.coroutines.resume' call

        // Inline function 'kotlin.Companion.success' call

        var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.y8(tmp$ret$3);
        break;
      case 2:
        prepareSenderForSuspension($this, cancellable, segment, index);
        break;
      case 4:
        if (s.b1($this.h1t()) < 0) {
          segment.v1r();
        }

        onClosedSendOnNoWaiterSuspend($this, element, cancellable);
        break;
      case 5:
        segment.v1r();
        $l$block_5: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
          var segment_0 = $this.d1r_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            var sendersAndCloseStatusCur = $this.z1q_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
            var s_0 = sendersAndCloseStatusCur.e3(new Long(-1, 268435455));
            var closed = _get_isClosedForSend0__kxgf9m($this, sendersAndCloseStatusCur);
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = s_0.u2(toLong(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var i = s_0.v2(toLong(other_0)).d1();
            if (!segment_0.l1i_1.equals(id)) {
              var tmp0_elvis_lhs = findSegmentSend($this, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                var tmp_0;
                if (closed) {
                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_5;
                } else {
                  continue $l$loop_0;
                }
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            switch (updateCellSend($this, segment_0, i, element, s_0, cancellable, closed)) {
              case 0:
                segment_0.v1r();
                // Inline function 'kotlin.coroutines.resume' call

                // Inline function 'kotlin.Companion.success' call

                var tmp$ret$12 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.y8(tmp$ret$12);
                break $l$block_5;
              case 1:
                // Inline function 'kotlin.coroutines.resume' call

                // Inline function 'kotlin.Companion.success' call

                var tmp$ret$15 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.y8(tmp$ret$15);
                break $l$block_5;
              case 2:
                if (closed) {
                  segment_0.l1r();
                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_5;
                }

                var tmp2_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  prepareSenderForSuspension($this, tmp2_safe_receiver, segment_0, i);
                }

                break $l$block_5;
              case 4:
                if (s_0.b1($this.h1t()) < 0) {
                  segment_0.v1r();
                }

                onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                break $l$block_5;
              case 5:
                segment_0.v1r();
                continue $l$loop_0;
              case 3:
                // Inline function 'kotlin.error' call

                var message = 'unexpected';
                throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }

        break;
      default:
        // Inline function 'kotlin.error' call

        var message_0 = 'unexpected';
        throw IllegalStateException_init_$Create$(toString(message_0));
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.i1j();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.h1j();
}
function prepareSenderForSuspension($this, _this__u8e3s4, segment, index) {
  _this__u8e3s4.o1j(segment, index + get_SEGMENT_SIZE() | 0);
}
function onClosedSendOnNoWaiterSuspend($this, element, cont) {
  var tmp0_safe_receiver = $this.y1q_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    callUndeliveredElement(tmp0_safe_receiver, element, cont.t8());
  }
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = recoverStackTrace($this.g1t(), cont);
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.y8(tmp$ret$0);
}
function SendBroadcast() {
}
function updateCellSend($this, segment, index, element, s, waiter, closed) {
  segment.p1q(index, element);
  if (closed)
    return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
  var state = segment.t1q(index);
  if (state === null) {
    if (bufferOrRendezvousSend($this, s)) {
      if (segment.v1q(index, null, get_BUFFERED())) {
        return 1;
      }
    } else {
      if (waiter == null) {
        return 3;
      } else {
        if (segment.v1q(index, null, waiter))
          return 2;
      }
    }
  } else {
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      segment.s1q(index);
      var tmp;
      if (tryResumeReceiver($this, state, element)) {
        segment.u1q(index, get_DONE_RCV());
        $this.i1t();
        tmp = 0;
      } else {
        if (!(segment.w1q(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.j1r(index, true);
        }
        tmp = 5;
      }
      return tmp;
    }
  }
  return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
}
function updateCellSendSlow($this, segment, index, element, s, waiter, closed) {
  while (true) {
    var state = segment.t1q(index);
    if (state === null) {
      if (bufferOrRendezvousSend($this, s) && !closed) {
        if (segment.v1q(index, null, get_BUFFERED())) {
          return 1;
        }
      } else {
        if (closed) {
          if (segment.v1q(index, null, get_INTERRUPTED_SEND())) {
            segment.j1r(index, false);
            return 4;
          }
        } else if (waiter == null)
          return 3;
        else if (segment.v1q(index, null, waiter))
          return 2;
      }
    } else if (state === get_IN_BUFFER()) {
      if (segment.v1q(index, state, get_BUFFERED())) {
        return 1;
      }
    } else if (state === get_INTERRUPTED_RCV()) {
      segment.s1q(index);
      return 5;
    } else if (state === get_POISONED()) {
      segment.s1q(index);
      return 5;
    } else if (state === get_CHANNEL_CLOSED()) {
      segment.s1q(index);
      completeCloseOrCancel($this);
      return 4;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      segment.s1q(index);
      var tmp;
      if (state instanceof WaiterEB) {
        tmp = state.j1t_1;
      } else {
        tmp = state;
      }
      var receiver = tmp;
      var tmp_0;
      if (tryResumeReceiver($this, receiver, element)) {
        segment.u1q(index, get_DONE_RCV());
        $this.i1t();
        tmp_0 = 0;
      } else {
        if (!(segment.w1q(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.j1r(index, true);
        }
        tmp_0 = 5;
      }
      return tmp_0;
    }
  }
}
function shouldSendSuspend0($this, curSendersAndCloseStatus) {
  if (_get_isClosedForSend0__kxgf9m($this, curSendersAndCloseStatus))
    return false;
  // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
  var tmp$ret$0 = curSendersAndCloseStatus.e3(new Long(-1, 268435455));
  return !bufferOrRendezvousSend($this, tmp$ret$0);
}
function bufferOrRendezvousSend($this, curSenders) {
  var tmp;
  if (curSenders.b1(_get_bufferEndCounter__2d4hee($this)) < 0) {
    tmp = true;
  } else {
    var tmp0 = $this.h1t();
    // Inline function 'kotlin.Long.plus' call
    var other = $this.x1q_1;
    var tmp$ret$0 = tmp0.r2(toLong(other));
    tmp = curSenders.b1(tmp$ret$0) < 0;
  }
  return tmp;
}
function tryResumeReceiver($this, _this__u8e3s4, element) {
  var tmp;
  if (isInterface(_this__u8e3s4, SelectInstance)) {
    tmp = _this__u8e3s4.o1t($this, element);
  } else {
    if (_this__u8e3s4 instanceof ReceiveCatching) {
      if (!(_this__u8e3s4 instanceof ReceiveCatching))
        THROW_CCE();
      var tmp_0 = Companion_getInstance_0().m1t(element);
      var tmp1_safe_receiver = $this.y1q_1;
      tmp = tryResume0(_this__u8e3s4.n1t_1, new ChannelResult(tmp_0), tmp1_safe_receiver == null ? null : bindCancellationFunResult($this, tmp1_safe_receiver));
    } else {
      if (_this__u8e3s4 instanceof BufferedChannelIterator) {
        if (!(_this__u8e3s4 instanceof BufferedChannelIterator))
          THROW_CCE();
        tmp = _this__u8e3s4.k1t(element);
      } else {
        if (isInterface(_this__u8e3s4, CancellableContinuation)) {
          if (!isInterface(_this__u8e3s4, CancellableContinuation))
            THROW_CCE();
          var tmp2_safe_receiver = $this.y1q_1;
          tmp = tryResume0(_this__u8e3s4, element, tmp2_safe_receiver == null ? null : bindCancellationFun_0($this, tmp2_safe_receiver));
        } else {
          var message = 'Unexpected receiver type: ' + toString(_this__u8e3s4);
          throw IllegalStateException_init_$Create$(toString(message));
        }
      }
    }
  }
  return tmp;
}
function receiveOnNoWaiterSuspend($this, segment, index, r, $completion) {
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
    var updCellResult = updateCellReceive($this, segment, index, r, cancellable);
    if (updCellResult === get_SUSPEND()) {
      prepareReceiverForSuspension($this, cancellable, segment, index);
    } else if (updCellResult === get_FAILED()) {
      if (r.b1($this.b1s()) < 0) {
        segment.v1r();
      }
      $l$block_0: {
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
        var segment_0 = $this.e1r_1.kotlinx$atomicfu$value;
        $l$loop_0: while (true) {
          if ($this.c1s()) {
            onClosedReceiveOnNoWaiterSuspend($this, cancellable);
            break $l$block_0;
          }
          var r_0 = $this.a1r_1.atomicfu$getAndIncrement$long();
          // Inline function 'kotlin.Long.div' call
          var other = get_SEGMENT_SIZE();
          var id = r_0.u2(toLong(other));
          // Inline function 'kotlin.Long.rem' call
          var other_0 = get_SEGMENT_SIZE();
          var i = r_0.v2(toLong(other_0)).d1();
          if (!segment_0.l1i_1.equals(id)) {
            var tmp0_elvis_lhs = findSegmentReceive($this, id, segment_0);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            segment_0 = tmp;
          }
          var updCellResult_0 = updateCellReceive($this, segment_0, i, r_0, cancellable);
          if (updCellResult_0 === get_SUSPEND()) {
            var tmp1_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              prepareReceiverForSuspension($this, tmp1_safe_receiver, segment_0, i);
            }
          } else if (updCellResult_0 === get_FAILED()) {
            if (r_0.b1($this.b1s()) < 0) {
              segment_0.v1r();
            }
            continue $l$loop_0;
          } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
            // Inline function 'kotlin.error' call
            var message = 'unexpected';
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            segment_0.v1r();
            var element = (updCellResult_0 == null ? true : !(updCellResult_0 == null)) ? updCellResult_0 : THROW_CCE();
            var tmp0_safe_receiver = $this.y1q_1;
            var onCancellation = tmp0_safe_receiver == null ? null : bindCancellationFun_0($this, tmp0_safe_receiver);
            cancellable.n1h(element, onCancellation);
          }
          break $l$block_0;
        }
      }
    } else {
      segment.v1r();
      var element_0 = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
      var tmp0_safe_receiver_0 = $this.y1q_1;
      var onCancellation_0 = tmp0_safe_receiver_0 == null ? null : bindCancellationFun_0($this, tmp0_safe_receiver_0);
      cancellable.n1h(element_0, onCancellation_0);
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.i1j();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.h1j();
}
function prepareReceiverForSuspension($this, _this__u8e3s4, segment, index) {
  $this.p1t();
  _this__u8e3s4.o1j(segment, index);
}
function onClosedReceiveOnNoWaiterSuspend($this, cont) {
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = _get_receiveException__foorc1($this);
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.y8(tmp$ret$0);
}
function updateCellReceive($this, segment, index, r, waiter) {
  var state = segment.t1q(index);
  if (state === null) {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var senders = $this.z1q_1.kotlinx$atomicfu$value.e3(new Long(-1, 268435455));
    if (r.b1(senders) >= 0) {
      if (waiter === null) {
        return get_SUSPEND_NO_WAITER();
      }
      if (segment.v1q(index, state, waiter)) {
        expandBuffer($this);
        return get_SUSPEND();
      }
    }
  } else if (state === get_BUFFERED())
    if (segment.v1q(index, state, get_DONE_RCV())) {
      expandBuffer($this);
      return segment.r1q(index);
    }
  return updateCellReceiveSlow($this, segment, index, r, waiter);
}
function updateCellReceiveSlow($this, segment, index, r, waiter) {
  $l$loop: while (true) {
    var state = segment.t1q(index);
    if (state === null || state === get_IN_BUFFER()) {
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var senders = $this.z1q_1.kotlinx$atomicfu$value.e3(new Long(-1, 268435455));
      if (r.b1(senders) < 0) {
        if (segment.v1q(index, state, get_POISONED())) {
          expandBuffer($this);
          return get_FAILED();
        }
      } else {
        if (waiter === null) {
          return get_SUSPEND_NO_WAITER();
        }
        if (segment.v1q(index, state, waiter)) {
          expandBuffer($this);
          return get_SUSPEND();
        }
      }
    } else if (state === get_BUFFERED()) {
      if (segment.v1q(index, state, get_DONE_RCV())) {
        expandBuffer($this);
        return segment.r1q(index);
      }
    } else if (state === get_INTERRUPTED_SEND())
      return get_FAILED();
    else if (state === get_POISONED())
      return get_FAILED();
    else if (state === get_CHANNEL_CLOSED()) {
      expandBuffer($this);
      return get_FAILED();
    } else if (state === get_RESUMING_BY_EB())
      continue $l$loop;
    else {
      if (segment.v1q(index, state, get_RESUMING_BY_RCV())) {
        var helpExpandBuffer = state instanceof WaiterEB;
        var tmp;
        if (state instanceof WaiterEB) {
          tmp = state.j1t_1;
        } else {
          tmp = state;
        }
        var sender = tmp;
        var tmp_0;
        if (tryResumeSender($this, sender, segment, index)) {
          segment.u1q(index, get_DONE_RCV());
          expandBuffer($this);
          tmp_0 = segment.r1q(index);
        } else {
          segment.u1q(index, get_INTERRUPTED_SEND());
          segment.j1r(index, false);
          if (helpExpandBuffer) {
            expandBuffer($this);
          }
          tmp_0 = get_FAILED();
        }
        return tmp_0;
      }
    }
  }
}
function tryResumeSender($this, _this__u8e3s4, segment, index) {
  var tmp;
  if (isInterface(_this__u8e3s4, CancellableContinuation)) {
    if (!isInterface(_this__u8e3s4, CancellableContinuation))
      THROW_CCE();
    tmp = tryResume0(_this__u8e3s4, Unit_instance);
  } else {
    if (isInterface(_this__u8e3s4, SelectInstance)) {
      if (!(_this__u8e3s4 instanceof SelectImplementation))
        THROW_CCE();
      var trySelectResult = _this__u8e3s4.u1t($this, Unit_instance);
      if (trySelectResult === TrySelectDetailedResult_REREGISTER_getInstance()) {
        segment.s1q(index);
      }
      tmp = trySelectResult === TrySelectDetailedResult_SUCCESSFUL_getInstance();
    } else {
      if (_this__u8e3s4 instanceof SendBroadcast) {
        tmp = tryResume0(_this__u8e3s4.q1t_1, true);
      } else {
        var message = 'Unexpected waiter: ' + toString(_this__u8e3s4);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  return tmp;
}
function expandBuffer($this) {
  if (_get_isRendezvousOrUnlimited__3mdufi($this))
    return Unit_instance;
  var segment = $this.f1r_1.kotlinx$atomicfu$value;
  try_again: while (true) {
    var b = $this.b1r_1.atomicfu$getAndIncrement$long();
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE();
    var id = b.u2(toLong(other));
    var s = $this.b1s();
    if (s.b1(b) <= 0) {
      if (segment.l1i_1.b1(id) < 0 && !(segment.r1r() == null)) {
        moveSegmentBufferEndToSpecifiedOrLast($this, id, segment);
      }
      incCompletedExpandBufferAttempts$default($this);
      return Unit_instance;
    }
    if (!segment.l1i_1.equals(id)) {
      var tmp0_elvis_lhs = findSegmentBufferEnd($this, id, segment, b);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue try_again;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE();
    var i = b.v2(toLong(other_0)).d1();
    if (updateCellExpandBuffer($this, segment, i, b)) {
      incCompletedExpandBufferAttempts$default($this);
      return Unit_instance;
    } else {
      incCompletedExpandBufferAttempts$default($this);
      continue try_again;
    }
  }
}
function updateCellExpandBuffer($this, segment, index, b) {
  var state = segment.t1q(index);
  if (!(state == null) ? isInterface(state, Waiter) : false) {
    if (b.b1($this.a1r_1.kotlinx$atomicfu$value) >= 0) {
      if (segment.v1q(index, state, get_RESUMING_BY_EB())) {
        var tmp;
        if (tryResumeSender($this, state, segment, index)) {
          segment.u1q(index, get_BUFFERED());
          tmp = true;
        } else {
          segment.u1q(index, get_INTERRUPTED_SEND());
          segment.j1r(index, false);
          tmp = false;
        }
        return tmp;
      }
    }
  }
  return updateCellExpandBufferSlow($this, segment, index, b);
}
function updateCellExpandBufferSlow($this, segment, index, b) {
  $l$loop: while (true) {
    var state = segment.t1q(index);
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      if (b.b1($this.a1r_1.kotlinx$atomicfu$value) < 0) {
        if (segment.v1q(index, state, new WaiterEB(state)))
          return true;
      } else {
        if (segment.v1q(index, state, get_RESUMING_BY_EB())) {
          var tmp;
          if (tryResumeSender($this, state, segment, index)) {
            segment.u1q(index, get_BUFFERED());
            tmp = true;
          } else {
            segment.u1q(index, get_INTERRUPTED_SEND());
            segment.j1r(index, false);
            tmp = false;
          }
          return tmp;
        }
      }
    } else {
      if (state === get_INTERRUPTED_SEND())
        return false;
      else {
        if (state === null) {
          if (segment.v1q(index, state, get_IN_BUFFER()))
            return true;
        } else {
          if (state === get_BUFFERED())
            return true;
          else {
            if (state === get_POISONED() || state === get_DONE_RCV() || state === get_INTERRUPTED_RCV())
              return true;
            else {
              if (state === get_CHANNEL_CLOSED())
                return true;
              else {
                if (state === get_RESUMING_BY_RCV())
                  continue $l$loop;
                else {
                  // Inline function 'kotlin.error' call
                  var message = 'Unexpected cell state: ' + toString_0(state);
                  throw IllegalStateException_init_$Create$(toString(message));
                }
              }
            }
          }
        }
      }
    }
  }
}
function incCompletedExpandBufferAttempts($this, nAttempts) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
  if (!$this.c1r_1.atomicfu$addAndGet$long(nAttempts).e3(new Long(0, 1073741824)).equals(new Long(0, 0))) {
    $l$loop: while (true) {
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      if (!!$this.c1r_1.kotlinx$atomicfu$value.e3(new Long(0, 1073741824)).equals(new Long(0, 0))) {
        break $l$loop;
      }
    }
  }
}
function incCompletedExpandBufferAttempts$default($this, nAttempts, $super) {
  nAttempts = nAttempts === VOID ? new Long(1, 0) : nAttempts;
  return incCompletedExpandBufferAttempts($this, nAttempts);
}
function BufferedChannelIterator($outer) {
  this.z1r_1 = $outer;
  this.x1r_1 = get_NO_RECEIVE_RESULT();
  this.y1r_1 = null;
}
protoOf(BufferedChannelIterator).v1t = function ($completion) {
  var tmp = new $hasNextCOROUTINE$8(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BufferedChannelIterator).o1j = function (segment, index) {
  var tmp0_safe_receiver = this.y1r_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.o1j(segment, index);
  }
};
protoOf(BufferedChannelIterator).l = function () {
  var result = this.x1r_1;
  // Inline function 'kotlin.check' call
  if (!!(result === get_NO_RECEIVE_RESULT())) {
    var message = '`hasNext()` has not been invoked';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  this.x1r_1 = get_NO_RECEIVE_RESULT();
  if (result === get_CHANNEL_CLOSED())
    throw recoverStackTrace_0(_get_receiveException__foorc1(this.z1r_1));
  return (result == null ? true : !(result == null)) ? result : THROW_CCE();
};
protoOf(BufferedChannelIterator).k1t = function (element) {
  var cont = ensureNotNull(this.y1r_1);
  this.y1r_1 = null;
  this.x1r_1 = element;
  var tmp0_safe_receiver = this.z1r_1.y1q_1;
  return tryResume0(cont, true, tmp0_safe_receiver == null ? null : bindCancellationFun(this.z1r_1, tmp0_safe_receiver, element));
};
protoOf(BufferedChannelIterator).w1t = function () {
  var cont = ensureNotNull(this.y1r_1);
  this.y1r_1 = null;
  this.x1r_1 = get_CHANNEL_CLOSED();
  var cause = this.z1r_1.a1s();
  if (cause == null) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
    cont.y8(tmp$ret$0);
  } else {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace(cause, cont);
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.y8(tmp$ret$2);
  }
};
function _get_receiveException__foorc1($this) {
  var tmp0_elvis_lhs = $this.a1s();
  return tmp0_elvis_lhs == null ? new ClosedReceiveChannelException('Channel was closed') : tmp0_elvis_lhs;
}
function invokeCloseHandler($this) {
  var tmp0 = $this.i1r_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.getAndUpdate' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      var tmp;
      if (cur === null) {
        tmp = get_CLOSE_HANDLER_CLOSED();
      } else {
        tmp = get_CLOSE_HANDLER_INVOKED();
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$1 = cur;
        break $l$block;
      }
    }
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var closeHandler = tmp_0;
  if (typeof closeHandler !== 'function')
    THROW_CCE();
  closeHandler($this.a1s());
}
function markClosed($this) {
  var tmp0 = $this.z1q_1;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      var tmp;
      switch (cur.c3(60).d1()) {
        case 0:
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

          var tmp$ret$1 = cur.e3(new Long(-1, 268435455));
          tmp = constructSendersAndCloseStatus(tmp$ret$1, 2);
          break;
        case 1:
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

          var tmp$ret$2 = cur.e3(new Long(-1, 268435455));
          tmp = constructSendersAndCloseStatus(tmp$ret$2, 3);
          break;
        default:
          return Unit_instance;
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$4 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$4 = Unit_instance;
  }
  return tmp$ret$4;
}
function markCancelled($this) {
  var tmp0 = $this.z1q_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var tmp$ret$0 = cur.e3(new Long(-1, 268435455));
      var upd = constructSendersAndCloseStatus(tmp$ret$0, 3);
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$2 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$2 = Unit_instance;
  }
  return tmp$ret$2;
}
function markCancellationStarted($this) {
  var tmp0 = $this.z1q_1;
  var tmp$ret$3;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      var tmp;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      if (cur.c3(60).d1() === 0) {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var tmp$ret$1 = cur.e3(new Long(-1, 268435455));
        tmp = constructSendersAndCloseStatus(tmp$ret$1, 1);
      } else {
        return Unit_instance;
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$3 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$3 = Unit_instance;
  }
  return tmp$ret$3;
}
function completeCloseOrCancel($this) {
  $this.x1t();
}
function completeClose($this, sendersCur) {
  var lastSegment = closeLinkedList($this);
  if ($this.z1t()) {
    var lastBufferedCellGlobalIndex = markAllEmptyCellsAsClosed($this, lastSegment);
    if (!lastBufferedCellGlobalIndex.equals(new Long(-1, -1))) {
      $this.y1t(lastBufferedCellGlobalIndex);
    }
  }
  cancelSuspendedReceiveRequests($this, lastSegment, sendersCur);
  return lastSegment;
}
function completeCancel($this, sendersCur) {
  var lastSegment = completeClose($this, sendersCur);
  removeUnprocessedElements($this, lastSegment);
}
function closeLinkedList($this) {
  var lastSegment = $this.f1r_1.kotlinx$atomicfu$value;
  // Inline function 'kotlin.let' call
  var it = $this.d1r_1.kotlinx$atomicfu$value;
  if (it.l1i_1.b1(lastSegment.l1i_1) > 0)
    lastSegment = it;
  // Inline function 'kotlin.let' call
  var it_0 = $this.e1r_1.kotlinx$atomicfu$value;
  if (it_0.l1i_1.b1(lastSegment.l1i_1) > 0)
    lastSegment = it_0;
  return close(lastSegment);
}
function markAllEmptyCellsAsClosed($this, lastSegment) {
  var segment = lastSegment;
  while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.l1i_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var globalIndex = tmp0.t2(toLong(other)).r2(toLong(index));
        if (globalIndex.b1($this.h1t()) < 0)
          return new Long(-1, -1);
        cell_update: while (true) {
          var state = segment.t1q(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.v1q(index, state, get_CHANNEL_CLOSED())) {
              segment.l1r();
              break cell_update;
            }
          } else if (state === get_BUFFERED())
            return globalIndex;
          else
            break cell_update;
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.u1r();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return new Long(-1, -1);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
}
function removeUnprocessedElements($this, lastSegment) {
  var onUndeliveredElement = $this.y1q_1;
  var undeliveredElementException = null;
  var suspendedSenders = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.l1i_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var globalIndex = tmp0.t2(toLong(other)).r2(toLong(index));
        update_cell: while (true) {
          var state = segment.t1q(index);
          if (state === get_DONE_RCV())
            break process_segments;
          else {
            if (state === get_BUFFERED()) {
              if (globalIndex.b1($this.h1t()) < 0)
                break process_segments;
              if (segment.v1q(index, state, get_CHANNEL_CLOSED())) {
                if (!(onUndeliveredElement == null)) {
                  var element = segment.q1q(index);
                  undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element, undeliveredElementException);
                }
                segment.s1q(index);
                segment.l1r();
                break update_cell;
              }
            } else {
              if (state === get_IN_BUFFER() || state === null) {
                if (segment.v1q(index, state, get_CHANNEL_CLOSED())) {
                  segment.l1r();
                  break update_cell;
                }
              } else {
                var tmp;
                if (!(state == null) ? isInterface(state, Waiter) : false) {
                  tmp = true;
                } else {
                  tmp = state instanceof WaiterEB;
                }
                if (tmp) {
                  if (globalIndex.b1($this.h1t()) < 0)
                    break process_segments;
                  var tmp_0;
                  if (state instanceof WaiterEB) {
                    tmp_0 = state.j1t_1;
                  } else {
                    tmp_0 = (!(state == null) ? isInterface(state, Waiter) : false) ? state : THROW_CCE();
                  }
                  var sender = tmp_0;
                  if (segment.v1q(index, state, get_CHANNEL_CLOSED())) {
                    if (!(onUndeliveredElement == null)) {
                      var element_0 = segment.q1q(index);
                      undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element_0, undeliveredElementException);
                    }
                    suspendedSenders = InlineList__plus_impl_nuetvo(suspendedSenders, sender);
                    segment.s1q(index);
                    segment.l1r();
                    break update_cell;
                  }
                } else {
                  if (state === get_RESUMING_BY_EB() || state === get_RESUMING_BY_RCV())
                    break process_segments;
                  else {
                    if (state === get_RESUMING_BY_EB())
                      continue update_cell;
                    else {
                      break update_cell;
                    }
                  }
                }
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.u1r();
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      break process_segments;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    segment = tmp_1;
  }
  var tmp4 = suspendedSenders;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var tmp0_subject = access$_get_holder__kkflen(tmp4);
    if (tmp0_subject == null) {
      break $l$block;
    } else {
      if (!(tmp0_subject instanceof ArrayList)) {
        var tmp_2 = access$_get_holder__kkflen(tmp4);
        var it = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
        resumeSenderOnCancelledChannel($this, it);
      } else {
        var tmp_3 = access$_get_holder__kkflen(tmp4);
        var list = tmp_3 instanceof ArrayList ? tmp_3 : THROW_CCE();
        var inductionVariable_0 = list.m() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var it_0 = list.o(i);
            resumeSenderOnCancelledChannel($this, it_0);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  var tmp1_safe_receiver = undeliveredElementException;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp1_safe_receiver;
  }
}
function cancelSuspendedReceiveRequests($this, lastSegment, sendersCounter) {
  var suspendedReceivers = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (!(segment == null)) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.l1i_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        if (tmp0.t2(toLong(other)).r2(toLong(index)).b1(sendersCounter) < 0)
          break process_segments;
        cell_update: while (true) {
          var state = segment.t1q(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.v1q(index, state, get_CHANNEL_CLOSED())) {
              segment.l1r();
              break cell_update;
            }
          } else {
            if (state instanceof WaiterEB) {
              if (segment.v1q(index, state, get_CHANNEL_CLOSED())) {
                suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state.j1t_1);
                segment.j1r(index, true);
                break cell_update;
              }
            } else {
              if (!(state == null) ? isInterface(state, Waiter) : false) {
                if (segment.v1q(index, state, get_CHANNEL_CLOSED())) {
                  suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state);
                  segment.j1r(index, true);
                  break cell_update;
                }
              } else {
                break cell_update;
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    segment = segment.u1r();
  }
  var tmp4 = suspendedReceivers;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var tmp0_subject = access$_get_holder__kkflen(tmp4);
    if (tmp0_subject == null) {
      break $l$block;
    } else {
      if (!(tmp0_subject instanceof ArrayList)) {
        var tmp = access$_get_holder__kkflen(tmp4);
        var it = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        resumeReceiverOnClosedChannel($this, it);
      } else {
        var tmp_0 = access$_get_holder__kkflen(tmp4);
        var list = tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE();
        var inductionVariable_0 = list.m() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var it_0 = list.o(i);
            resumeReceiverOnClosedChannel($this, it_0);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
}
function resumeReceiverOnClosedChannel($this, _this__u8e3s4) {
  return resumeWaiterOnClosedChannel($this, _this__u8e3s4, true);
}
function resumeSenderOnCancelledChannel($this, _this__u8e3s4) {
  return resumeWaiterOnClosedChannel($this, _this__u8e3s4, false);
}
function resumeWaiterOnClosedChannel($this, _this__u8e3s4, receiver) {
  if (_this__u8e3s4 instanceof SendBroadcast) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = _this__u8e3s4.q1t_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
    this_0.y8(tmp$ret$0);
  } else {
    if (isInterface(_this__u8e3s4, CancellableContinuation)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = receiver ? _get_receiveException__foorc1($this) : $this.g1t();
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      _this__u8e3s4.y8(tmp$ret$2);
    } else {
      if (_this__u8e3s4 instanceof ReceiveCatching) {
        var tmp4 = _this__u8e3s4.n1t_1;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = new ChannelResult(Companion_getInstance_0().a1u($this.a1s()));
        var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
        tmp4.y8(tmp$ret$4);
      } else {
        if (_this__u8e3s4 instanceof BufferedChannelIterator) {
          _this__u8e3s4.w1t();
        } else {
          if (isInterface(_this__u8e3s4, SelectInstance))
            _this__u8e3s4.o1t($this, get_CHANNEL_CLOSED());
          else {
            // Inline function 'kotlin.error' call
            var message = 'Unexpected waiter: ' + toString(_this__u8e3s4);
            throw IllegalStateException_init_$Create$(toString(message));
          }
        }
      }
    }
  }
}
function _get_isClosedForSend0__kxgf9m($this, _this__u8e3s4) {
  return isClosed($this, _this__u8e3s4, false);
}
function _get_isClosedForReceive0__f7qknl($this, _this__u8e3s4) {
  return isClosed($this, _this__u8e3s4, true);
}
function isClosed($this, sendersAndCloseStatusCur, isClosedForReceive) {
  // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
  var tmp;
  switch (sendersAndCloseStatusCur.c3(60).d1()) {
    case 0:
      tmp = false;
      break;
    case 1:
      tmp = false;
      break;
    case 2:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$1 = sendersAndCloseStatusCur.e3(new Long(-1, 268435455));
      completeClose($this, tmp$ret$1);
      tmp = isClosedForReceive ? !$this.b1u() : true;
      break;
    case 3:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$2 = sendersAndCloseStatusCur.e3(new Long(-1, 268435455));
      completeCancel($this, tmp$ret$2);
      tmp = true;
      break;
    default:
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call

      var message = 'unexpected close status: ' + sendersAndCloseStatusCur.c3(60).d1();
      throw IllegalStateException_init_$Create$(toString(message));
  }
  return tmp;
}
function isCellNonEmpty($this, segment, index, globalIndex) {
  while (true) {
    var state = segment.t1q(index);
    if (state === null || state === get_IN_BUFFER()) {
      if (segment.v1q(index, state, get_POISONED())) {
        expandBuffer($this);
        return false;
      }
    } else if (state === get_BUFFERED())
      return true;
    else if (state === get_INTERRUPTED_SEND())
      return false;
    else if (state === get_CHANNEL_CLOSED())
      return false;
    else if (state === get_DONE_RCV())
      return false;
    else if (state === get_POISONED())
      return false;
    else if (state === get_RESUMING_BY_EB())
      return true;
    else if (state === get_RESUMING_BY_RCV())
      return false;
    else
      return globalIndex.equals($this.h1t());
  }
}
function findSegmentSend($this, id, startFrom) {
  var tmp0 = $this.d1r_1;
  var tmp3 = createSegmentFunction();
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp3);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp1 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.l1i_1.b1(tmp1.l1i_1) >= 0) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (!tmp1.n1r()) {
              tmp$ret$0 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp1)) {
              if (cur.o1r()) {
                cur.c4();
              }
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (tmp1.o1r()) {
              tmp1.c4();
            }
          }
          tmp$ret$0 = Unit_instance;
        }
        tmp = tmp$ret$0;
      }
      if (tmp) {
        tmp$ret$2 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$2;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    var tmp0_0 = startFrom.l1i_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    if (tmp0_0.t2(toLong(other)).b1($this.h1t()) < 0) {
      startFrom.v1r();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (segment.l1i_1.b1(id) > 0) {
      var tmp2 = segment.l1i_1;
      // Inline function 'kotlin.Long.times' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$4 = tmp2.t2(toLong(other_0));
      updateSendersCounterIfLower($this, tmp$ret$4);
      var tmp4 = segment.l1i_1;
      // Inline function 'kotlin.Long.times' call
      var other_1 = get_SEGMENT_SIZE();
      if (tmp4.t2(toLong(other_1)).b1($this.h1t()) < 0) {
        segment.v1r();
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function findSegmentReceive($this, id, startFrom) {
  var tmp0 = $this.e1r_1;
  var tmp3 = createSegmentFunction();
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp3);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp1 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.l1i_1.b1(tmp1.l1i_1) >= 0) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (!tmp1.n1r()) {
              tmp$ret$0 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp1)) {
              if (cur.o1r()) {
                cur.c4();
              }
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (tmp1.o1r()) {
              tmp1.c4();
            }
          }
          tmp$ret$0 = Unit_instance;
        }
        tmp = tmp$ret$0;
      }
      if (tmp) {
        tmp$ret$2 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$2;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    var tmp0_0 = startFrom.l1i_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    if (tmp0_0.t2(toLong(other)).b1($this.b1s()) < 0) {
      startFrom.v1r();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (!_get_isRendezvousOrUnlimited__3mdufi($this)) {
      var tmp2 = _get_bufferEndCounter__2d4hee($this);
      // Inline function 'kotlin.Long.div' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$4 = tmp2.u2(toLong(other_0));
      tmp_1 = id.b1(tmp$ret$4) <= 0;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp4 = $this.f1r_1;
      $l$block_5: {
        // Inline function 'kotlinx.coroutines.internal.moveForward' call
        while (true) {
          var cur_0 = tmp4.kotlinx$atomicfu$value;
          if (cur_0.l1i_1.b1(segment.l1i_1) >= 0) {
            break $l$block_5;
          }
          if (!segment.n1r()) {
            break $l$block_5;
          }
          if (tmp4.atomicfu$compareAndSet(cur_0, segment)) {
            if (cur_0.o1r()) {
              cur_0.c4();
            }
            break $l$block_5;
          }
          if (segment.o1r()) {
            segment.c4();
          }
        }
      }
    }
    var tmp_2;
    if (segment.l1i_1.b1(id) > 0) {
      var tmp6 = segment.l1i_1;
      // Inline function 'kotlin.Long.times' call
      var other_1 = get_SEGMENT_SIZE();
      var tmp$ret$7 = tmp6.t2(toLong(other_1));
      updateReceiversCounterIfLower($this, tmp$ret$7);
      var tmp8 = segment.l1i_1;
      // Inline function 'kotlin.Long.times' call
      var other_2 = get_SEGMENT_SIZE();
      if (tmp8.t2(toLong(other_2)).b1($this.b1s()) < 0) {
        segment.v1r();
      }
      tmp_2 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_2 = segment;
    }
    tmp_0 = tmp_2;
  }
  return tmp_0;
}
function findSegmentBufferEnd($this, id, startFrom, currentBufferEndCounter) {
  var tmp0 = $this.f1r_1;
  var tmp3 = createSegmentFunction();
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp3);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp1 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.l1i_1.b1(tmp1.l1i_1) >= 0) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (!tmp1.n1r()) {
              tmp$ret$0 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp1)) {
              if (cur.o1r()) {
                cur.c4();
              }
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (tmp1.o1r()) {
              tmp1.c4();
            }
          }
          tmp$ret$0 = Unit_instance;
        }
        tmp = tmp$ret$0;
      }
      if (tmp) {
        tmp$ret$2 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$2;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom);
    incCompletedExpandBufferAttempts$default($this);
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (segment.l1i_1.b1(id) > 0) {
      // Inline function 'kotlin.Long.plus' call
      var tmp_2 = currentBufferEndCounter.r2(toLong(1));
      var tmp2 = segment.l1i_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      var tmp$ret$4 = tmp2.t2(toLong(other));
      if ($this.b1r_1.atomicfu$compareAndSet(tmp_2, tmp$ret$4)) {
        var tmp4 = segment.l1i_1;
        // Inline function 'kotlin.Long.times' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$5 = tmp4.t2(toLong(other_0));
        incCompletedExpandBufferAttempts($this, tmp$ret$5.s2(currentBufferEndCounter));
      } else {
        incCompletedExpandBufferAttempts$default($this);
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom) {
  var segment = startFrom;
  $l$loop: while (segment.l1i_1.b1(id) < 0) {
    var tmp0_elvis_lhs = segment.r1r();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
  while (true) {
    $l$loop_0: while (segment.m1r()) {
      var tmp1_elvis_lhs = segment.r1r();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      segment = tmp_0;
    }
    var tmp0 = $this.f1r_1;
    var tmp1 = segment;
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.internal.moveForward' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (cur.l1i_1.b1(tmp1.l1i_1) >= 0) {
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (!tmp1.n1r()) {
          tmp$ret$0 = false;
          break $l$block_1;
        }
        if (tmp0.atomicfu$compareAndSet(cur, tmp1)) {
          if (cur.o1r()) {
            cur.c4();
          }
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (tmp1.o1r()) {
          tmp1.c4();
        }
      }
      tmp$ret$0 = Unit_instance;
    }
    if (tmp$ret$0)
      return Unit_instance;
  }
}
function updateSendersCounterIfLower($this, value) {
  var this_0 = $this.z1q_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var curCounter = cur.e3(new Long(-1, 268435455));
    if (curCounter.b1(value) >= 0)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp$ret$1 = cur.c3(60).d1();
    var update = constructSendersAndCloseStatus(curCounter, tmp$ret$1);
    if ($this.z1q_1.atomicfu$compareAndSet(cur, update))
      return Unit_instance;
  }
  return Unit_instance;
}
function updateReceiversCounterIfLower($this, value) {
  var this_0 = $this.a1r_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    if (cur.b1(value) >= 0)
      return Unit_instance;
    if ($this.a1r_1.atomicfu$compareAndSet(cur, value))
      return Unit_instance;
  }
  return Unit_instance;
}
function bindCancellationFunResult($this, _this__u8e3s4) {
  return BufferedChannel$onCancellationChannelResultImplDoNotCall$ref($this);
}
function onCancellationChannelResultImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.y1q_1), ensureNotNull(ChannelResult__getOrNull_impl_f5e07h(element)), context);
}
function bindCancellationFun($this, _this__u8e3s4, element) {
  return BufferedChannel$bindCancellationFun$lambda(_this__u8e3s4, element);
}
function bindCancellationFun_0($this, _this__u8e3s4) {
  return BufferedChannel$onCancellationImplDoNotCall$ref($this);
}
function onCancellationImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.y1q_1), element, context);
}
function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda($element, this$0, $select) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    var tmp;
    if (!($element === get_CHANNEL_CLOSED())) {
      callUndeliveredElement(this$0.y1q_1, ($element == null ? true : !($element == null)) ? $element : THROW_CCE(), $select.t8());
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this$0) {
  return function (select, _unused_var__etf5q3, element) {
    return BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda(element, this$0, select);
  };
}
function BufferedChannel$onCancellationChannelResultImplDoNotCall$ref($boundThis) {
  var l = function (p0, p1, p2) {
    onCancellationChannelResultImplDoNotCall($boundThis, p0, p1.d1u_1, p2);
    return Unit_instance;
  };
  l.callableName = 'onCancellationChannelResultImplDoNotCall';
  return l;
}
function BufferedChannel$bindCancellationFun$lambda($this_bindCancellationFun, $element) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, context) {
    callUndeliveredElement($this_bindCancellationFun, $element, context);
    return Unit_instance;
  };
}
function BufferedChannel$onCancellationImplDoNotCall$ref($boundThis) {
  var l = function (p0, p1, p2) {
    onCancellationImplDoNotCall($boundThis, p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onCancellationImplDoNotCall';
  return l;
}
function $sendCOROUTINE$5(_this__u8e3s4, element, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.m1u_1 = _this__u8e3s4;
  this.n1u_1 = element;
}
protoOf($sendCOROUTINE$5).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 11;
          var tmp_0 = this;
          tmp_0.o1u_1 = this.m1u_1;
          var tmp_1 = this;
          tmp_1.p1u_1 = this.n1u_1;
          var tmp_2 = this;
          tmp_2.q1u_1 = null;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.s1u_1 = this.o1u_1;
          this.t1u_1 = this.p1u_1;
          this.u1u_1 = this.q1u_1;
          this.v1u_1 = this.s1u_1.d1r_1.kotlinx$atomicfu$value;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (!true) {
            this.n8_1 = 12;
            continue $sm;
          }

          this.w1u_1 = this.s1u_1.z1q_1.atomicfu$getAndIncrement$long();
          var tmp_3 = this;
          tmp_3.x1u_1 = this.w1u_1.e3(new Long(-1, 268435455));
          this.y1u_1 = _get_isClosedForSend0__kxgf9m(this.s1u_1, this.w1u_1);
          var tmp_4 = this;
          var tmp0 = this.x1u_1;
          var other = get_SEGMENT_SIZE();
          tmp_4.z1u_1 = tmp0.u2(toLong(other));
          var tmp_5 = this;
          var tmp2 = this.x1u_1;
          var other_0 = get_SEGMENT_SIZE();
          tmp_5.a1v_1 = tmp2.v2(toLong(other_0)).d1();
          if (!this.v1u_1.l1i_1.equals(this.z1u_1)) {
            this.b1v_1 = findSegmentSend(this.s1u_1, this.z1u_1, this.v1u_1);
            if (this.b1v_1 == null) {
              if (this.y1u_1) {
                this.n8_1 = 10;
                suspendResult = onClosedSend(this.m1u_1, this.n1u_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n8_1 = 2;
                continue $sm;
              }
            } else {
              this.c1v_1 = this.b1v_1;
              this.n8_1 = 3;
              continue $sm;
            }
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 3:
          this.v1u_1 = this.c1v_1;
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.d1v_1 = updateCellSend(this.s1u_1, this.v1u_1, this.a1v_1, this.t1u_1, this.x1u_1, this.u1u_1, this.y1u_1);
          if (this.d1v_1 === 0) {
            this.v1u_1.v1r();
            var tmp_6 = this;
            tmp_6.r1u_1 = Unit_instance;
            this.n8_1 = 13;
            continue $sm;
          } else {
            if (this.d1v_1 === 1) {
              var tmp_7 = this;
              tmp_7.r1u_1 = Unit_instance;
              this.n8_1 = 13;
              continue $sm;
            } else {
              if (this.d1v_1 === 2) {
                if (this.y1u_1) {
                  this.v1u_1.l1r();
                  this.n8_1 = 9;
                  suspendResult = onClosedSend(this.m1u_1, this.n1u_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.n8_1 = 8;
                  continue $sm;
                }
              } else {
                if (this.d1v_1 === 4) {
                  if (this.x1u_1.b1(this.s1u_1.h1t()) < 0) {
                    this.v1u_1.v1r();
                  }
                  this.n8_1 = 7;
                  suspendResult = onClosedSend(this.m1u_1, this.n1u_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (this.d1v_1 === 5) {
                    this.v1u_1.v1r();
                    this.n8_1 = 2;
                    continue $sm;
                  } else {
                    if (this.d1v_1 === 3) {
                      var tmp_8 = this;
                      tmp_8.e1v_1 = this.v1u_1;
                      var tmp_9 = this;
                      tmp_9.f1v_1 = this.a1v_1;
                      var tmp_10 = this;
                      tmp_10.g1v_1 = this.t1u_1;
                      var tmp_11 = this;
                      tmp_11.h1v_1 = this.x1u_1;
                      this.i1v_1 = this.e1v_1;
                      this.j1v_1 = this.f1v_1;
                      this.k1v_1 = this.g1v_1;
                      this.l1v_1 = this.h1v_1;
                      this.n8_1 = 6;
                      suspendResult = sendOnNoWaiterSuspend(this.m1u_1, this.i1v_1, this.j1v_1, this.k1v_1, this.l1v_1, this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      this.n8_1 = 5;
                      continue $sm;
                    }
                  }
                }
              }
            }
          }

        case 5:
          this.n8_1 = 2;
          continue $sm;
        case 6:
          var tmp_12 = this;
          tmp_12.r1u_1 = Unit_instance;
          this.n8_1 = 13;
          continue $sm;
        case 7:
          var tmp_13 = this;
          tmp_13.r1u_1 = Unit_instance;
          this.n8_1 = 13;
          continue $sm;
        case 8:
          var tmp_14 = this.u1u_1;
          var tmp2_safe_receiver = (!(tmp_14 == null) ? isInterface(tmp_14, Waiter) : false) ? tmp_14 : null;
          if (tmp2_safe_receiver == null)
            null;
          else {
            prepareSenderForSuspension(this.s1u_1, tmp2_safe_receiver, this.v1u_1, this.a1v_1);
          }

          var tmp_15 = this;
          this.v1u_1;
          this.a1v_1;
          tmp_15.r1u_1 = Unit_instance;
          this.n8_1 = 13;
          continue $sm;
        case 9:
          var tmp_16 = this;
          tmp_16.r1u_1 = Unit_instance;
          this.n8_1 = 13;
          continue $sm;
        case 10:
          var tmp_17 = this;
          tmp_17.r1u_1 = Unit_instance;
          this.n8_1 = 13;
          continue $sm;
        case 11:
          throw this.q8_1;
        case 12:
          if (false) {
            this.n8_1 = 1;
            continue $sm;
          }

          this.n8_1 = 13;
          continue $sm;
        case 13:
          return Unit_instance;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 11) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $receiveCOROUTINE$6(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.u1v_1 = _this__u8e3s4;
}
protoOf($receiveCOROUTINE$6).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 8;
          var tmp_0 = this;
          tmp_0.v1v_1 = this.u1v_1;
          var tmp_1 = this;
          tmp_1.w1v_1 = null;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.y1v_1 = this.v1v_1;
          this.z1v_1 = this.w1v_1;
          this.a1w_1 = this.y1v_1.e1r_1.kotlinx$atomicfu$value;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (!true) {
            this.n8_1 = 9;
            continue $sm;
          }

          if (this.y1v_1.c1s()) {
            var tmp_2 = this;
            throw recoverStackTrace_0(_get_receiveException__foorc1(this.u1v_1));
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 3:
          this.b1w_1 = this.y1v_1.a1r_1.atomicfu$getAndIncrement$long();
          var tmp_3 = this;
          var tmp0 = this.b1w_1;
          var other = get_SEGMENT_SIZE();
          tmp_3.c1w_1 = tmp0.u2(toLong(other));
          var tmp_4 = this;
          var tmp2 = this.b1w_1;
          var other_0 = get_SEGMENT_SIZE();
          tmp_4.d1w_1 = tmp2.v2(toLong(other_0)).d1();
          if (!this.a1w_1.l1i_1.equals(this.c1w_1)) {
            this.e1w_1 = findSegmentReceive(this.y1v_1, this.c1w_1, this.a1w_1);
            if (this.e1w_1 == null) {
              this.n8_1 = 2;
              var tmp_5 = this;
              continue $sm;
            } else {
              this.f1w_1 = this.e1w_1;
              this.n8_1 = 4;
              continue $sm;
            }
          } else {
            this.n8_1 = 5;
            continue $sm;
          }

        case 4:
          this.a1w_1 = this.f1w_1;
          this.n8_1 = 5;
          continue $sm;
        case 5:
          this.g1w_1 = updateCellReceive(this.y1v_1, this.a1w_1, this.d1w_1, this.b1w_1, this.z1v_1);
          if (this.g1w_1 === get_SUSPEND()) {
            var tmp_6 = this;
            var tmp_7 = this.z1v_1;
            var tmp1_safe_receiver = (!(tmp_7 == null) ? isInterface(tmp_7, Waiter) : false) ? tmp_7 : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              prepareReceiverForSuspension(this.y1v_1, tmp1_safe_receiver, this.a1w_1, this.d1w_1);
            }
            this.a1w_1;
            this.d1w_1;
            this.b1w_1;
            var message = 'unexpected';
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            if (this.g1w_1 === get_FAILED()) {
              if (this.b1w_1.b1(this.y1v_1.b1s()) < 0) {
                this.a1w_1.v1r();
              }
              this.n8_1 = 2;
              var tmp_8 = this;
              continue $sm;
            } else {
              if (this.g1w_1 === get_SUSPEND_NO_WAITER()) {
                var tmp_9 = this;
                tmp_9.i1w_1 = this.a1w_1;
                var tmp_10 = this;
                tmp_10.j1w_1 = this.d1w_1;
                var tmp_11 = this;
                tmp_11.k1w_1 = this.b1w_1;
                this.l1w_1 = this.i1w_1;
                this.m1w_1 = this.j1w_1;
                this.n1w_1 = this.k1w_1;
                this.n8_1 = 6;
                suspendResult = receiveOnNoWaiterSuspend(this.u1v_1, this.l1w_1, this.m1w_1, this.n1w_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_12 = this;
                this.a1w_1.v1r();
                var tmp_13 = this.g1w_1;
                return (tmp_13 == null ? true : !(tmp_13 == null)) ? tmp_13 : THROW_CCE();
              }
            }
          }

        case 6:
          this.h1w_1 = suspendResult;
          this.n8_1 = 7;
          continue $sm;
        case 7:
          this.x1v_1 = this.h1w_1;
          this.n8_1 = 10;
          continue $sm;
        case 8:
          throw this.q8_1;
        case 9:
          if (false) {
            this.n8_1 = 1;
            continue $sm;
          }

          this.n8_1 = 10;
          continue $sm;
        case 10:
          return this.x1v_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 8) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function BufferedChannel(capacity, onUndeliveredElement) {
  onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
  this.x1q_1 = capacity;
  this.y1q_1 = onUndeliveredElement;
  // Inline function 'kotlin.require' call
  if (!(this.x1q_1 >= 0)) {
    var message = 'Invalid channel capacity: ' + this.x1q_1 + ', should be >=0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  this.z1q_1 = atomic$long$1(new Long(0, 0));
  this.a1r_1 = atomic$long$1(new Long(0, 0));
  this.b1r_1 = atomic$long$1(initialBufferEnd(this.x1q_1));
  this.c1r_1 = atomic$long$1(_get_bufferEndCounter__2d4hee(this));
  var firstSegment = new ChannelSegment(new Long(0, 0), null, this, 3);
  this.d1r_1 = atomic$ref$1(firstSegment);
  this.e1r_1 = atomic$ref$1(firstSegment);
  var tmp = this;
  var tmp_0;
  if (_get_isRendezvousOrUnlimited__3mdufi(this)) {
    var tmp_1 = get_NULL_SEGMENT();
    tmp_0 = tmp_1 instanceof ChannelSegment ? tmp_1 : THROW_CCE();
  } else {
    tmp_0 = firstSegment;
  }
  tmp.f1r_1 = atomic$ref$1(tmp_0);
  var tmp_2 = this;
  var tmp_3;
  if (this.y1q_1 == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this);
  }
  tmp_2.g1r_1 = tmp_3;
  this.h1r_1 = atomic$ref$1(get_NO_CLOSE_CAUSE());
  this.i1r_1 = atomic$ref$1(null);
}
protoOf(BufferedChannel).b1s = function () {
  // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
  return this.z1q_1.kotlinx$atomicfu$value.e3(new Long(-1, 268435455));
};
protoOf(BufferedChannel).h1t = function () {
  return this.a1r_1.kotlinx$atomicfu$value;
};
protoOf(BufferedChannel).o1w = function (element, $completion) {
  var tmp = new $sendCOROUTINE$5(this, element, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BufferedChannel).p1w = function (element) {
  if (shouldSendSuspend0(this, this.z1q_1.kotlinx$atomicfu$value))
    return Companion_getInstance_0().q1w();
  var tmp2 = get_INTERRUPTED_SEND();
  var tmp$ret$4;
  $l$block_4: {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
    var segment = this.d1r_1.kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      var sendersAndCloseStatusCur = this.z1q_1.atomicfu$getAndIncrement$long();
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var s = sendersAndCloseStatusCur.e3(new Long(-1, 268435455));
      var closed = _get_isClosedForSend0__kxgf9m(this, sendersAndCloseStatusCur);
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = s.u2(toLong(other));
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var i = s.v2(toLong(other_0)).d1();
      if (!segment.l1i_1.equals(id)) {
        var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp_0;
          if (closed) {
            tmp$ret$4 = Companion_getInstance_0().a1u(this.g1t());
            break $l$block_4;
          } else {
            continue $l$loop_0;
          }
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      switch (updateCellSend(this, segment, i, element, s, tmp2, closed)) {
        case 0:
          segment.v1r();
          tmp$ret$4 = Companion_getInstance_0().m1t(Unit_instance);
          break $l$block_4;
        case 1:
          tmp$ret$4 = Companion_getInstance_0().m1t(Unit_instance);
          break $l$block_4;
        case 2:
          if (closed) {
            segment.l1r();
            tmp$ret$4 = Companion_getInstance_0().a1u(this.g1t());
            break $l$block_4;
          }

          var tmp2_safe_receiver = (!(tmp2 == null) ? isInterface(tmp2, Waiter) : false) ? tmp2 : null;
          if (tmp2_safe_receiver == null)
            null;
          else {
            prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
          }

          segment.l1r();
          tmp$ret$4 = Companion_getInstance_0().q1w();
          break $l$block_4;
        case 4:
          if (s.b1(this.h1t()) < 0) {
            segment.v1r();
          }

          tmp$ret$4 = Companion_getInstance_0().a1u(this.g1t());
          break $l$block_4;
        case 5:
          segment.v1r();
          continue $l$loop_0;
        case 3:
          var message = 'unexpected';
          throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  return tmp$ret$4;
};
protoOf(BufferedChannel).r1w = function (element) {
  var tmp$ret$3;
  // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
  var waiter = get_BUFFERED();
  var segment = this.d1r_1.kotlinx$atomicfu$value;
  $l$loop_0: while (true) {
    var sendersAndCloseStatusCur = this.z1q_1.atomicfu$getAndIncrement$long();
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var s = sendersAndCloseStatusCur.e3(new Long(-1, 268435455));
    var closed = _get_isClosedForSend0__kxgf9m(this, sendersAndCloseStatusCur);
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE();
    var id = s.u2(toLong(other));
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE();
    var i = s.v2(toLong(other_0)).d1();
    if (!segment.l1i_1.equals(id)) {
      var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp_0;
        if (closed) {
          return Companion_getInstance_0().a1u(this.g1t());
        } else {
          continue $l$loop_0;
        }
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    switch (updateCellSend(this, segment, i, element, s, waiter, closed)) {
      case 0:
        segment.v1r();
        return Companion_getInstance_0().m1t(Unit_instance);
      case 1:
        return Companion_getInstance_0().m1t(Unit_instance);
      case 2:
        if (closed) {
          segment.l1r();
          return Companion_getInstance_0().a1u(this.g1t());
        }

        var tmp2_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter) : false) ? waiter : null;
        if (tmp2_safe_receiver == null)
          null;
        else {
          prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
        }

        var tmp4 = segment.l1i_1;
        // Inline function 'kotlin.Long.times' call

        var other_1 = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call

        var tmp$ret$5 = tmp4.t2(toLong(other_1)).r2(toLong(i));
        this.y1t(tmp$ret$5);
        return Companion_getInstance_0().m1t(Unit_instance);
      case 4:
        if (s.b1(this.h1t()) < 0) {
          segment.v1r();
        }

        return Companion_getInstance_0().a1u(this.g1t());
      case 5:
        segment.v1r();
        continue $l$loop_0;
      case 3:
        var message = 'unexpected';
        throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  return tmp$ret$3;
};
protoOf(BufferedChannel).p1t = function () {
};
protoOf(BufferedChannel).i1t = function () {
};
protoOf(BufferedChannel).s1w = function ($completion) {
  var tmp = new $receiveCOROUTINE$6(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BufferedChannel).y1t = function (globalCellIndex) {
  // Inline function 'kotlinx.coroutines.assert' call
  var segment = this.e1r_1.kotlinx$atomicfu$value;
  $l$loop_0: while (true) {
    var r = this.a1r_1.kotlinx$atomicfu$value;
    // Inline function 'kotlin.Long.plus' call
    var other = this.x1q_1;
    var tmp2 = r.r2(toLong(other));
    // Inline function 'kotlin.math.max' call
    var b = _get_bufferEndCounter__2d4hee(this);
    var tmp$ret$2 = tmp2.b1(b) >= 0 ? tmp2 : b;
    if (globalCellIndex.b1(tmp$ret$2) < 0)
      return Unit_instance;
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$3 = r.r2(toLong(1));
    if (!this.a1r_1.atomicfu$compareAndSet(r, tmp$ret$3))
      continue $l$loop_0;
    // Inline function 'kotlin.Long.div' call
    var other_0 = get_SEGMENT_SIZE();
    var id = r.u2(toLong(other_0));
    // Inline function 'kotlin.Long.rem' call
    var other_1 = get_SEGMENT_SIZE();
    var i = r.v2(toLong(other_1)).d1();
    if (!segment.l1i_1.equals(id)) {
      var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    var updCellResult = updateCellReceive(this, segment, i, r, null);
    if (updCellResult === get_FAILED()) {
      if (r.b1(this.b1s()) < 0) {
        segment.v1r();
      }
    } else {
      segment.v1r();
      var tmp1_safe_receiver = this.y1q_1;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = callUndeliveredElementCatchingException(tmp1_safe_receiver, (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE());
      }
      var tmp2_safe_receiver = tmp_0;
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        throw tmp2_safe_receiver;
      }
    }
  }
};
protoOf(BufferedChannel).k1r = function (globalIndex) {
  if (_get_isRendezvousOrUnlimited__3mdufi(this))
    return Unit_instance;
  while (_get_bufferEndCounter__2d4hee(this).b1(globalIndex) <= 0) {
  }
  // Inline function 'kotlin.repeat' call
  var times = get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS();
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = _get_bufferEndCounter__2d4hee(this);
      // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
      var ebCompleted = this.c1r_1.kotlinx$atomicfu$value.e3(new Long(-1, 1073741823));
      if (b.equals(ebCompleted) && b.equals(_get_bufferEndCounter__2d4hee(this)))
        return Unit_instance;
    }
     while (inductionVariable < times);
  var tmp2 = this.c1r_1;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp2.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
      var tmp$ret$3 = cur.e3(new Long(-1, 1073741823));
      var upd = constructEBCompletedAndPauseFlag(tmp$ret$3, true);
      if (tmp2.atomicfu$compareAndSet(cur, upd)) {
        break $l$block;
      }
    }
  }
  while (true) {
    var b_0 = _get_bufferEndCounter__2d4hee(this);
    var ebCompletedAndBit = this.c1r_1.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
    var ebCompleted_0 = ebCompletedAndBit.e3(new Long(-1, 1073741823));
    // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
    var pauseExpandBuffers = !ebCompletedAndBit.e3(new Long(0, 1073741824)).equals(new Long(0, 0));
    if (b_0.equals(ebCompleted_0) && b_0.equals(_get_bufferEndCounter__2d4hee(this))) {
      var tmp4 = this.c1r_1;
      $l$block_0: {
        // Inline function 'kotlinx.atomicfu.update' call
        while (true) {
          var cur_0 = tmp4.kotlinx$atomicfu$value;
          // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
          var tmp$ret$8 = cur_0.e3(new Long(-1, 1073741823));
          var upd_0 = constructEBCompletedAndPauseFlag(tmp$ret$8, false);
          if (tmp4.atomicfu$compareAndSet(cur_0, upd_0)) {
            break $l$block_0;
          }
        }
      }
      return Unit_instance;
    }
    if (!pauseExpandBuffers) {
      this.c1r_1.atomicfu$compareAndSet(ebCompletedAndBit, constructEBCompletedAndPauseFlag(ebCompleted_0, true));
    }
  }
};
protoOf(BufferedChannel).j = function () {
  return new BufferedChannelIterator(this);
};
protoOf(BufferedChannel).a1s = function () {
  var tmp = this.h1r_1.kotlinx$atomicfu$value;
  return (tmp == null ? true : tmp instanceof Error) ? tmp : THROW_CCE();
};
protoOf(BufferedChannel).g1t = function () {
  var tmp0_elvis_lhs = this.a1s();
  return tmp0_elvis_lhs == null ? new ClosedSendChannelException('Channel was closed') : tmp0_elvis_lhs;
};
protoOf(BufferedChannel).t1w = function () {
};
protoOf(BufferedChannel).u1w = function (cause) {
  return this.v1w(cause, false);
};
protoOf(BufferedChannel).r1f = function (cause) {
  this.x1w(cause);
};
protoOf(BufferedChannel).x1w = function (cause) {
  return this.v1w(cause == null ? CancellationException_init_$Create$('Channel was cancelled') : cause, true);
};
protoOf(BufferedChannel).v1w = function (cause, cancel) {
  if (cancel) {
    markCancellationStarted(this);
  }
  var closedByThisOperation = this.h1r_1.atomicfu$compareAndSet(get_NO_CLOSE_CAUSE(), cause);
  if (cancel) {
    markCancelled(this);
  } else {
    markClosed(this);
  }
  completeCloseOrCancel(this);
  // Inline function 'kotlin.also' call
  this.t1w();
  if (closedByThisOperation) {
    invokeCloseHandler(this);
  }
  return closedByThisOperation;
};
protoOf(BufferedChannel).z1w = function (handler) {
  if (this.i1r_1.atomicfu$compareAndSet(null, handler)) {
    return Unit_instance;
  }
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.i1r_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    if (cur === get_CLOSE_HANDLER_CLOSED()) {
      if (this.i1r_1.atomicfu$compareAndSet(get_CLOSE_HANDLER_CLOSED(), get_CLOSE_HANDLER_INVOKED())) {
        handler(this.a1s());
        return Unit_instance;
      }
    } else if (cur === get_CLOSE_HANDLER_INVOKED()) {
      // Inline function 'kotlin.error' call
      var message = 'Another handler was already registered and successfully invoked';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      // Inline function 'kotlin.error' call
      var message_0 = 'Another handler is already registered: ' + toString_0(cur);
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
  }
};
protoOf(BufferedChannel).z1t = function () {
  return false;
};
protoOf(BufferedChannel).x1t = function () {
  return _get_isClosedForSend0__kxgf9m(this, this.z1q_1.kotlinx$atomicfu$value);
};
protoOf(BufferedChannel).c1s = function () {
  return _get_isClosedForReceive0__f7qknl(this, this.z1q_1.kotlinx$atomicfu$value);
};
protoOf(BufferedChannel).b1u = function () {
  $l$loop: while (true) {
    var segment = this.e1r_1.kotlinx$atomicfu$value;
    var r = this.h1t();
    var s = this.b1s();
    if (s.b1(r) <= 0)
      return false;
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE();
    var id = r.u2(toLong(other));
    if (!segment.l1i_1.equals(id)) {
      var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp_0;
        if (this.e1r_1.kotlinx$atomicfu$value.l1i_1.b1(id) < 0) {
          return false;
        } else {
          continue $l$loop;
        }
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    segment.v1r();
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE();
    var i = r.v2(toLong(other_0)).d1();
    if (isCellNonEmpty(this, segment, i, r))
      return true;
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$2 = r.r2(toLong(1));
    this.a1r_1.atomicfu$compareAndSet(r, tmp$ret$2);
  }
};
protoOf(BufferedChannel).toString = function () {
  var sb = StringBuilder_init_$Create$();
  // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
  var tmp0_subject = this.z1q_1.kotlinx$atomicfu$value.c3(60).d1();
  if (tmp0_subject === 2) {
    sb.b8('closed,');
  } else if (tmp0_subject === 3) {
    sb.b8('cancelled,');
  }
  sb.b8('capacity=' + this.x1q_1 + ',');
  sb.b8('data=[');
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = listOf([this.e1r_1.kotlinx$atomicfu$value, this.d1r_1.kotlinx$atomicfu$value, this.f1r_1.kotlinx$atomicfu$value]);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!(element === get_NULL_SEGMENT())) {
      destination.e(element);
    }
  }
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.collections.minBy' call
    var iterator = destination.j();
    if (!iterator.k())
      throw NoSuchElementException_init_$Create$();
    var minElem = iterator.l();
    if (!iterator.k()) {
      tmp$ret$4 = minElem;
      break $l$block;
    }
    var minValue = minElem.l1i_1;
    do {
      var e = iterator.l();
      var v = e.l1i_1;
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.k());
    tmp$ret$4 = minElem;
  }
  var firstSegment = tmp$ret$4;
  var r = this.h1t();
  var s = this.b1s();
  var segment = firstSegment;
  append_elements: while (true) {
    var inductionVariable = 0;
    var last_0 = get_SEGMENT_SIZE();
    if (inductionVariable < last_0)
      process_cell: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp5 = segment.l1i_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var globalCellIndex = tmp5.t2(toLong(other)).r2(toLong(i));
        if (globalCellIndex.b1(s) >= 0 && globalCellIndex.b1(r) >= 0)
          break append_elements;
        var cellState = segment.t1q(i);
        var element_0 = segment.q1q(i);
        var tmp;
        if (!(cellState == null) ? isInterface(cellState, CancellableContinuation) : false) {
          tmp = globalCellIndex.b1(r) < 0 && globalCellIndex.b1(s) >= 0 ? 'receive' : globalCellIndex.b1(s) < 0 && globalCellIndex.b1(r) >= 0 ? 'send' : 'cont';
        } else {
          if (!(cellState == null) ? isInterface(cellState, SelectInstance) : false) {
            tmp = globalCellIndex.b1(r) < 0 && globalCellIndex.b1(s) >= 0 ? 'onReceive' : globalCellIndex.b1(s) < 0 && globalCellIndex.b1(r) >= 0 ? 'onSend' : 'select';
          } else {
            if (cellState instanceof ReceiveCatching) {
              tmp = 'receiveCatching';
            } else {
              if (cellState instanceof SendBroadcast) {
                tmp = 'sendBroadcast';
              } else {
                if (cellState instanceof WaiterEB) {
                  tmp = 'EB(' + cellState.toString() + ')';
                } else {
                  if (equals(cellState, get_RESUMING_BY_RCV()) || equals(cellState, get_RESUMING_BY_EB())) {
                    tmp = 'resuming_sender';
                  } else {
                    if (cellState == null || (equals(cellState, get_IN_BUFFER()) || equals(cellState, get_DONE_RCV())) || (equals(cellState, get_POISONED()) || equals(cellState, get_INTERRUPTED_RCV()) || (equals(cellState, get_INTERRUPTED_SEND()) || equals(cellState, get_CHANNEL_CLOSED())))) {
                      continue process_cell;
                    } else {
                      tmp = toString(cellState);
                    }
                  }
                }
              }
            }
          }
        }
        var cellStateString = tmp;
        if (!(element_0 == null)) {
          sb.b8('(' + cellStateString + ',' + toString_0(element_0) + '),');
        } else {
          sb.b8(cellStateString + ',');
        }
      }
       while (inductionVariable < last_0);
    var tmp2_elvis_lhs = segment.r1r();
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      break append_elements;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    segment = tmp_0;
  }
  if (last(sb) === _Char___init__impl__6a9atx(44)) {
    sb.nc(sb.a() - 1 | 0);
  }
  sb.b8(']');
  return sb.toString();
};
function WaiterEB(waiter) {
  this.j1t_1 = waiter;
}
protoOf(WaiterEB).toString = function () {
  return 'WaiterEB(' + toString(this.j1t_1) + ')';
};
function initialBufferEnd(capacity) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  switch (capacity) {
    case 0:
      return new Long(0, 0);
    case 2147483647:
      return new Long(-1, 2147483647);
    default:
      return toLong(capacity);
  }
}
function ReceiveCatching() {
}
function tryResume0(_this__u8e3s4, value, onCancellation) {
  onCancellation = onCancellation === VOID ? null : onCancellation;
  _init_properties_BufferedChannel_kt__d6uc4y();
  // Inline function 'kotlin.let' call
  var token = _this__u8e3s4.j1h(value, null, onCancellation);
  var tmp;
  if (!(token == null)) {
    _this__u8e3s4.k1h(token);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function constructEBCompletedAndPauseFlag(counter, pauseEB) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return (pauseEB ? new Long(0, 1073741824) : new Long(0, 0)).r2(counter);
}
function constructSendersAndCloseStatus(counter, closeStatus) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return toLong(closeStatus).b3(60).r2(counter);
}
function createSegmentFunction() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return createSegment$ref();
}
function createSegment(id, prev) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return new ChannelSegment(id, prev, prev.n1q(), 0);
}
function createSegment$ref() {
  var l = function (p0, p1) {
    return createSegment(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
var properties_initialized_BufferedChannel_kt_58tjvw;
function _init_properties_BufferedChannel_kt__d6uc4y() {
  if (!properties_initialized_BufferedChannel_kt_58tjvw) {
    properties_initialized_BufferedChannel_kt_58tjvw = true;
    NULL_SEGMENT = new ChannelSegment(new Long(-1, -1), null, null, 0);
    SEGMENT_SIZE = systemProp('kotlinx.coroutines.bufferedChannel.segmentSize', 32);
    EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS = systemProp('kotlinx.coroutines.bufferedChannel.expandBufferCompletionWaitIterations', 10000);
    BUFFERED = new Symbol('BUFFERED');
    IN_BUFFER = new Symbol('SHOULD_BUFFER');
    RESUMING_BY_RCV = new Symbol('S_RESUMING_BY_RCV');
    RESUMING_BY_EB = new Symbol('RESUMING_BY_EB');
    POISONED = new Symbol('POISONED');
    DONE_RCV = new Symbol('DONE_RCV');
    INTERRUPTED_SEND = new Symbol('INTERRUPTED_SEND');
    INTERRUPTED_RCV = new Symbol('INTERRUPTED_RCV');
    CHANNEL_CLOSED = new Symbol('CHANNEL_CLOSED');
    SUSPEND = new Symbol('SUSPEND');
    SUSPEND_NO_WAITER = new Symbol('SUSPEND_NO_WAITER');
    FAILED = new Symbol('FAILED');
    NO_RECEIVE_RESULT = new Symbol('NO_RECEIVE_RESULT');
    CLOSE_HANDLER_CLOSED = new Symbol('CLOSE_HANDLER_CLOSED');
    CLOSE_HANDLER_INVOKED = new Symbol('CLOSE_HANDLER_INVOKED');
    NO_CLOSE_CAUSE = new Symbol('NO_CLOSE_CAUSE');
  }
}
function Factory() {
  Factory_instance = this;
  this.a1x_1 = 2147483647;
  this.b1x_1 = 0;
  this.c1x_1 = -1;
  this.d1x_1 = -2;
  this.e1x_1 = -3;
  this.f1x_1 = 'kotlinx.coroutines.channels.defaultBuffer';
  this.g1x_1 = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
}
var Factory_instance;
function Factory_getInstance() {
  if (Factory_instance == null)
    new Factory();
  return Factory_instance;
}
function _ChannelResult___init__impl__siwsuf(holder) {
  return holder;
}
function _ChannelResult___get_holder__impl__pm9gzw($this) {
  return $this;
}
function _ChannelResult___get_isSuccess__impl__odq1z9($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return !(tmp instanceof Failed);
}
function _ChannelResult___get_isClosed__impl__mg7kuu($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return tmp instanceof Closed;
}
function ChannelResult__getOrNull_impl_f5e07h($this) {
  var tmp;
  var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
  if (!(tmp_0 instanceof Failed)) {
    var tmp_1 = _ChannelResult___get_holder__impl__pm9gzw($this);
    tmp = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
  } else {
    tmp = null;
  }
  return tmp;
}
function ChannelResult__exceptionOrNull_impl_16ei30($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h1x_1;
}
function Failed() {
}
protoOf(Failed).toString = function () {
  return 'Failed';
};
function Closed(cause) {
  Failed.call(this);
  this.h1x_1 = cause;
}
protoOf(Closed).equals = function (other) {
  var tmp;
  if (other instanceof Closed) {
    tmp = equals(this.h1x_1, other.h1x_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(Closed).hashCode = function () {
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver = this.h1x_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
};
protoOf(Closed).toString = function () {
  return 'Closed(' + toString_0(this.h1x_1) + ')';
};
function Companion() {
  Companion_instance_0 = this;
  this.l1t_1 = new Failed();
}
protoOf(Companion).m1t = function (value) {
  return _ChannelResult___init__impl__siwsuf(value);
};
protoOf(Companion).q1w = function () {
  return _ChannelResult___init__impl__siwsuf(this.l1t_1);
};
protoOf(Companion).a1u = function (cause) {
  return _ChannelResult___init__impl__siwsuf(new Closed(cause));
};
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 == null)
    new Companion();
  return Companion_instance_0;
}
function ChannelResult__toString_impl_rrcqu7($this) {
  var tmp;
  if (_ChannelResult___get_holder__impl__pm9gzw($this) instanceof Closed) {
    tmp = _ChannelResult___get_holder__impl__pm9gzw($this).toString();
  } else {
    tmp = 'Value(' + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this)) + ')';
  }
  return tmp;
}
function ChannelResult__hashCode_impl_lilec2($this) {
  return $this == null ? 0 : hashCode($this);
}
function ChannelResult__equals_impl_f471ri($this, other) {
  if (!(other instanceof ChannelResult))
    return false;
  var tmp0_other_with_cast = other instanceof ChannelResult ? other.d1u_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function ChannelResult(holder) {
  Companion_getInstance_0();
  this.d1u_1 = holder;
}
protoOf(ChannelResult).toString = function () {
  return ChannelResult__toString_impl_rrcqu7(this.d1u_1);
};
protoOf(ChannelResult).hashCode = function () {
  return ChannelResult__hashCode_impl_lilec2(this.d1u_1);
};
protoOf(ChannelResult).equals = function (other) {
  return ChannelResult__equals_impl_f471ri(this.d1u_1, other);
};
function ClosedSendChannelException(message) {
  IllegalStateException_init_$Init$(message, this);
  captureStack(this, ClosedSendChannelException);
}
function ClosedReceiveChannelException(message) {
  NoSuchElementException_init_$Init$(message, this);
  captureStack(this, ClosedReceiveChannelException);
}
function SendChannel() {
}
function ReceiveChannel() {
}
function Channel(capacity, onBufferOverflow, onUndeliveredElement) {
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
  var tmp;
  switch (capacity) {
    case 0:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(0, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
      break;
    case -1:
      // Inline function 'kotlin.require' call

      if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
        var message = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }

      tmp = new ConflatedBufferedChannel(1, BufferOverflow_DROP_OLDEST_getInstance(), onUndeliveredElement);
      break;
    case 2147483647:
      tmp = new BufferedChannel(2147483647, onUndeliveredElement);
      break;
    case -2:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(Factory_getInstance().g1x_1, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
      break;
    default:
      tmp = onBufferOverflow === BufferOverflow_SUSPEND_getInstance() ? new BufferedChannel(capacity, onUndeliveredElement) : new ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement);
      break;
  }
  return tmp;
}
function ChannelCoroutine(parentContext, _channel, initParentJob, active) {
  AbstractCoroutine.call(this, parentContext, initParentJob, active);
  this.l1x_1 = _channel;
}
protoOf(ChannelCoroutine).r1f = function (cause) {
  if (this.e1f())
    return Unit_instance;
  var tmp;
  if (cause == null) {
    // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
    tmp = new JobCancellationException(null == null ? this.l1e() : null, null, this);
  } else {
    tmp = cause;
  }
  this.t1f(tmp);
};
protoOf(ChannelCoroutine).y1w = function (cause, $super) {
  return this.s1f(cause, ($super == null ? true : $super instanceof ChannelCoroutine) ? $super : THROW_CCE());
};
protoOf(ChannelCoroutine).t1f = function (cause) {
  var exception = this.j1f(cause);
  this.l1x_1.r1f(exception);
  this.w1f(exception);
};
protoOf(ChannelCoroutine).x1t = function () {
  return this.l1x_1.x1t();
};
protoOf(ChannelCoroutine).o1w = function (element, $completion) {
  return this.l1x_1.o1w(element, $completion);
};
protoOf(ChannelCoroutine).p1w = function (element) {
  return this.l1x_1.p1w(element);
};
protoOf(ChannelCoroutine).u1w = function (cause) {
  return this.l1x_1.u1w(cause);
};
protoOf(ChannelCoroutine).z1w = function (handler) {
  this.l1x_1.z1w(handler);
};
protoOf(ChannelCoroutine).s1w = function ($completion) {
  return this.l1x_1.s1w($completion);
};
protoOf(ChannelCoroutine).j = function () {
  return this.l1x_1.j();
};
function cancelConsumed(_this__u8e3s4, cause) {
  var tmp;
  if (cause == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_elvis_lhs = cause instanceof CancellationException ? cause : null;
    tmp = tmp0_elvis_lhs == null ? CancellationException_0('Channel was consumed, consumer had failed', cause) : tmp0_elvis_lhs;
  }
  _this__u8e3s4.r1f(tmp);
}
function trySendImpl($this, element, isSendOp) {
  return $this.z1x_1 === BufferOverflow_DROP_LATEST_getInstance() ? trySendDropLatest($this, element, isSendOp) : $this.r1w(element);
}
function trySendDropLatest($this, element, isSendOp) {
  var result = protoOf(BufferedChannel).p1w.call($this, element);
  if (_ChannelResult___get_isSuccess__impl__odq1z9(result) || _ChannelResult___get_isClosed__impl__mg7kuu(result))
    return result;
  if (isSendOp) {
    var tmp0_safe_receiver = $this.y1q_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp1_safe_receiver;
    }
  }
  return Companion_getInstance_0().m1t(Unit_instance);
}
function ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement) {
  onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
  BufferedChannel.call(this, capacity, onUndeliveredElement);
  this.y1x_1 = capacity;
  this.z1x_1 = onBufferOverflow;
  // Inline function 'kotlin.require' call
  if (!!(this.z1x_1 === BufferOverflow_SUSPEND_getInstance())) {
    var message = 'This implementation does not support suspension for senders, use ' + getKClass(BufferedChannel).pa() + ' instead';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.y1x_1 >= 1)) {
    var message_0 = 'Buffered channel capacity must be at least 1, but ' + this.y1x_1 + ' was specified';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(ConflatedBufferedChannel).z1t = function () {
  return this.z1x_1.equals(BufferOverflow_DROP_OLDEST_getInstance());
};
protoOf(ConflatedBufferedChannel).o1w = function (element, $completion) {
  // Inline function 'kotlinx.coroutines.channels.onClosed' call
  var this_0 = trySendImpl(this, element, true);
  var tmp = _ChannelResult___get_holder__impl__pm9gzw(this_0);
  if (tmp instanceof Closed) {
    ChannelResult__exceptionOrNull_impl_16ei30(this_0);
    var tmp0_safe_receiver = this.y1q_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      addSuppressed(tmp1_safe_receiver, this.g1t());
      throw tmp1_safe_receiver;
    }
    throw this.g1t();
  }
  return Unit_instance;
};
protoOf(ConflatedBufferedChannel).p1w = function (element) {
  return trySendImpl(this, element, false);
};
function ProducerScope() {
}
function produce(_this__u8e3s4, context, capacity, onBufferOverflow, start, onCompletion, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  onCompletion = onCompletion === VOID ? null : onCompletion;
  var channel = Channel(capacity, onBufferOverflow);
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = new ProducerCoroutine(newContext, channel);
  if (!(onCompletion == null)) {
    coroutine.k1f(onCompletion);
  }
  coroutine.v1e(start, coroutine, block);
  return coroutine;
}
function ProducerCoroutine(parentContext, channel) {
  ChannelCoroutine.call(this, parentContext, channel, true, true);
}
protoOf(ProducerCoroutine).i1e = function () {
  return protoOf(ChannelCoroutine).i1e.call(this);
};
protoOf(ProducerCoroutine).e1y = function (value) {
  this.l1x_1.w1w();
};
protoOf(ProducerCoroutine).j1e = function (value) {
  return this.e1y(value instanceof Unit ? value : THROW_CCE());
};
protoOf(ProducerCoroutine).k1e = function (cause, handled) {
  var processed = this.l1x_1.u1w(cause);
  if (!processed && !handled) {
    handleCoroutineException(this.g1e_1, cause);
  }
};
protoOf(ProducerCoroutine).y1w = function (cause, $super) {
  return this.s1f(cause, ($super == null ? true : $super instanceof ProducerCoroutine) ? $super : THROW_CCE());
};
function produce_0(_this__u8e3s4, context, capacity, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  capacity = capacity === VOID ? 0 : capacity;
  return produce(_this__u8e3s4, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
}
function flow(block) {
  return new SafeFlow(block);
}
function SafeFlow(block) {
  AbstractFlow.call(this);
  this.f1y_1 = block;
}
protoOf(SafeFlow).g1y = function (collector, $completion) {
  return this.f1y_1(collector, $completion);
};
function asFlow(_this__u8e3s4) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new asFlow$$inlined$unsafeFlow$1(_this__u8e3s4);
}
function $collectCOROUTINE$12(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.q1y_1 = _this__u8e3s4;
  this.r1y_1 = collector;
}
protoOf($collectCOROUTINE$12).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          var tmp_0 = this;
          tmp_0.s1y_1 = this.r1y_1;
          this.t1y_1 = this.s1y_1;
          var tmp_1 = this;
          tmp_1.u1y_1 = this.q1y_1.a1z_1;
          this.v1y_1 = this.u1y_1;
          this.w1y_1 = this.v1y_1.j();
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!this.w1y_1.k()) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.x1y_1 = this.w1y_1.l();
          var tmp_2 = this;
          tmp_2.y1y_1 = this.x1y_1;
          this.z1y_1 = this.y1y_1;
          this.n8_1 = 2;
          suspendResult = this.t1y_1.b1z(this.z1y_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.n8_1 = 1;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function asFlow$$inlined$unsafeFlow$1($this_asFlow) {
  this.a1z_1 = $this_asFlow;
}
protoOf(asFlow$$inlined$unsafeFlow$1).c1z = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$12(this, collector, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(asFlow$$inlined$unsafeFlow$1).h1y = function (collector, $completion) {
  return this.c1z(collector, $completion);
};
function $collectCOROUTINE$15(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.l1z_1 = _this__u8e3s4;
  this.m1z_1 = collector;
}
protoOf($collectCOROUTINE$15).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 5;
          var tmp_0 = this;
          tmp_0.n1z_1 = new SafeCollector(this.m1z_1, this.t8());
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.o8_1 = 4;
          this.n8_1 = 2;
          suspendResult = this.l1z_1.g1y(this.n1z_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.o1z_1 = suspendResult;
          this.o8_1 = 5;
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.o8_1 = 5;
          this.n1z_1.x8();
          return Unit_instance;
        case 4:
          this.o8_1 = 5;
          var t = this.q8_1;
          this.n1z_1.x8();
          throw t;
        case 5:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 5) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function AbstractFlow() {
}
protoOf(AbstractFlow).h1y = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$15(this, collector, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function FlowCollector() {
}
function get_NO_VALUE() {
  _init_properties_SharedFlow_kt__umasnn();
  return NO_VALUE;
}
var NO_VALUE;
function MutableSharedFlow(replay, extraBufferCapacity, onBufferOverflow) {
  replay = replay === VOID ? 0 : replay;
  extraBufferCapacity = extraBufferCapacity === VOID ? 0 : extraBufferCapacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  _init_properties_SharedFlow_kt__umasnn();
  // Inline function 'kotlin.require' call
  if (!(replay >= 0)) {
    var message = 'replay cannot be negative, but was ' + replay;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(extraBufferCapacity >= 0)) {
    var message_0 = 'extraBufferCapacity cannot be negative, but was ' + extraBufferCapacity;
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(replay > 0 || extraBufferCapacity > 0 || onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()))) {
    var message_1 = 'replay or extraBufferCapacity must be positive with non-default onBufferOverflow strategy ' + onBufferOverflow.toString();
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  var bufferCapacity0 = replay + extraBufferCapacity | 0;
  var bufferCapacity = bufferCapacity0 < 0 ? 2147483647 : bufferCapacity0;
  return new SharedFlowImpl(replay, bufferCapacity, onBufferOverflow);
}
function _get_head__d7jo8b($this) {
  var tmp0 = $this.c20_1;
  // Inline function 'kotlin.comparisons.minOf' call
  var b = $this.b20_1;
  return tmp0.b1(b) <= 0 ? tmp0 : b;
}
function _get_replaySize__dxgnb1($this) {
  var tmp0 = _get_head__d7jo8b($this);
  // Inline function 'kotlin.Long.plus' call
  var other = $this.d20_1;
  return tmp0.r2(toLong(other)).s2($this.b20_1).d1();
}
function _get_totalSize__xhdb3o($this) {
  return $this.d20_1 + $this.e20_1 | 0;
}
function _get_bufferEndIndex__d2rk18($this) {
  var tmp0 = _get_head__d7jo8b($this);
  // Inline function 'kotlin.Long.plus' call
  var other = $this.d20_1;
  return tmp0.r2(toLong(other));
}
function _get_queueEndIndex__4m025l($this) {
  var tmp0 = _get_head__d7jo8b($this);
  // Inline function 'kotlin.Long.plus' call
  var other = $this.d20_1;
  var tmp2 = tmp0.r2(toLong(other));
  // Inline function 'kotlin.Long.plus' call
  var other_0 = $this.e20_1;
  return tmp2.r2(toLong(other_0));
}
function tryEmitLocked($this, value) {
  if ($this.g20_1 === 0)
    return tryEmitNoCollectorsLocked($this, value);
  if ($this.d20_1 >= $this.y1z_1 && $this.c20_1.b1($this.b20_1) <= 0) {
    switch ($this.z1z_1.l2_1) {
      case 0:
        return false;
      case 2:
        return true;
      case 1:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  enqueueLocked($this, value);
  $this.d20_1 = $this.d20_1 + 1 | 0;
  if ($this.d20_1 > $this.y1z_1) {
    dropOldestLocked($this);
  }
  if (_get_replaySize__dxgnb1($this) > $this.x1z_1) {
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = $this.b20_1.r2(toLong(1));
    updateBufferLocked($this, tmp$ret$0, $this.c20_1, _get_bufferEndIndex__d2rk18($this), _get_queueEndIndex__4m025l($this));
  }
  return true;
}
function tryEmitNoCollectorsLocked($this, value) {
  // Inline function 'kotlinx.coroutines.assert' call
  if ($this.x1z_1 === 0)
    return true;
  enqueueLocked($this, value);
  $this.d20_1 = $this.d20_1 + 1 | 0;
  if ($this.d20_1 > $this.x1z_1) {
    dropOldestLocked($this);
  }
  var tmp = $this;
  var tmp0 = _get_head__d7jo8b($this);
  // Inline function 'kotlin.Long.plus' call
  var other = $this.d20_1;
  tmp.c20_1 = tmp0.r2(toLong(other));
  return true;
}
function dropOldestLocked($this) {
  setBufferAt(ensureNotNull($this.a20_1), _get_head__d7jo8b($this), null);
  $this.d20_1 = $this.d20_1 - 1 | 0;
  // Inline function 'kotlin.Long.plus' call
  var newHead = _get_head__d7jo8b($this).r2(toLong(1));
  if ($this.b20_1.b1(newHead) < 0)
    $this.b20_1 = newHead;
  if ($this.c20_1.b1(newHead) < 0) {
    correctCollectorIndexesOnDropOldest($this, newHead);
  }
  // Inline function 'kotlinx.coroutines.assert' call
}
function correctCollectorIndexesOnDropOldest($this, newHead) {
  $l$block: {
    // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
    if ($this.g20_1 === 0) {
      break $l$block;
    }
    var tmp0_safe_receiver = $this.f20_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (!(element == null)) {
          if (element.j20_1.b1(new Long(0, 0)) >= 0 && element.j20_1.b1(newHead) < 0) {
            element.j20_1 = newHead;
          }
        }
      }
    }
  }
  $this.c20_1 = newHead;
}
function enqueueLocked($this, item) {
  var curSize = _get_totalSize__xhdb3o($this);
  var curBuffer = $this.a20_1;
  var buffer = curBuffer == null ? growBuffer($this, null, 0, 2) : curSize >= curBuffer.length ? growBuffer($this, curBuffer, curSize, imul(curBuffer.length, 2)) : curBuffer;
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = _get_head__d7jo8b($this).r2(toLong(curSize));
  setBufferAt(buffer, tmp$ret$0, item);
}
function growBuffer($this, curBuffer, curSize, newSize) {
  // Inline function 'kotlin.check' call
  if (!(newSize > 0)) {
    var message = 'Buffer size overflow';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.arrayOfNulls' call
  // Inline function 'kotlin.also' call
  var this_0 = Array(newSize);
  $this.a20_1 = this_0;
  var newBuffer = this_0;
  if (curBuffer == null)
    return newBuffer;
  var head = _get_head__d7jo8b($this);
  var inductionVariable = 0;
  if (inductionVariable < curSize)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.Long.plus' call
      var tmp = head.r2(toLong(i));
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$6 = head.r2(toLong(i));
      setBufferAt(newBuffer, tmp, getBufferAt(curBuffer, tmp$ret$6));
    }
     while (inductionVariable < curSize);
  return newBuffer;
}
function emitSuspend($this, value, $completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.z1i();
  var resumes = get_EMPTY_RESUMES();
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  var tmp$ret$2;
  $l$block: {
    if (tryEmitLocked($this, value)) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      cancellable.y8(tmp$ret$0);
      resumes = findSlotsToResumeLocked($this, resumes);
      tmp$ret$2 = null;
      break $l$block;
    }
    var tmp2 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = _get_totalSize__xhdb3o($this);
    var tmp$ret$3 = tmp2.r2(toLong(other));
    // Inline function 'kotlin.also' call
    var this_0 = new Emitter($this, tmp$ret$3, value, cancellable);
    enqueueLocked($this, this_0);
    $this.e20_1 = $this.e20_1 + 1 | 0;
    if ($this.y1z_1 === 0)
      resumes = findSlotsToResumeLocked($this, resumes);
    tmp$ret$2 = this_0;
  }
  var emitter = tmp$ret$2;
  if (emitter == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    disposeOnCancellation(cancellable, emitter);
  }
  var indexedObject = resumes;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var r = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (r == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$10 = _Result___init__impl__xyqfz8(Unit_instance);
      r.y8(tmp$ret$10);
    }
  }
  return cancellable.h1j();
}
function cancelEmitter($this, emitter) {
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  if (emitter.m20_1.b1(_get_head__d7jo8b($this)) < 0)
    return Unit_instance;
  var buffer = ensureNotNull($this.a20_1);
  if (!(getBufferAt(buffer, emitter.m20_1) === emitter))
    return Unit_instance;
  setBufferAt(buffer, emitter.m20_1, get_NO_VALUE());
  cleanupTailLocked($this);
  return Unit_instance;
}
function updateBufferLocked($this, newReplayIndex, newMinCollectorIndex, newBufferEndIndex, newQueueEndIndex) {
  // Inline function 'kotlin.comparisons.minOf' call
  var newHead = newMinCollectorIndex.b1(newReplayIndex) <= 0 ? newMinCollectorIndex : newReplayIndex;
  // Inline function 'kotlinx.coroutines.assert' call
  var inductionVariable = _get_head__d7jo8b($this);
  if (inductionVariable.b1(newHead) < 0)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable.r2(new Long(1, 0));
      setBufferAt(ensureNotNull($this.a20_1), index, null);
    }
     while (inductionVariable.b1(newHead) < 0);
  $this.b20_1 = newReplayIndex;
  $this.c20_1 = newMinCollectorIndex;
  $this.d20_1 = newBufferEndIndex.s2(newHead).d1();
  $this.e20_1 = newQueueEndIndex.s2(newBufferEndIndex).d1();
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
}
function cleanupTailLocked($this) {
  if ($this.y1z_1 === 0 && $this.e20_1 <= 1)
    return Unit_instance;
  var buffer = ensureNotNull($this.a20_1);
  $l$loop: while (true) {
    var tmp;
    if ($this.e20_1 > 0) {
      var tmp0 = _get_head__d7jo8b($this);
      // Inline function 'kotlin.Long.plus' call
      var other = _get_totalSize__xhdb3o($this);
      // Inline function 'kotlin.Long.minus' call
      var tmp$ret$1 = tmp0.r2(toLong(other)).s2(toLong(1));
      tmp = getBufferAt(buffer, tmp$ret$1) === get_NO_VALUE();
    } else {
      tmp = false;
    }
    if (!tmp) {
      break $l$loop;
    }
    $this.e20_1 = $this.e20_1 - 1 | 0;
    var tmp4 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other_0 = _get_totalSize__xhdb3o($this);
    var tmp$ret$2 = tmp4.r2(toLong(other_0));
    setBufferAt(buffer, tmp$ret$2, null);
  }
}
function tryTakeValue($this, slot) {
  var resumes = get_EMPTY_RESUMES();
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  var index = tryPeekLocked($this, slot);
  var tmp;
  if (index.b1(new Long(0, 0)) < 0) {
    tmp = get_NO_VALUE();
  } else {
    var oldIndex = slot.j20_1;
    var newValue = getPeekedValueLockedAt($this, index);
    var tmp_0 = slot;
    // Inline function 'kotlin.Long.plus' call
    tmp_0.j20_1 = index.r2(toLong(1));
    resumes = $this.p20(oldIndex);
    tmp = newValue;
  }
  var value = tmp;
  var indexedObject = resumes;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var resume = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (resume == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$4 = _Result___init__impl__xyqfz8(Unit_instance);
      resume.y8(tmp$ret$4);
    }
  }
  return value;
}
function tryPeekLocked($this, slot) {
  var index = slot.j20_1;
  if (index.b1(_get_bufferEndIndex__d2rk18($this)) < 0)
    return index;
  if ($this.y1z_1 > 0)
    return new Long(-1, -1);
  if (index.b1(_get_head__d7jo8b($this)) > 0)
    return new Long(-1, -1);
  if ($this.e20_1 === 0)
    return new Long(-1, -1);
  return index;
}
function getPeekedValueLockedAt($this, index) {
  var item = getBufferAt(ensureNotNull($this.a20_1), index);
  var tmp;
  if (item instanceof Emitter) {
    tmp = item.n20_1;
  } else {
    tmp = item;
  }
  return tmp;
}
function awaitValue($this, slot, $completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.z1i();
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  $l$block: {
    var index = tryPeekLocked($this, slot);
    if (index.b1(new Long(0, 0)) < 0) {
      slot.k20_1 = cancellable;
    } else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      cancellable.y8(tmp$ret$0);
      break $l$block;
    }
    slot.k20_1 = cancellable;
  }
  return cancellable.h1j();
}
function findSlotsToResumeLocked($this, resumesIn) {
  var resumes = resumesIn;
  var resumeCount = resumesIn.length;
  $l$block: {
    // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
    if ($this.g20_1 === 0) {
      break $l$block;
    }
    var tmp0_safe_receiver = $this.f20_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (!(element == null)) {
          $l$block_1: {
            var tmp0_elvis_lhs = element.k20_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              break $l$block_1;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var cont = tmp;
            if (tryPeekLocked($this, element).b1(new Long(0, 0)) < 0) {
              break $l$block_1;
            }
            if (resumeCount >= resumes.length) {
              var tmp_0 = resumes;
              // Inline function 'kotlin.comparisons.maxOf' call
              var b = imul(2, resumes.length);
              var tmp$ret$2 = Math.max(2, b);
              resumes = copyOf(tmp_0, tmp$ret$2);
            }
            var tmp_1 = resumes;
            var _unary__edvuaz = resumeCount;
            resumeCount = _unary__edvuaz + 1 | 0;
            tmp_1[_unary__edvuaz] = cont;
            element.k20_1 = null;
          }
        }
      }
    }
  }
  return resumes;
}
function Emitter(flow, index, value, cont) {
  this.l20_1 = flow;
  this.m20_1 = index;
  this.n20_1 = value;
  this.o20_1 = cont;
}
protoOf(Emitter).x1h = function () {
  return cancelEmitter(this.l20_1, this);
};
function $collectCOROUTINE$16(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.y20_1 = _this__u8e3s4;
  this.z20_1 = collector;
}
protoOf($collectCOROUTINE$16).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          this.a21_1 = this.y20_1.e21();
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.o8_1 = 12;
          var tmp_0 = this.z20_1;
          if (tmp_0 instanceof SubscribedFlowCollector) {
            this.n8_1 = 2;
            suspendResult = this.z20_1.h21(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          continue $sm;
        case 3:
          var tmp_1 = this;
          tmp_1.c21_1 = this.t8().a9(Key_instance_3);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          if (!true) {
            this.n8_1 = 10;
            continue $sm;
          }

          this.n8_1 = 5;
          continue $sm;
        case 5:
          if (!true) {
            this.n8_1 = 8;
            continue $sm;
          }

          this.d21_1 = tryTakeValue(this.y20_1, this.a21_1);
          if (!(this.d21_1 === get_NO_VALUE())) {
            this.n8_1 = 8;
            continue $sm;
          } else {
            this.n8_1 = 6;
            continue $sm;
          }

        case 6:
          this.n8_1 = 7;
          suspendResult = awaitValue(this.y20_1, this.a21_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 7:
          this.n8_1 = 5;
          continue $sm;
        case 8:
          var tmp0_safe_receiver = this.c21_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            ensureActive_0(tmp0_safe_receiver);
          }

          this.n8_1 = 9;
          var tmp_2 = this.d21_1;
          suspendResult = this.z20_1.b1z((tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 9:
          this.n8_1 = 4;
          continue $sm;
        case 10:
          this.b21_1 = Unit_instance;
          this.o8_1 = 13;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.o8_1 = 13;
          this.y20_1.i21(this.a21_1);
          return Unit_instance;
        case 12:
          this.o8_1 = 13;
          var t = this.q8_1;
          this.y20_1.i21(this.a21_1);
          throw t;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 13) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function SharedFlowImpl(replay, bufferCapacity, onBufferOverflow) {
  AbstractSharedFlow.call(this);
  this.x1z_1 = replay;
  this.y1z_1 = bufferCapacity;
  this.z1z_1 = onBufferOverflow;
  this.a20_1 = null;
  this.b20_1 = new Long(0, 0);
  this.c20_1 = new Long(0, 0);
  this.d20_1 = 0;
  this.e20_1 = 0;
}
protoOf(SharedFlowImpl).j21 = function () {
  var tmp = ensureNotNull(this.a20_1);
  var tmp0 = this.b20_1;
  // Inline function 'kotlin.Long.plus' call
  var other = _get_replaySize__dxgnb1(this);
  // Inline function 'kotlin.Long.minus' call
  var tmp$ret$1 = tmp0.r2(toLong(other)).s2(toLong(1));
  var tmp_0 = getBufferAt(tmp, tmp$ret$1);
  return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
};
protoOf(SharedFlowImpl).k21 = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$16(this, collector, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(SharedFlowImpl).h1y = function (collector, $completion) {
  return this.k21(collector, $completion);
};
protoOf(SharedFlowImpl).l21 = function (value) {
  var resumes = get_EMPTY_RESUMES();
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  var tmp;
  if (tryEmitLocked(this, value)) {
    resumes = findSlotsToResumeLocked(this, resumes);
    tmp = true;
  } else {
    tmp = false;
  }
  var emitted = tmp;
  var indexedObject = resumes;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var cont = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (cont == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
      cont.y8(tmp$ret$3);
    }
  }
  return emitted;
};
protoOf(SharedFlowImpl).b1z = function (value, $completion) {
  if (this.l21(value))
    return Unit_instance;
  return emitSuspend(this, value, $completion);
};
protoOf(SharedFlowImpl).m21 = function () {
  var index = this.b20_1;
  if (index.b1(this.c20_1) < 0)
    this.c20_1 = index;
  return index;
};
protoOf(SharedFlowImpl).p20 = function (oldIndex) {
  // Inline function 'kotlinx.coroutines.assert' call
  if (oldIndex.b1(this.c20_1) > 0)
    return get_EMPTY_RESUMES();
  var head = _get_head__d7jo8b(this);
  // Inline function 'kotlin.Long.plus' call
  var other = this.d20_1;
  var newMinCollectorIndex = head.r2(toLong(other));
  if (this.y1z_1 === 0 && this.e20_1 > 0) {
    newMinCollectorIndex = newMinCollectorIndex.w2();
  }
  $l$block: {
    // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
    if (this.g20_1 === 0) {
      break $l$block;
    }
    var tmp0_safe_receiver = this.f20_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (!(element == null)) {
          if (element.j20_1.b1(new Long(0, 0)) >= 0 && element.j20_1.b1(newMinCollectorIndex) < 0)
            newMinCollectorIndex = element.j20_1;
        }
      }
    }
  }
  // Inline function 'kotlinx.coroutines.assert' call
  if (newMinCollectorIndex.b1(this.c20_1) <= 0)
    return get_EMPTY_RESUMES();
  var newBufferEndIndex = _get_bufferEndIndex__d2rk18(this);
  var tmp;
  if (this.g20_1 > 0) {
    var newBufferSize0 = newBufferEndIndex.s2(newMinCollectorIndex).d1();
    var tmp4 = this.e20_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = this.y1z_1 - newBufferSize0 | 0;
    tmp = Math.min(tmp4, b);
  } else {
    tmp = this.e20_1;
  }
  var maxResumeCount = tmp;
  var resumes = get_EMPTY_RESUMES();
  var tmp6 = newBufferEndIndex;
  // Inline function 'kotlin.Long.plus' call
  var other_0 = this.e20_1;
  var newQueueEndIndex = tmp6.r2(toLong(other_0));
  if (maxResumeCount > 0) {
    // Inline function 'kotlin.arrayOfNulls' call
    resumes = Array(maxResumeCount);
    var resumeCount = 0;
    var buffer = ensureNotNull(this.a20_1);
    var inductionVariable_0 = newBufferEndIndex;
    if (inductionVariable_0.b1(newQueueEndIndex) < 0)
      $l$loop: do {
        var curEmitterIndex = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0.r2(new Long(1, 0));
        var emitter = getBufferAt(buffer, curEmitterIndex);
        if (!(emitter === get_NO_VALUE())) {
          if (!(emitter instanceof Emitter))
            THROW_CCE();
          var tmp_0 = resumes;
          var _unary__edvuaz = resumeCount;
          resumeCount = _unary__edvuaz + 1 | 0;
          tmp_0[_unary__edvuaz] = emitter.o20_1;
          setBufferAt(buffer, curEmitterIndex, get_NO_VALUE());
          setBufferAt(buffer, newBufferEndIndex, emitter.n20_1);
          newBufferEndIndex = newBufferEndIndex.w2();
          if (resumeCount >= maxResumeCount)
            break $l$loop;
        }
      }
       while (inductionVariable_0.b1(newQueueEndIndex) < 0);
  }
  var newBufferSize1 = newBufferEndIndex.s2(head).d1();
  if (this.g20_1 === 0)
    newMinCollectorIndex = newBufferEndIndex;
  var tmp13 = this.b20_1;
  var tmp11 = newBufferEndIndex;
  // Inline function 'kotlin.comparisons.minOf' call
  var a = this.x1z_1;
  // Inline function 'kotlin.Long.minus' call
  var other_1 = Math.min(a, newBufferSize1);
  // Inline function 'kotlin.comparisons.maxOf' call
  var b_0 = tmp11.s2(toLong(other_1));
  var newReplayIndex = tmp13.b1(b_0) >= 0 ? tmp13 : b_0;
  if (this.y1z_1 === 0 && newReplayIndex.b1(newQueueEndIndex) < 0 && equals(getBufferAt(ensureNotNull(this.a20_1), newReplayIndex), get_NO_VALUE())) {
    newBufferEndIndex = newBufferEndIndex.w2();
    newReplayIndex = newReplayIndex.w2();
  }
  updateBufferLocked(this, newReplayIndex, newMinCollectorIndex, newBufferEndIndex, newQueueEndIndex);
  cleanupTailLocked(this);
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.collections.isEmpty' call
  if (!(resumes.length === 0))
    resumes = findSlotsToResumeLocked(this, resumes);
  return resumes;
};
protoOf(SharedFlowImpl).n21 = function () {
  return new SharedFlowSlot();
};
protoOf(SharedFlowImpl).o21 = function (size) {
  // Inline function 'kotlin.arrayOfNulls' call
  return Array(size);
};
function SharedFlowSlot() {
  AbstractSharedFlowSlot.call(this);
  this.j20_1 = new Long(-1, -1);
  this.k20_1 = null;
}
protoOf(SharedFlowSlot).p21 = function (flow) {
  if (this.j20_1.b1(new Long(0, 0)) >= 0)
    return false;
  this.j20_1 = flow.m21();
  return true;
};
protoOf(SharedFlowSlot).q21 = function (flow) {
  return this.p21(flow instanceof SharedFlowImpl ? flow : THROW_CCE());
};
protoOf(SharedFlowSlot).r21 = function (flow) {
  // Inline function 'kotlinx.coroutines.assert' call
  var oldIndex = this.j20_1;
  this.j20_1 = new Long(-1, -1);
  this.k20_1 = null;
  return flow.p20(oldIndex);
};
protoOf(SharedFlowSlot).s21 = function (flow) {
  return this.r21(flow instanceof SharedFlowImpl ? flow : THROW_CCE());
};
function getBufferAt(_this__u8e3s4, index) {
  _init_properties_SharedFlow_kt__umasnn();
  return _this__u8e3s4[index.d1() & (_this__u8e3s4.length - 1 | 0)];
}
function setBufferAt(_this__u8e3s4, index, item) {
  _init_properties_SharedFlow_kt__umasnn();
  return _this__u8e3s4[index.d1() & (_this__u8e3s4.length - 1 | 0)] = item;
}
var properties_initialized_SharedFlow_kt_tmefor;
function _init_properties_SharedFlow_kt__umasnn() {
  if (!properties_initialized_SharedFlow_kt_tmefor) {
    properties_initialized_SharedFlow_kt_tmefor = true;
    NO_VALUE = new Symbol('NO_VALUE');
  }
}
function get_NONE() {
  _init_properties_StateFlow_kt__eu9yi5();
  return NONE;
}
var NONE;
function get_PENDING() {
  _init_properties_StateFlow_kt__eu9yi5();
  return PENDING;
}
var PENDING;
function MutableStateFlow(value) {
  _init_properties_StateFlow_kt__eu9yi5();
  return new StateFlowImpl(value == null ? get_NULL() : value);
}
function updateState($this, expectedState, newState) {
  var curSequence;
  var curSlots;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  var oldState = $this.x21_1.kotlinx$atomicfu$value;
  if (!(expectedState == null) && !equals(oldState, expectedState))
    return false;
  if (equals(oldState, newState))
    return true;
  $this.x21_1.kotlinx$atomicfu$value = newState;
  curSequence = $this.y21_1;
  if ((curSequence & 1) === 0) {
    curSequence = curSequence + 1 | 0;
    $this.y21_1 = curSequence;
  } else {
    $this.y21_1 = curSequence + 2 | 0;
    return true;
  }
  curSlots = $this.f20_1;
  while (true) {
    var tmp0_safe_receiver = curSlots;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element == null)
          null;
        else {
          element.a22();
        }
      }
    }
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    if ($this.y21_1 === curSequence) {
      $this.y21_1 = curSequence + 1 | 0;
      return true;
    }
    curSequence = $this.y21_1;
    curSlots = $this.f20_1;
  }
}
function $collectCOROUTINE$17(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.j22_1 = _this__u8e3s4;
  this.k22_1 = collector;
}
protoOf($collectCOROUTINE$17).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          this.l22_1 = this.j22_1.e21();
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.o8_1 = 11;
          var tmp_0 = this.k22_1;
          if (tmp_0 instanceof SubscribedFlowCollector) {
            this.n8_1 = 2;
            suspendResult = this.k22_1.h21(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          continue $sm;
        case 3:
          var tmp_1 = this;
          tmp_1.n22_1 = this.t8().a9(Key_instance_3);
          this.o22_1 = null;
          this.n8_1 = 4;
          continue $sm;
        case 4:
          if (!true) {
            this.n8_1 = 9;
            continue $sm;
          }

          this.p22_1 = this.j22_1.x21_1.kotlinx$atomicfu$value;
          var tmp0_safe_receiver = this.n22_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            ensureActive_0(tmp0_safe_receiver);
          }

          if (this.o22_1 == null || !equals(this.o22_1, this.p22_1)) {
            this.n8_1 = 5;
            var tmp0 = get_NULL();
            var value = this.p22_1;
            var tmp_2;
            if (value === tmp0) {
              tmp_2 = (null == null ? true : !(null == null)) ? null : THROW_CCE();
            } else {
              tmp_2 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
            }
            suspendResult = this.k22_1.b1z(tmp_2, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 6;
            continue $sm;
          }

        case 5:
          this.o22_1 = this.p22_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          if (!this.l22_1.r22()) {
            this.n8_1 = 7;
            suspendResult = this.l22_1.q22(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 8;
            continue $sm;
          }

        case 7:
          this.n8_1 = 8;
          continue $sm;
        case 8:
          this.n8_1 = 4;
          continue $sm;
        case 9:
          this.m22_1 = Unit_instance;
          this.o8_1 = 12;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.o8_1 = 12;
          this.j22_1.i21(this.l22_1);
          return Unit_instance;
        case 11:
          this.o8_1 = 12;
          var t = this.q8_1;
          this.j22_1.i21(this.l22_1);
          throw t;
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 12) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function StateFlowImpl(initialState) {
  AbstractSharedFlow.call(this);
  this.x21_1 = atomic$ref$1(initialState);
  this.y21_1 = 0;
}
protoOf(StateFlowImpl).s22 = function (value) {
  updateState(this, null, value == null ? get_NULL() : value);
};
protoOf(StateFlowImpl).t = function () {
  var tmp0 = get_NULL();
  // Inline function 'kotlinx.coroutines.internal.Symbol.unbox' call
  var value = this.x21_1.kotlinx$atomicfu$value;
  var tmp;
  if (value === tmp0) {
    tmp = (null == null ? true : !(null == null)) ? null : THROW_CCE();
  } else {
    tmp = (value == null ? true : !(value == null)) ? value : THROW_CCE();
  }
  return tmp;
};
protoOf(StateFlowImpl).t22 = function (expect, update) {
  var tmp = expect == null ? get_NULL() : expect;
  return updateState(this, tmp, update == null ? get_NULL() : update);
};
protoOf(StateFlowImpl).b1z = function (value, $completion) {
  this.s22(value);
  return Unit_instance;
};
protoOf(StateFlowImpl).k21 = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$17(this, collector, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(StateFlowImpl).h1y = function (collector, $completion) {
  return this.k21(collector, $completion);
};
protoOf(StateFlowImpl).n21 = function () {
  return new StateFlowSlot();
};
protoOf(StateFlowImpl).o21 = function (size) {
  // Inline function 'kotlin.arrayOfNulls' call
  return Array(size);
};
function StateFlowSlot() {
  AbstractSharedFlowSlot.call(this);
  this.z21_1 = new WorkaroundAtomicReference(null);
}
protoOf(StateFlowSlot).u22 = function (flow) {
  if (!(get_value(this.z21_1) == null))
    return false;
  set_value(this.z21_1, get_NONE());
  return true;
};
protoOf(StateFlowSlot).q21 = function (flow) {
  return this.u22(flow instanceof StateFlowImpl ? flow : THROW_CCE());
};
protoOf(StateFlowSlot).v22 = function (flow) {
  set_value(this.z21_1, null);
  return get_EMPTY_RESUMES();
};
protoOf(StateFlowSlot).s21 = function (flow) {
  return this.v22(flow instanceof StateFlowImpl ? flow : THROW_CCE());
};
protoOf(StateFlowSlot).a22 = function () {
  // Inline function 'kotlinx.coroutines.internal.loop' call
  var this_0 = this.z21_1;
  while (true) {
    var state = get_value(this_0);
    if (state == null)
      return Unit_instance;
    else if (state === get_PENDING())
      return Unit_instance;
    else if (state === get_NONE()) {
      if (this.z21_1.x22(state, get_PENDING()))
        return Unit_instance;
    } else {
      if (this.z21_1.x22(state, get_NONE())) {
        // Inline function 'kotlin.coroutines.resume' call
        var this_1 = state instanceof CancellableContinuationImpl ? state : THROW_CCE();
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
        this_1.y8(tmp$ret$0);
        return Unit_instance;
      }
    }
  }
};
protoOf(StateFlowSlot).r22 = function () {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlinx.coroutines.assert' call
  return ensureNotNull(this.z21_1.y22(get_NONE())) === get_PENDING();
};
protoOf(StateFlowSlot).q22 = function ($completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.z1i();
  $l$block: {
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.z21_1.x22(get_NONE(), cancellable)) {
      break $l$block;
    }
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
    cancellable.y8(tmp$ret$3);
  }
  return cancellable.h1j();
};
var properties_initialized_StateFlow_kt_nsqikx;
function _init_properties_StateFlow_kt__eu9yi5() {
  if (!properties_initialized_StateFlow_kt_nsqikx) {
    properties_initialized_StateFlow_kt_nsqikx = true;
    NONE = new Symbol('NONE');
    PENDING = new Symbol('PENDING');
  }
}
function get_EMPTY_RESUMES() {
  _init_properties_AbstractSharedFlow_kt__h2xygb();
  return EMPTY_RESUMES;
}
var EMPTY_RESUMES;
function AbstractSharedFlow() {
  SynchronizedObject.call(this);
  this.f20_1 = null;
  this.g20_1 = 0;
  this.h20_1 = 0;
  this.i20_1 = null;
}
protoOf(AbstractSharedFlow).e21 = function () {
  var subscriptionCount;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  var curSlots = this.f20_1;
  var tmp;
  if (curSlots == null) {
    // Inline function 'kotlin.also' call
    var this_0 = this.o21(2);
    this.f20_1 = this_0;
    tmp = this_0;
  } else {
    var tmp_0;
    if (this.g20_1 >= curSlots.length) {
      // Inline function 'kotlin.also' call
      var this_1 = copyOf(curSlots, imul(2, curSlots.length));
      this.f20_1 = this_1;
      tmp_0 = this_1;
    } else {
      tmp_0 = curSlots;
    }
    tmp = tmp_0;
  }
  var slots = tmp;
  var index = this.h20_1;
  var slot;
  $l$loop: while (true) {
    var tmp0_elvis_lhs = slots[index];
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_2 = this.n21();
      slots[index] = this_2;
      tmp_1 = this_2;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    slot = tmp_1;
    index = index + 1 | 0;
    if (index >= slots.length)
      index = 0;
    if ((slot instanceof AbstractSharedFlowSlot ? slot : THROW_CCE()).q21(this))
      break $l$loop;
  }
  this.h20_1 = index;
  this.g20_1 = this.g20_1 + 1 | 0;
  subscriptionCount = this.i20_1;
  var slot_0 = slot;
  if (subscriptionCount == null)
    null;
  else
    subscriptionCount.l23(1);
  return slot_0;
};
protoOf(AbstractSharedFlow).i21 = function (slot) {
  var subscriptionCount;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  this.g20_1 = this.g20_1 - 1 | 0;
  subscriptionCount = this.i20_1;
  if (this.g20_1 === 0)
    this.h20_1 = 0;
  var resumes = (slot instanceof AbstractSharedFlowSlot ? slot : THROW_CCE()).s21(this);
  var inductionVariable = 0;
  var last = resumes.length;
  while (inductionVariable < last) {
    var cont = resumes[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (cont == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
      cont.y8(tmp$ret$3);
    }
  }
  if (subscriptionCount == null)
    null;
  else
    subscriptionCount.l23(-1);
};
function AbstractSharedFlowSlot() {
}
var properties_initialized_AbstractSharedFlow_kt_2mpafr;
function _init_properties_AbstractSharedFlow_kt__h2xygb() {
  if (!properties_initialized_AbstractSharedFlow_kt_2mpafr) {
    properties_initialized_AbstractSharedFlow_kt_2mpafr = true;
    // Inline function 'kotlin.arrayOfNulls' call
    EMPTY_RESUMES = Array(0);
  }
}
function checkOwnership(_this__u8e3s4, owner) {
  if (!(_this__u8e3s4.m23_1 === owner))
    throw _this__u8e3s4;
}
function get_NULL() {
  _init_properties_NullSurrogate_kt__n2yti9();
  return NULL;
}
var NULL;
var UNINITIALIZED;
var DONE;
var properties_initialized_NullSurrogate_kt_39v8bl;
function _init_properties_NullSurrogate_kt__n2yti9() {
  if (!properties_initialized_NullSurrogate_kt_39v8bl) {
    properties_initialized_NullSurrogate_kt_39v8bl = true;
    NULL = new Symbol('NULL');
    UNINITIALIZED = new Symbol('UNINITIALIZED');
    DONE = new Symbol('DONE');
  }
}
function checkContext(_this__u8e3s4, currentContext) {
  var result = currentContext.ig(0, checkContext$lambda(_this__u8e3s4));
  if (!(result === _this__u8e3s4.r1z_1)) {
    // Inline function 'kotlin.error' call
    var message = 'Flow invariant is violated:\n' + ('\t\tFlow was collected in ' + toString(_this__u8e3s4.q1z_1) + ',\n') + ('\t\tbut emission happened in ' + toString(currentContext) + '.\n') + "\t\tPlease refer to 'flow' documentation or use 'flowOn' instead";
    throw IllegalStateException_init_$Create$(toString(message));
  }
}
function transitiveCoroutineParent(_this__u8e3s4, collectJob) {
  var $this = _this__u8e3s4;
  var collectJob_0 = collectJob;
  $l$1: do {
    $l$0: do {
      if ($this === null)
        return null;
      if ($this === collectJob_0)
        return $this;
      if (!($this instanceof ScopeCoroutine))
        return $this;
      var tmp0 = $this.b1f();
      var tmp1 = collectJob_0;
      $this = tmp0;
      collectJob_0 = tmp1;
      continue $l$0;
    }
     while (false);
  }
   while (true);
}
function checkContext$lambda($this_checkContext) {
  return function (count, element) {
    var key = element.s();
    var collectElement = $this_checkContext.q1z_1.a9(key);
    var tmp;
    if (!(key === Key_instance_3)) {
      return !(element === collectElement) ? -2147483648 : count + 1 | 0;
    }
    var collectJob = (collectElement == null ? true : isInterface(collectElement, Job)) ? collectElement : THROW_CCE();
    var emissionParentJob = transitiveCoroutineParent(isInterface(element, Job) ? element : THROW_CCE(), collectJob);
    var tmp_0;
    if (!(emissionParentJob === collectJob)) {
      var message = 'Flow invariant is violated:\n\t\tEmission from another coroutine is detected.\n' + ('\t\tChild of ' + toString_0(emissionParentJob) + ', expected child of ' + toString_0(collectJob) + '.\n') + '\t\tFlowCollector is not thread-safe and concurrent emissions are prohibited.\n' + "\t\tTo mitigate this restriction please use 'channelFlow' builder instead of 'flow'";
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return collectJob == null ? count : count + 1 | 0;
  };
}
function ensureActive_1(_this__u8e3s4) {
  if (_this__u8e3s4 instanceof ThrowingCollector)
    throw _this__u8e3s4.n23_1;
}
function ThrowingCollector() {
}
function asStateFlow(_this__u8e3s4) {
  return new ReadonlyStateFlow(_this__u8e3s4, null);
}
function asSharedFlow(_this__u8e3s4) {
  return new ReadonlySharedFlow(_this__u8e3s4, null);
}
function $onSubscriptionCOROUTINE$26(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.w23_1 = _this__u8e3s4;
}
protoOf($onSubscriptionCOROUTINE$26).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          var tmp_0 = this;
          tmp_0.x23_1 = new SafeCollector(this.w23_1.f21_1, this.t8());
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.o8_1 = 6;
          this.n8_1 = 2;
          suspendResult = this.w23_1.g21_1(this.x23_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.y23_1 = suspendResult;
          this.o8_1 = 7;
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.o8_1 = 7;
          this.x23_1.x8();
          var tmp_1 = this.w23_1.f21_1;
          if (tmp_1 instanceof SubscribedFlowCollector) {
            this.n8_1 = 4;
            suspendResult = this.w23_1.f21_1.h21(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 5;
            continue $sm;
          }

        case 4:
          this.n8_1 = 5;
          continue $sm;
        case 5:
          return Unit_instance;
        case 6:
          this.o8_1 = 7;
          var t = this.q8_1;
          this.x23_1.x8();
          throw t;
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function SubscribedFlowCollector() {
}
protoOf(SubscribedFlowCollector).h21 = function ($completion) {
  var tmp = new $onSubscriptionCOROUTINE$26(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function $collectCOROUTINE$27(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.h24_1 = _this__u8e3s4;
  this.i24_1 = collector;
}
protoOf($collectCOROUTINE$27).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.h24_1.j24_1.k21(this.i24_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          throwKotlinNothingValueException();
          break;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function ReadonlyStateFlow(flow, job) {
  this.j24_1 = flow;
  this.k24_1 = job;
}
protoOf(ReadonlyStateFlow).t = function () {
  return this.j24_1.t();
};
protoOf(ReadonlyStateFlow).k21 = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$27(this, collector, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ReadonlyStateFlow).h1y = function (collector, $completion) {
  return this.k21(collector, $completion);
};
function $collectCOROUTINE$28(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.t24_1 = _this__u8e3s4;
  this.u24_1 = collector;
}
protoOf($collectCOROUTINE$28).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.t24_1.v24_1.k21(this.u24_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          throwKotlinNothingValueException();
          break;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function ReadonlySharedFlow(flow, job) {
  this.v24_1 = flow;
  this.w24_1 = job;
}
protoOf(ReadonlySharedFlow).k21 = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$28(this, collector, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ReadonlySharedFlow).h1y = function (collector, $completion) {
  return this.k21(collector, $completion);
};
function emitAll(_this__u8e3s4, flow, $completion) {
  ensureActive_1(_this__u8e3s4);
  return flow.h1y(_this__u8e3s4, $completion);
}
function firstOrNull(_this__u8e3s4, $completion) {
  var tmp = new $firstOrNullCOROUTINE$35(_this__u8e3s4, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function firstOrNull_0(_this__u8e3s4, predicate, $completion) {
  var tmp = new $firstOrNullCOROUTINE$37(_this__u8e3s4, predicate, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function firstOrNull$$inlined$collectWhile$1($result) {
  this.y25_1 = $result;
}
protoOf(firstOrNull$$inlined$collectWhile$1).z25 = function (value, $completion) {
  this.y25_1._v = value;
  if (!false) {
    throw new AbortFlowException(this);
  }
  return Unit_instance;
};
protoOf(firstOrNull$$inlined$collectWhile$1).b1z = function (value, $completion) {
  return this.z25((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
};
function $emitCOROUTINE$38(_this__u8e3s4, value, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.i26_1 = _this__u8e3s4;
  this.j26_1 = value;
}
protoOf($emitCOROUTINE$38).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          var tmp_0 = this;
          tmp_0.k26_1 = this.j26_1;
          this.l26_1 = this.k26_1;
          this.n8_1 = 1;
          suspendResult = this.i26_1.n26_1(this.l26_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          if (suspendResult) {
            var tmp_1 = this;
            this.i26_1.o26_1._v = this.l26_1;
            tmp_1.m26_1 = false;
            this.n8_1 = 2;
            continue $sm;
          } else {
            var tmp_2 = this;
            tmp_2.m26_1 = true;
            this.n8_1 = 2;
            continue $sm;
          }

        case 2:
          var ARGUMENT = this.m26_1;
          if (!ARGUMENT) {
            throw new AbortFlowException(this.i26_1);
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 3:
          return Unit_instance;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function firstOrNull$$inlined$collectWhile$2($predicate, $result) {
  this.n26_1 = $predicate;
  this.o26_1 = $result;
}
protoOf(firstOrNull$$inlined$collectWhile$2).z25 = function (value, $completion) {
  var tmp = new $emitCOROUTINE$38(this, value, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(firstOrNull$$inlined$collectWhile$2).b1z = function (value, $completion) {
  return this.z25((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
};
function $firstOrNullCOROUTINE$35(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.f25_1 = _this__u8e3s4;
}
protoOf($firstOrNullCOROUTINE$35).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.g25_1 = {_v: null};
          var tmp_0 = this;
          tmp_0.h25_1 = this.f25_1;
          this.i25_1 = this.h25_1;
          var tmp_1 = this;
          tmp_1.j25_1 = new firstOrNull$$inlined$collectWhile$1(this.g25_1);
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.i25_1.h1y(this.j25_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_2 = this.q8_1;
          if (tmp_2 instanceof AbortFlowException) {
            var e = this.q8_1;
            checkOwnership(e, this.j25_1);
            ensureActive(this.t8());
            this.n8_1 = 3;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return this.g25_1._v;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 4) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
function $firstOrNullCOROUTINE$37(_this__u8e3s4, predicate, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.s25_1 = _this__u8e3s4;
  this.t25_1 = predicate;
}
protoOf($firstOrNullCOROUTINE$37).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.u25_1 = {_v: null};
          var tmp_0 = this;
          tmp_0.v25_1 = this.s25_1;
          this.w25_1 = this.v25_1;
          var tmp_1 = this;
          tmp_1.x25_1 = new firstOrNull$$inlined$collectWhile$2(this.t25_1, this.u25_1);
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.w25_1.h1y(this.x25_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_2 = this.q8_1;
          if (tmp_2 instanceof AbortFlowException) {
            var e = this.q8_1;
            checkOwnership(e, this.x25_1);
            ensureActive(this.t8());
            this.n8_1 = 3;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return this.u25_1._v;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 4) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
function set_value(_this__u8e3s4, value) {
  return _this__u8e3s4.p26(value);
}
function get_value(_this__u8e3s4) {
  return _this__u8e3s4.n18();
}
function get_CLOSED() {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  return CLOSED;
}
var CLOSED;
function Segment(id, prev, pointers) {
  ConcurrentLinkedListNode.call(this, prev);
  this.l1i_1 = id;
  this.m1i_1 = atomic$int$1(pointers << 16);
}
protoOf(Segment).m1r = function () {
  return this.m1i_1.kotlinx$atomicfu$value === this.o1q() && !this.t1r();
};
protoOf(Segment).n1r = function () {
  var tmp0 = this.m1i_1;
  var tmp$ret$1;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.internal.addConditionally' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      if (!(!(cur === this.o1q()) || this.t1r())) {
        tmp$ret$1 = false;
        break $l$block_0;
      }
      if (tmp0.atomicfu$compareAndSet(cur, cur + 65536 | 0)) {
        tmp$ret$1 = true;
        break $l$block_0;
      }
    }
  }
  return tmp$ret$1;
};
protoOf(Segment).o1r = function () {
  return this.m1i_1.atomicfu$addAndGet(-65536) === this.o1q() && !this.t1r();
};
protoOf(Segment).l1r = function () {
  if (this.m1i_1.atomicfu$incrementAndGet() === this.o1q()) {
    this.c4();
  }
};
function close(_this__u8e3s4) {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  var cur = _this__u8e3s4;
  while (true) {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    var this_0 = cur;
    // Inline function 'kotlin.let' call
    var it = access$_get_nextOrClosed__ywzond(this_0);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      return cur;
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    var next = tmp;
    if (next === null) {
      if (cur.w1r())
        return cur;
    } else {
      cur = next;
    }
  }
}
function _SegmentOrClosed___init__impl__jnexvb(value) {
  return value;
}
function _get_value__a43j40($this) {
  return $this;
}
function _SegmentOrClosed___get_isClosed__impl__qmxmlo($this) {
  return _get_value__a43j40($this) === get_CLOSED();
}
function _SegmentOrClosed___get_segment__impl__jvcr9l($this) {
  var tmp;
  if (_get_value__a43j40($this) === get_CLOSED()) {
    var message = 'Does not contain segment';
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    var tmp_0 = _get_value__a43j40($this);
    tmp = tmp_0 instanceof Segment ? tmp_0 : THROW_CCE();
  }
  return tmp;
}
function SegmentOrClosed__toString_impl_pzb2an($this) {
  return 'SegmentOrClosed(value=' + toString_0($this) + ')';
}
function SegmentOrClosed__hashCode_impl_4855hs($this) {
  return $this == null ? 0 : hashCode($this);
}
function SegmentOrClosed__equals_impl_6erq1g($this, other) {
  if (!(other instanceof SegmentOrClosed))
    return false;
  var tmp0_other_with_cast = other instanceof SegmentOrClosed ? other.c1u_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function SegmentOrClosed(value) {
  this.c1u_1 = value;
}
protoOf(SegmentOrClosed).toString = function () {
  return SegmentOrClosed__toString_impl_pzb2an(this.c1u_1);
};
protoOf(SegmentOrClosed).hashCode = function () {
  return SegmentOrClosed__hashCode_impl_4855hs(this.c1u_1);
};
protoOf(SegmentOrClosed).equals = function (other) {
  return SegmentOrClosed__equals_impl_6erq1g(this.c1u_1, other);
};
function _get_nextOrClosed__w0gmuv($this) {
  return $this.p1r_1.kotlinx$atomicfu$value;
}
function _get_aliveSegmentLeft__mr4ndu($this) {
  var cur = $this.u1r();
  while (!(cur === null) && cur.m1r())
    cur = cur.q1r_1.kotlinx$atomicfu$value;
  return cur;
}
function _get_aliveSegmentRight__7ulr0b($this) {
  // Inline function 'kotlinx.coroutines.assert' call
  var cur = ensureNotNull($this.r1r());
  while (cur.m1r()) {
    var tmp0_elvis_lhs = cur.r1r();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return cur;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    cur = tmp;
  }
  return cur;
}
function access$_get_nextOrClosed__ywzond($this) {
  return _get_nextOrClosed__w0gmuv($this);
}
function ConcurrentLinkedListNode(prev) {
  this.p1r_1 = atomic$ref$1(null);
  this.q1r_1 = atomic$ref$1(prev);
}
protoOf(ConcurrentLinkedListNode).r1r = function () {
  // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
  // Inline function 'kotlin.let' call
  var it = access$_get_nextOrClosed__ywzond(this);
  var tmp;
  if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
    return null;
  } else {
    tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
  }
  return tmp;
};
protoOf(ConcurrentLinkedListNode).s1r = function (value) {
  return this.p1r_1.atomicfu$compareAndSet(null, value);
};
protoOf(ConcurrentLinkedListNode).t1r = function () {
  return this.r1r() == null;
};
protoOf(ConcurrentLinkedListNode).u1r = function () {
  return this.q1r_1.kotlinx$atomicfu$value;
};
protoOf(ConcurrentLinkedListNode).v1r = function () {
  // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
  this.q1r_1.kotlinx$atomicfu$value = null;
};
protoOf(ConcurrentLinkedListNode).w1r = function () {
  return this.p1r_1.atomicfu$compareAndSet(null, get_CLOSED());
};
protoOf(ConcurrentLinkedListNode).c4 = function () {
  // Inline function 'kotlinx.coroutines.assert' call
  if (this.t1r())
    return Unit_instance;
  $l$loop_0: while (true) {
    var prev = _get_aliveSegmentLeft__mr4ndu(this);
    var next = _get_aliveSegmentRight__7ulr0b(this);
    var tmp0 = next.q1r_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        var upd = cur === null ? null : prev;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    if (!(prev === null))
      prev.p1r_1.kotlinx$atomicfu$value = next;
    if (next.m1r() && !next.t1r())
      continue $l$loop_0;
    if (!(prev === null) && prev.m1r())
      continue $l$loop_0;
    return Unit_instance;
  }
};
function findSegmentInternal(_this__u8e3s4, id, createNewSegment) {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  var cur = _this__u8e3s4;
  $l$loop: while (cur.l1i_1.b1(id) < 0 || cur.m1r()) {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    var this_0 = cur;
    // Inline function 'kotlin.let' call
    var it = access$_get_nextOrClosed__ywzond(this_0);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      return _SegmentOrClosed___init__impl__jnexvb(get_CLOSED());
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    var next = tmp;
    if (!(next == null)) {
      cur = next;
      continue $l$loop;
    }
    // Inline function 'kotlin.Long.plus' call
    var newTail = createNewSegment(cur.l1i_1.r2(toLong(1)), cur);
    if (cur.s1r(newTail)) {
      if (cur.m1r()) {
        cur.c4();
      }
      cur = newTail;
    }
  }
  return _SegmentOrClosed___init__impl__jnexvb(cur);
}
function access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy() {
  return get_CLOSED();
}
var properties_initialized_ConcurrentLinkedList_kt_kwt434;
function _init_properties_ConcurrentLinkedList_kt__5gcgzy() {
  if (!properties_initialized_ConcurrentLinkedList_kt_kwt434) {
    properties_initialized_ConcurrentLinkedList_kt_kwt434 = true;
    CLOSED = new Symbol('CLOSED');
  }
}
function handleUncaughtCoroutineException(context, exception) {
  var _iterator__ex2g4s = get_platformExceptionHandlers().j();
  while (_iterator__ex2g4s.k()) {
    var handler = _iterator__ex2g4s.l();
    try {
      handler.k1l(context, exception);
    } catch ($p) {
      if ($p instanceof ExceptionSuccessfullyProcessed) {
        var _unused_var__etf5q3 = $p;
        return Unit_instance;
      } else {
        if ($p instanceof Error) {
          var t = $p;
          propagateExceptionFinalResort(handlerException(exception, t));
        } else {
          throw $p;
        }
      }
    }
  }
  try {
    addSuppressed(exception, new DiagnosticCoroutineContextException(context));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  propagateExceptionFinalResort(exception);
}
function ExceptionSuccessfullyProcessed() {
}
function get_UNDEFINED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return UNDEFINED;
}
var UNDEFINED;
function get_REUSABLE_CLAIMED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return REUSABLE_CLAIMED;
}
var REUSABLE_CLAIMED;
function _get_reusableCancellableContinuation__9qex09($this) {
  var tmp = $this.d1i_1.kotlinx$atomicfu$value;
  return tmp instanceof CancellableContinuationImpl ? tmp : null;
}
function DispatchedContinuation(dispatcher, continuation) {
  DispatchedTask.call(this, -1);
  this.z1h_1 = dispatcher;
  this.a1i_1 = continuation;
  this.b1i_1 = get_UNDEFINED();
  this.c1i_1 = threadContextElements(this.t8());
  this.d1i_1 = atomic$ref$1(null);
}
protoOf(DispatchedContinuation).g1i = function () {
  return !(this.d1i_1.kotlinx$atomicfu$value == null);
};
protoOf(DispatchedContinuation).q26 = function () {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.d1i_1;
  while (true) {
    if (!(this_0.kotlinx$atomicfu$value === get_REUSABLE_CLAIMED()))
      return Unit_instance;
  }
};
protoOf(DispatchedContinuation).i1l = function () {
  this.q26();
  var tmp0_safe_receiver = _get_reusableCancellableContinuation__9qex09(this);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.x1i();
  }
};
protoOf(DispatchedContinuation).e1i = function () {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.d1i_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (state === null) {
      this.d1i_1.kotlinx$atomicfu$value = get_REUSABLE_CLAIMED();
      return null;
    } else {
      if (state instanceof CancellableContinuationImpl) {
        if (this.d1i_1.atomicfu$compareAndSet(state, get_REUSABLE_CLAIMED())) {
          return state instanceof CancellableContinuationImpl ? state : THROW_CCE();
        }
      } else {
        if (state !== get_REUSABLE_CLAIMED()) {
          if (!(state instanceof Error)) {
            // Inline function 'kotlin.error' call
            var message = 'Inconsistent state ' + toString_0(state);
            throw IllegalStateException_init_$Create$(toString(message));
          }
        }
      }
    }
  }
};
protoOf(DispatchedContinuation).k1j = function (continuation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.d1i_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (state === get_REUSABLE_CLAIMED()) {
      if (this.d1i_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), continuation))
        return null;
    } else {
      if (state instanceof Error) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!this.d1i_1.atomicfu$compareAndSet(state, null)) {
          var message = 'Failed requirement.';
          throw IllegalArgumentException_init_$Create$(toString(message));
        }
        return state;
      } else {
        // Inline function 'kotlin.error' call
        var message_0 = 'Inconsistent state ' + toString_0(state);
        throw IllegalStateException_init_$Create$(toString(message_0));
      }
    }
  }
};
protoOf(DispatchedContinuation).i1i = function (cause) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.d1i_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (equals(state, get_REUSABLE_CLAIMED())) {
      if (this.d1i_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), cause))
        return true;
    } else {
      if (state instanceof Error)
        return true;
      else {
        if (this.d1i_1.atomicfu$compareAndSet(state, null))
          return false;
      }
    }
  }
};
protoOf(DispatchedContinuation).a1j = function () {
  var state = this.b1i_1;
  // Inline function 'kotlinx.coroutines.assert' call
  this.b1i_1 = get_UNDEFINED();
  return state;
};
protoOf(DispatchedContinuation).y1i = function () {
  return this;
};
protoOf(DispatchedContinuation).y8 = function (result) {
  var state = toState_0(result);
  if (safeIsDispatchNeeded(this.z1h_1, this.t8())) {
    this.b1i_1 = state;
    this.h1i_1 = 0;
    safeDispatch(this.z1h_1, this.t8(), this);
  } else {
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
      // Inline function 'kotlinx.coroutines.assert' call
      var eventLoop = ThreadLocalEventLoop_getInstance().d1m();
      if (false && eventLoop.y1l()) {
        break $l$block;
      }
      var tmp;
      if (eventLoop.x1l()) {
        this.b1i_1 = state;
        this.h1i_1 = 0;
        eventLoop.w1l(this);
        tmp = true;
      } else {
        // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
        eventLoop.z1l(true);
        try {
          this.t8();
          // Inline function 'kotlinx.coroutines.withCoroutineContext' call
          this.c1i_1;
          this.a1i_1.y8(result);
          $l$loop: while (eventLoop.v1l()) {
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            this.w1j(e);
          } else {
            throw $p;
          }
        }
        finally {
          eventLoop.a1m(true);
        }
        tmp = false;
      }
    }
  }
};
protoOf(DispatchedContinuation).toString = function () {
  return 'DispatchedContinuation[' + this.z1h_1.toString() + ', ' + toDebugString(this.a1i_1) + ']';
};
protoOf(DispatchedContinuation).t8 = function () {
  return this.a1i_1.t8();
};
function safeDispatch(_this__u8e3s4, context, runnable) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  try {
    _this__u8e3s4.h1l(context, runnable);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      throw new DispatchException(e, _this__u8e3s4, context);
    } else {
      throw $p;
    }
  }
}
function safeIsDispatchNeeded(_this__u8e3s4, context) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  try {
    return _this__u8e3s4.g1l(context);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      throw new DispatchException(e, _this__u8e3s4, context);
    } else {
      throw $p;
    }
  }
}
function resumeCancellableWith(_this__u8e3s4, result) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  var tmp;
  if (_this__u8e3s4 instanceof DispatchedContinuation) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancellableWith' call
    var state = toState_0(result);
    if (safeIsDispatchNeeded(_this__u8e3s4.z1h_1, _this__u8e3s4.t8())) {
      _this__u8e3s4.b1i_1 = state;
      _this__u8e3s4.h1i_1 = 1;
      safeDispatch(_this__u8e3s4.z1h_1, _this__u8e3s4.t8(), _this__u8e3s4);
    } else {
      $l$block: {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().d1m();
        if (false && eventLoop.y1l()) {
          break $l$block;
        }
        var tmp_0;
        if (eventLoop.x1l()) {
          _this__u8e3s4.b1i_1 = state;
          _this__u8e3s4.h1i_1 = 1;
          eventLoop.w1l(_this__u8e3s4);
          tmp_0 = true;
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.z1l(true);
          try {
            var tmp$ret$4;
            $l$block_0: {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancelled' call
              var job = _this__u8e3s4.t8().a9(Key_instance_3);
              if (!(job == null) && !job.i1e()) {
                var cause = job.h1f();
                _this__u8e3s4.b1j(state, cause);
                // Inline function 'kotlin.coroutines.resumeWithException' call
                // Inline function 'kotlin.Companion.failure' call
                var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(cause));
                _this__u8e3s4.y8(tmp$ret$2);
                tmp$ret$4 = true;
                break $l$block_0;
              }
              tmp$ret$4 = false;
            }
            if (!tmp$ret$4) {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
              _this__u8e3s4.a1i_1;
              // Inline function 'kotlinx.coroutines.withContinuationContext' call
              _this__u8e3s4.c1i_1;
              _this__u8e3s4.a1i_1.y8(result);
            }
            $l$loop: while (eventLoop.v1l()) {
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              _this__u8e3s4.w1j(e);
            } else {
              throw $p;
            }
          }
          finally {
            eventLoop.a1m(true);
          }
          tmp_0 = false;
        }
      }
    }
    tmp = Unit_instance;
  } else {
    _this__u8e3s4.y8(result);
    tmp = Unit_instance;
  }
  return tmp;
}
var properties_initialized_DispatchedContinuation_kt_2siadq;
function _init_properties_DispatchedContinuation_kt__tnmqc0() {
  if (!properties_initialized_DispatchedContinuation_kt_2siadq) {
    properties_initialized_DispatchedContinuation_kt_2siadq = true;
    UNDEFINED = new Symbol('UNDEFINED');
    REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
  }
}
function DispatchedTask(resumeMode) {
  SchedulerTask.call(this);
  this.h1i_1 = resumeMode;
}
protoOf(DispatchedTask).b1j = function (takenState, cause) {
};
protoOf(DispatchedTask).j1j = function (state) {
  return (state == null ? true : !(state == null)) ? state : THROW_CCE();
};
protoOf(DispatchedTask).t1j = function (state) {
  var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1e_1;
};
protoOf(DispatchedTask).v1j = function () {
  // Inline function 'kotlinx.coroutines.assert' call
  try {
    var tmp = this.y1i();
    var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
    var continuation = delegate.a1i_1;
    // Inline function 'kotlinx.coroutines.withContinuationContext' call
    delegate.c1i_1;
    var context = continuation.t8();
    var state = this.a1j();
    var exception = this.t1j(state);
    var job = exception == null && get_isCancellableMode(this.h1i_1) ? context.a9(Key_instance_3) : null;
    if (!(job == null) && !job.i1e()) {
      var cause = job.h1f();
      this.b1j(state, cause);
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      // Inline function 'kotlin.Companion.failure' call
      var exception_0 = recoverStackTrace(cause, continuation);
      var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception_0));
      continuation.y8(tmp$ret$1);
    } else {
      if (!(exception == null)) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
        continuation.y8(tmp$ret$3);
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = this.j1j(state);
        var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
        continuation.y8(tmp$ret$5);
      }
    }
  } catch ($p) {
    if ($p instanceof DispatchException) {
      var e = $p;
      handleCoroutineException(this.y1i().t8(), e.j1l_1);
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        this.w1j(e_0);
      } else {
        throw $p;
      }
    }
  }
};
protoOf(DispatchedTask).w1j = function (exception) {
  var reason = new CoroutinesInternalError('Fatal exception in coroutines machinery for ' + toString(this) + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", exception);
  handleCoroutineException(this.y1i().t8(), reason);
};
function get_isReusableMode(_this__u8e3s4) {
  return _this__u8e3s4 === 2;
}
function get_isCancellableMode(_this__u8e3s4) {
  return _this__u8e3s4 === 1 || _this__u8e3s4 === 2;
}
function dispatch(_this__u8e3s4, mode) {
  // Inline function 'kotlinx.coroutines.assert' call
  var delegate = _this__u8e3s4.y1i();
  var undispatched = mode === 4;
  var tmp;
  var tmp_0;
  if (!undispatched) {
    tmp_0 = delegate instanceof DispatchedContinuation;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = get_isCancellableMode(mode) === get_isCancellableMode(_this__u8e3s4.h1i_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    var dispatcher = delegate.z1h_1;
    var context = delegate.t8();
    if (safeIsDispatchNeeded(dispatcher, context)) {
      safeDispatch(dispatcher, context, _this__u8e3s4);
    } else {
      resumeUnconfined(_this__u8e3s4);
    }
  } else {
    resume(_this__u8e3s4, delegate, undispatched);
  }
}
function DispatchException(cause, dispatcher, context) {
  Exception_init_$Init$('Coroutine dispatcher ' + dispatcher.toString() + ' threw an exception, context = ' + toString(context), cause, this);
  captureStack(this, DispatchException);
  this.j1l_1 = cause;
}
protoOf(DispatchException).h1 = function () {
  return this.j1l_1;
};
function resumeUnconfined(_this__u8e3s4) {
  var eventLoop = ThreadLocalEventLoop_getInstance().d1m();
  if (eventLoop.x1l()) {
    eventLoop.w1l(_this__u8e3s4);
  } else {
    // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
    eventLoop.z1l(true);
    try {
      resume(_this__u8e3s4, _this__u8e3s4.y1i(), true);
      $l$loop: while (eventLoop.v1l()) {
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        _this__u8e3s4.w1j(e);
      } else {
        throw $p;
      }
    }
    finally {
      eventLoop.a1m(true);
    }
  }
}
function resume(_this__u8e3s4, delegate, undispatched) {
  var state = _this__u8e3s4.a1j();
  var exception = _this__u8e3s4.t1j(state);
  var tmp;
  if (!(exception == null)) {
    // Inline function 'kotlin.Companion.failure' call
    tmp = _Result___init__impl__xyqfz8(createFailure(exception));
  } else {
    // Inline function 'kotlin.Companion.success' call
    var value = _this__u8e3s4.j1j(state);
    tmp = _Result___init__impl__xyqfz8(value);
  }
  var result = tmp;
  if (undispatched) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
    var this_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
    this_0.a1i_1;
    // Inline function 'kotlinx.coroutines.withContinuationContext' call
    this_0.c1i_1;
    this_0.a1i_1.y8(result);
  } else {
    delegate.y8(result);
  }
}
function _InlineList___init__impl__z8n56(holder) {
  holder = holder === VOID ? null : holder;
  return holder;
}
function _get_holder__f6h5pd($this) {
  return $this;
}
function InlineList__plus_impl_nuetvo($this, element) {
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_subject = _get_holder__f6h5pd($this);
  var tmp;
  if (tmp0_subject == null) {
    tmp = _InlineList___init__impl__z8n56(element);
  } else {
    if (tmp0_subject instanceof ArrayList) {
      var tmp_0 = _get_holder__f6h5pd($this);
      (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).e(element);
      tmp = _InlineList___init__impl__z8n56(_get_holder__f6h5pd($this));
    } else {
      var list = ArrayList_init_$Create$(4);
      var tmp_1 = _get_holder__f6h5pd($this);
      list.e((tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE());
      list.e(element);
      tmp = _InlineList___init__impl__z8n56(list);
    }
  }
  return tmp;
}
function access$_get_holder__kkflen($this) {
  return _get_holder__f6h5pd($this);
}
function callUndeliveredElement(_this__u8e3s4, element, context) {
  var tmp0_safe_receiver = callUndeliveredElementCatchingException(_this__u8e3s4, element, null);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    handleCoroutineException(context, tmp0_safe_receiver);
  }
}
function UndeliveredElementException(message, cause) {
  RuntimeException_init_$Init$(message, cause, this);
  captureStack(this, UndeliveredElementException);
}
function callUndeliveredElementCatchingException(_this__u8e3s4, element, undeliveredElementException) {
  undeliveredElementException = undeliveredElementException === VOID ? null : undeliveredElementException;
  try {
    _this__u8e3s4(element);
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      if (!(undeliveredElementException == null) && !(undeliveredElementException.cause === ex)) {
        addSuppressed(undeliveredElementException, ex);
      } else {
        return new UndeliveredElementException('Exception in undelivered element handler for ' + toString_0(element), ex);
      }
    } else {
      throw $p;
    }
  }
  return undeliveredElementException;
}
function ContextScope(context) {
  this.r26_1 = context;
}
protoOf(ContextScope).h1e = function () {
  return this.r26_1;
};
protoOf(ContextScope).toString = function () {
  return 'CoroutineScope(coroutineContext=' + toString(this.r26_1) + ')';
};
function ScopeCoroutine(context, uCont) {
  AbstractCoroutine.call(this, context, true, true);
  this.c1q_1 = uCont;
}
protoOf(ScopeCoroutine).c1g = function () {
  return true;
};
protoOf(ScopeCoroutine).s1e = function (state) {
  resumeCancellableWith(intercepted(this.c1q_1), recoverResult(state, this.c1q_1));
};
protoOf(ScopeCoroutine).d1q = function () {
};
protoOf(ScopeCoroutine).r1e = function (state) {
  this.c1q_1.y8(recoverResult(state, this.c1q_1));
};
function Symbol(symbol) {
  this.s26_1 = symbol;
}
protoOf(Symbol).toString = function () {
  return '<' + this.s26_1 + '>';
};
function systemProp(propertyName, defaultValue, minValue, maxValue) {
  minValue = minValue === VOID ? 1 : minValue;
  maxValue = maxValue === VOID ? 2147483647 : maxValue;
  return systemProp_0(propertyName, toLong(defaultValue), toLong(minValue), toLong(maxValue)).d1();
}
function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
  minValue = minValue === VOID ? new Long(1, 0) : minValue;
  maxValue = maxValue === VOID ? new Long(-1, 2147483647) : maxValue;
  var tmp0_elvis_lhs = systemProp_1(propertyName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return defaultValue;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var value = tmp;
  var tmp1_elvis_lhs = toLongOrNull(value);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var message = "System property '" + propertyName + "' has unrecognized value '" + value + "'";
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var parsed = tmp_0;
  if (!(minValue.b1(parsed) <= 0 ? parsed.b1(maxValue) <= 0 : false)) {
    // Inline function 'kotlin.error' call
    var message_0 = "System property '" + propertyName + "' should be in range " + minValue.toString() + '..' + maxValue.toString() + ", but is '" + parsed.toString() + "'";
    throw IllegalStateException_init_$Create$(toString(message_0));
  }
  return parsed;
}
function startCoroutineCancellable(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(createCoroutineUnintercepted(_this__u8e3s4, receiver, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp, tmp$ret$0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(completion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function startCoroutineCancellable_0(_this__u8e3s4, fatalCompletion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(_this__u8e3s4);
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp, tmp$ret$0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(fatalCompletion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function dispatcherFailure(completion, e) {
  var tmp;
  if (e instanceof DispatchException) {
    tmp = e.j1l_1;
  } else {
    tmp = e;
  }
  var reportException = tmp;
  // Inline function 'kotlin.Companion.failure' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(reportException));
  completion.y8(tmp$ret$0);
  throw reportException;
}
function startCoroutineCancellable_1(_this__u8e3s4, completion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(createCoroutineUnintercepted_0(_this__u8e3s4, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp, tmp$ret$0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(completion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function startUndispatchedOrReturn(_this__u8e3s4, receiver, block) {
  return startUndspatched(_this__u8e3s4, true, receiver, block);
}
function startCoroutineUndispatched(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlinx.coroutines.internal.probeCoroutineCreated' call
  var actualCompletion = completion;
  var tmp;
  try {
    // Inline function 'kotlinx.coroutines.withCoroutineContext' call
    actualCompletion.t8();
    // Inline function 'kotlinx.coroutines.internal.probeCoroutineResumed' call
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(_this__u8e3s4, receiver, actualCompletion);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      var tmp_1;
      if (e instanceof DispatchException) {
        tmp_1 = e.j1l_1;
      } else {
        tmp_1 = e;
      }
      var reportException = tmp_1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(reportException));
      actualCompletion.y8(tmp$ret$5);
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  var value = tmp;
  if (!(value === get_COROUTINE_SUSPENDED())) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
    var tmp$ret$7 = _Result___init__impl__xyqfz8(value_0);
    actualCompletion.y8(tmp$ret$7);
  }
}
function startUndispatchedOrReturnIgnoreTimeout(_this__u8e3s4, receiver, block) {
  return startUndspatched(_this__u8e3s4, false, receiver, block);
}
function startUndspatched(_this__u8e3s4, alwaysRethrow, receiver, block) {
  var tmp;
  try {
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(block, receiver, _this__u8e3s4);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof DispatchException) {
      var e = $p;
      dispatchExceptionAndMakeCompleting(_this__u8e3s4, e);
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        tmp_0 = new CompletedExceptionally(e_0);
      } else {
        throw $p;
      }
    }
    tmp = tmp_0;
  }
  var result = tmp;
  if (result === get_COROUTINE_SUSPENDED())
    return get_COROUTINE_SUSPENDED();
  var state = _this__u8e3s4.q1e(result);
  if (state === get_COMPLETING_WAITING_CHILDREN())
    return get_COROUTINE_SUSPENDED();
  _this__u8e3s4.d1q();
  var tmp_1;
  if (state instanceof CompletedExceptionally) {
    var tmp_2;
    if (alwaysRethrow || notOwnTimeout(_this__u8e3s4, state.n1e_1)) {
      throw recoverStackTrace(state.n1e_1, _this__u8e3s4.c1q_1);
    } else {
      if (result instanceof CompletedExceptionally) {
        throw recoverStackTrace(result.n1e_1, _this__u8e3s4.c1q_1);
      } else {
        tmp_2 = result;
      }
    }
    tmp_1 = tmp_2;
  } else {
    tmp_1 = unboxState(state);
  }
  return tmp_1;
}
function dispatchExceptionAndMakeCompleting(_this__u8e3s4, e) {
  _this__u8e3s4.z1f(new CompletedExceptionally(e.j1l_1));
  throw recoverStackTrace(e.j1l_1, _this__u8e3s4.c1q_1);
}
function notOwnTimeout(_this__u8e3s4, cause) {
  var tmp;
  if (!(cause instanceof TimeoutCancellationException)) {
    tmp = true;
  } else {
    tmp = !(cause.i1p_1 === _this__u8e3s4);
  }
  return tmp;
}
var DUMMY_PROCESS_RESULT_FUNCTION;
function get_STATE_REG() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_REG;
}
var STATE_REG;
function get_STATE_COMPLETED() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_COMPLETED;
}
var STATE_COMPLETED;
function get_STATE_CANCELLED() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_CANCELLED;
}
var STATE_CANCELLED;
function get_NO_RESULT() {
  _init_properties_Select_kt__zhm2jg();
  return NO_RESULT;
}
var NO_RESULT;
var PARAM_CLAUSE_0;
function SelectInstance() {
}
function trySelectInternal($this, clauseObject, internalResult) {
  $l$loop: while (true) {
    var curState = $this.r1t_1.kotlinx$atomicfu$value;
    if (isInterface(curState, CancellableContinuation)) {
      var tmp0_elvis_lhs = findClause($this, clauseObject);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var clause = tmp;
      var onCancellation = clause.x26($this, internalResult);
      if ($this.r1t_1.atomicfu$compareAndSet(curState, clause)) {
        var cont = isInterface(curState, CancellableContinuation) ? curState : THROW_CCE();
        $this.t1t_1 = internalResult;
        if (tryResume_0(cont, onCancellation))
          return 0;
        $this.t1t_1 = get_NO_RESULT();
        return 2;
      }
    } else {
      var tmp_0;
      if (equals(curState, get_STATE_COMPLETED())) {
        tmp_0 = true;
      } else {
        tmp_0 = curState instanceof ClauseData;
      }
      if (tmp_0)
        return 3;
      else {
        if (equals(curState, get_STATE_CANCELLED()))
          return 2;
        else {
          if (equals(curState, get_STATE_REG())) {
            if ($this.r1t_1.atomicfu$compareAndSet(curState, listOf_0(clauseObject)))
              return 1;
          } else {
            if (isInterface(curState, KtList)) {
              if ($this.r1t_1.atomicfu$compareAndSet(curState, plus_0(curState, clauseObject)))
                return 1;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Unexpected state: ' + toString(curState);
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }
      }
    }
  }
}
function findClause($this, clauseObject) {
  var tmp0_elvis_lhs = $this.s1t_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var clauses = tmp;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = clauses.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.u26_1 === clauseObject) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var message = 'Clause with object ' + toString(clauseObject) + ' is not found';
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
}
function ClauseData() {
}
protoOf(ClauseData).x26 = function (select, internalResult) {
  var tmp0_safe_receiver = this.w26_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(select, this.v26_1, internalResult);
};
function SelectImplementation() {
}
protoOf(SelectImplementation).u1t = function (clauseObject, result) {
  return TrySelectDetailedResult_0(trySelectInternal(this, clauseObject, result));
};
var TrySelectDetailedResult_SUCCESSFUL_instance;
var TrySelectDetailedResult_REREGISTER_instance;
var TrySelectDetailedResult_CANCELLED_instance;
var TrySelectDetailedResult_ALREADY_SELECTED_instance;
var TrySelectDetailedResult_entriesInitialized;
function TrySelectDetailedResult_initEntries() {
  if (TrySelectDetailedResult_entriesInitialized)
    return Unit_instance;
  TrySelectDetailedResult_entriesInitialized = true;
  TrySelectDetailedResult_SUCCESSFUL_instance = new TrySelectDetailedResult('SUCCESSFUL', 0);
  TrySelectDetailedResult_REREGISTER_instance = new TrySelectDetailedResult('REREGISTER', 1);
  TrySelectDetailedResult_CANCELLED_instance = new TrySelectDetailedResult('CANCELLED', 2);
  TrySelectDetailedResult_ALREADY_SELECTED_instance = new TrySelectDetailedResult('ALREADY_SELECTED', 3);
}
function TrySelectDetailedResult(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function TrySelectDetailedResult_0(trySelectInternalResult) {
  _init_properties_Select_kt__zhm2jg();
  var tmp;
  switch (trySelectInternalResult) {
    case 0:
      tmp = TrySelectDetailedResult_SUCCESSFUL_getInstance();
      break;
    case 1:
      tmp = TrySelectDetailedResult_REREGISTER_getInstance();
      break;
    case 2:
      tmp = TrySelectDetailedResult_CANCELLED_getInstance();
      break;
    case 3:
      tmp = TrySelectDetailedResult_ALREADY_SELECTED_getInstance();
      break;
    default:
      var message = 'Unexpected internal result: ' + trySelectInternalResult;
      throw IllegalStateException_init_$Create$(toString(message));
  }
  return tmp;
}
function tryResume_0(_this__u8e3s4, onCancellation) {
  _init_properties_Select_kt__zhm2jg();
  var tmp0_elvis_lhs = _this__u8e3s4.j1h(Unit_instance, null, onCancellation);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var token = tmp;
  _this__u8e3s4.k1h(token);
  return true;
}
function DUMMY_PROCESS_RESULT_FUNCTION$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
  _init_properties_Select_kt__zhm2jg();
  return null;
}
function TrySelectDetailedResult_SUCCESSFUL_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_SUCCESSFUL_instance;
}
function TrySelectDetailedResult_REREGISTER_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_REREGISTER_instance;
}
function TrySelectDetailedResult_CANCELLED_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_CANCELLED_instance;
}
function TrySelectDetailedResult_ALREADY_SELECTED_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_ALREADY_SELECTED_instance;
}
var properties_initialized_Select_kt_7rpl36;
function _init_properties_Select_kt__zhm2jg() {
  if (!properties_initialized_Select_kt_7rpl36) {
    properties_initialized_Select_kt_7rpl36 = true;
    DUMMY_PROCESS_RESULT_FUNCTION = DUMMY_PROCESS_RESULT_FUNCTION$lambda;
    STATE_REG = new Symbol('STATE_REG');
    STATE_COMPLETED = new Symbol('STATE_COMPLETED');
    STATE_CANCELLED = new Symbol('STATE_CANCELLED');
    NO_RESULT = new Symbol('NO_RESULT');
    PARAM_CLAUSE_0 = new Symbol('PARAM_CLAUSE_0');
  }
}
function get_NO_OWNER() {
  _init_properties_Mutex_kt__jod56b();
  return NO_OWNER;
}
var NO_OWNER;
var ON_LOCK_ALREADY_LOCKED_BY_OWNER;
function Mutex(locked) {
  locked = locked === VOID ? false : locked;
  _init_properties_Mutex_kt__jod56b();
  return new MutexImpl(locked);
}
function MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this$0, this$1) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    // Inline function 'kotlinx.coroutines.assert' call
    this$0.f27_1.kotlinx$atomicfu$value = this$1.i27_1;
    this$0.k27(this$1.i27_1);
    return Unit_instance;
  };
}
function MutexImpl$CancellableContinuationWithOwner$resume$lambda(this$0, this$1) {
  return function (it) {
    this$0.k27(this$1.i27_1);
    return Unit_instance;
  };
}
function holdsLockImpl($this, owner) {
  $l$loop: while (true) {
    if (!$this.l27())
      return 0;
    var curOwner = $this.f27_1.kotlinx$atomicfu$value;
    if (curOwner === get_NO_OWNER())
      continue $l$loop;
    return curOwner === owner ? 1 : 2;
  }
}
function lockSuspend($this, owner, $completion) {
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    var contWithOwner = new CancellableContinuationWithOwner($this, cancellable, owner);
    $this.acquireCont(contWithOwner);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.i1j();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.h1j();
}
function tryLockImpl($this, owner) {
  $l$loop: while (true) {
    if ($this.t27()) {
      // Inline function 'kotlinx.coroutines.assert' call
      $this.f27_1.kotlinx$atomicfu$value = owner;
      return 0;
    } else {
      if (owner == null)
        return 1;
      switch (holdsLockImpl($this, owner)) {
        case 1:
          return 2;
        case 2:
          return 1;
        case 0:
          continue $l$loop;
      }
    }
  }
}
function CancellableContinuationWithOwner($outer, cont, owner) {
  this.j27_1 = $outer;
  this.h27_1 = cont;
  this.i27_1 = owner;
}
protoOf(CancellableContinuationWithOwner).u27 = function (value, idempotent, onCancellation) {
  // Inline function 'kotlinx.coroutines.assert' call
  var token = this.h27_1.j1h(value, idempotent, MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this.j27_1, this));
  if (!(token == null)) {
    // Inline function 'kotlinx.coroutines.assert' call
    this.j27_1.f27_1.kotlinx$atomicfu$value = this.i27_1;
  }
  return token;
};
protoOf(CancellableContinuationWithOwner).j1h = function (value, idempotent, onCancellation) {
  return this.u27(value instanceof Unit ? value : THROW_CCE(), idempotent, onCancellation);
};
protoOf(CancellableContinuationWithOwner).v27 = function (value, onCancellation) {
  // Inline function 'kotlinx.coroutines.assert' call
  this.j27_1.f27_1.kotlinx$atomicfu$value = this.i27_1;
  this.h27_1.m1j(Unit_instance, MutexImpl$CancellableContinuationWithOwner$resume$lambda(this.j27_1, this));
};
protoOf(CancellableContinuationWithOwner).n1h = function (value, onCancellation) {
  return this.v27(value instanceof Unit ? value : THROW_CCE(), onCancellation);
};
protoOf(CancellableContinuationWithOwner).e1f = function () {
  return this.h27_1.e1f();
};
protoOf(CancellableContinuationWithOwner).k1h = function (token) {
  this.h27_1.k1h(token);
};
protoOf(CancellableContinuationWithOwner).l1h = function (handler) {
  this.h27_1.l1h(handler);
};
protoOf(CancellableContinuationWithOwner).o1j = function (segment, index) {
  this.h27_1.o1j(segment, index);
};
protoOf(CancellableContinuationWithOwner).w27 = function (_this__u8e3s4, value) {
  this.h27_1.m1h(_this__u8e3s4, Unit_instance);
};
protoOf(CancellableContinuationWithOwner).m1h = function (_this__u8e3s4, value) {
  return this.w27(_this__u8e3s4, value instanceof Unit ? value : THROW_CCE());
};
protoOf(CancellableContinuationWithOwner).ag = function (result) {
  this.h27_1.y8(result);
};
protoOf(CancellableContinuationWithOwner).y8 = function (result) {
  return this.ag(result);
};
protoOf(CancellableContinuationWithOwner).t8 = function () {
  return this.h27_1.t8();
};
function MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, $owner) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    this$0.k27($owner);
    return Unit_instance;
  };
}
function MutexImpl$onSelectCancellationUnlockConstructor$lambda(this$0) {
  return function (_unused_var__etf5q3, owner, _unused_var__etf5q3_0) {
    return MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, owner);
  };
}
function MutexImpl(locked) {
  SemaphoreAndMutexImpl.call(this, 1, locked ? 1 : 0);
  this.f27_1 = atomic$ref$1(locked ? null : get_NO_OWNER());
  var tmp = this;
  tmp.g27_1 = MutexImpl$onSelectCancellationUnlockConstructor$lambda(this);
}
protoOf(MutexImpl).l27 = function () {
  return this.x27() === 0;
};
protoOf(MutexImpl).y27 = function (owner, $completion) {
  if (this.z27(owner))
    return Unit_instance;
  return lockSuspend(this, owner, $completion);
};
protoOf(MutexImpl).z27 = function (owner) {
  var tmp;
  switch (tryLockImpl(this, owner)) {
    case 0:
      tmp = true;
      break;
    case 1:
      tmp = false;
      break;
    case 2:
      var message = 'This mutex is already locked by the specified owner: ' + toString_0(owner);
      throw IllegalStateException_init_$Create$(toString(message));
    default:
      var message_0 = 'unexpected';
      throw IllegalStateException_init_$Create$(toString(message_0));
  }
  return tmp;
};
protoOf(MutexImpl).k27 = function (owner) {
  $l$loop_0: while (true) {
    // Inline function 'kotlin.check' call
    if (!this.l27()) {
      var message = 'This mutex is not locked';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var curOwner = this.f27_1.kotlinx$atomicfu$value;
    if (curOwner === get_NO_OWNER())
      continue $l$loop_0;
    // Inline function 'kotlin.check' call
    if (!(curOwner === owner || owner == null)) {
      var message_0 = 'This mutex is locked by ' + toString_0(curOwner) + ', but ' + toString_0(owner) + ' is expected';
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    if (!this.f27_1.atomicfu$compareAndSet(curOwner, get_NO_OWNER()))
      continue $l$loop_0;
    this.a28();
    return Unit_instance;
  }
};
protoOf(MutexImpl).toString = function () {
  return 'Mutex@' + get_hexAddress(this) + '[isLocked=' + this.l27() + ',owner=' + toString_0(this.f27_1.kotlinx$atomicfu$value) + ']';
};
var properties_initialized_Mutex_kt_yv4p3j;
function _init_properties_Mutex_kt__jod56b() {
  if (!properties_initialized_Mutex_kt_yv4p3j) {
    properties_initialized_Mutex_kt_yv4p3j = true;
    NO_OWNER = new Symbol('NO_OWNER');
    ON_LOCK_ALREADY_LOCKED_BY_OWNER = new Symbol('ALREADY_LOCKED_BY_OWNER');
  }
}
function get_MAX_SPIN_CYCLES() {
  _init_properties_Semaphore_kt__t514r6();
  return MAX_SPIN_CYCLES;
}
var MAX_SPIN_CYCLES;
function get_PERMIT() {
  _init_properties_Semaphore_kt__t514r6();
  return PERMIT;
}
var PERMIT;
function get_TAKEN() {
  _init_properties_Semaphore_kt__t514r6();
  return TAKEN;
}
var TAKEN;
function get_BROKEN() {
  _init_properties_Semaphore_kt__t514r6();
  return BROKEN;
}
var BROKEN;
function get_CANCELLED() {
  _init_properties_Semaphore_kt__t514r6();
  return CANCELLED;
}
var CANCELLED;
function get_SEGMENT_SIZE_0() {
  _init_properties_Semaphore_kt__t514r6();
  return SEGMENT_SIZE_0;
}
var SEGMENT_SIZE_0;
function decPermits($this) {
  $l$loop: while (true) {
    var p = $this.r27_1.atomicfu$getAndDecrement();
    if (p > $this.m27_1)
      continue $l$loop;
    return p;
  }
}
function coerceAvailablePermitsAtMaximum($this) {
  $l$loop_0: while (true) {
    var cur = $this.r27_1.kotlinx$atomicfu$value;
    if (cur <= $this.m27_1)
      break $l$loop_0;
    if ($this.r27_1.atomicfu$compareAndSet(cur, $this.m27_1))
      break $l$loop_0;
  }
}
function addAcquireToQueue($this, waiter) {
  var curTail = $this.p27_1.kotlinx$atomicfu$value;
  var enqIdx = $this.q27_1.atomicfu$getAndIncrement$long();
  var createNewSegment = createSegment$ref_0();
  var tmp2 = $this.p27_1;
  // Inline function 'kotlin.Long.div' call
  var other = get_SEGMENT_SIZE_0();
  var tmp3 = enqIdx.u2(toLong(other));
  var tmp$ret$3;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(curTail, tmp3, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp1 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur = tmp2.kotlinx$atomicfu$value;
            if (cur.l1i_1.b1(tmp1.l1i_1) >= 0) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp1.n1r()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp2.atomicfu$compareAndSet(cur, tmp1)) {
              if (cur.o1r()) {
                cur.c4();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp1.o1r()) {
              tmp1.c4();
            }
          }
          tmp$ret$1 = Unit_instance;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$3 = s;
        break $l$block_2;
      }
    }
  }
  var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$3);
  // Inline function 'kotlin.Long.rem' call
  var other_0 = get_SEGMENT_SIZE_0();
  var i = enqIdx.v2(toLong(other_0)).d1();
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
  if (segment.f28_1.atomicfu$get(i).atomicfu$compareAndSet(null, waiter)) {
    waiter.o1j(segment, i);
    return true;
  }
  var tmp14 = get_PERMIT();
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
  var value = get_TAKEN();
  if (segment.f28_1.atomicfu$get(i).atomicfu$compareAndSet(tmp14, value)) {
    if (isInterface(waiter, CancellableContinuation)) {
      if (!isInterface(waiter, CancellableContinuation))
        THROW_CCE();
      waiter.n1h(Unit_instance, $this.s27_1);
    } else {
      if (isInterface(waiter, SelectInstance)) {
        waiter.t26(Unit_instance);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unexpected: ' + toString(waiter);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    return true;
  }
  // Inline function 'kotlinx.coroutines.assert' call
  return false;
}
function tryResumeNextFromQueue($this) {
  var curHead = $this.n27_1.kotlinx$atomicfu$value;
  var deqIdx = $this.o27_1.atomicfu$getAndIncrement$long();
  // Inline function 'kotlin.Long.div' call
  var other = get_SEGMENT_SIZE_0();
  var id = deqIdx.u2(toLong(other));
  var createNewSegment = createSegment$ref_1();
  var tmp2 = $this.n27_1;
  var tmp$ret$3;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(curHead, id, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp1 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur = tmp2.kotlinx$atomicfu$value;
            if (cur.l1i_1.b1(tmp1.l1i_1) >= 0) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp1.n1r()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp2.atomicfu$compareAndSet(cur, tmp1)) {
              if (cur.o1r()) {
                cur.c4();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp1.o1r()) {
              tmp1.c4();
            }
          }
          tmp$ret$1 = Unit_instance;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$3 = s;
        break $l$block_2;
      }
    }
  }
  var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$3);
  segment.v1r();
  if (segment.l1i_1.b1(id) > 0)
    return false;
  // Inline function 'kotlin.Long.rem' call
  var other_0 = get_SEGMENT_SIZE_0();
  var i = deqIdx.v2(toLong(other_0)).d1();
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.getAndSet' call
  var value = get_PERMIT();
  var cellState = segment.f28_1.atomicfu$get(i).atomicfu$getAndSet(value);
  if (cellState === null) {
    // Inline function 'kotlin.repeat' call
    var times = get_MAX_SPIN_CYCLES();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.get' call
        if (segment.f28_1.atomicfu$get(i).kotlinx$atomicfu$value === get_TAKEN())
          return true;
      }
       while (inductionVariable < times);
    var tmp15 = get_PERMIT();
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
    var value_0 = get_BROKEN();
    return !segment.f28_1.atomicfu$get(i).atomicfu$compareAndSet(tmp15, value_0);
  } else if (cellState === get_CANCELLED())
    return false;
  else
    return tryResumeAcquire($this, cellState);
}
function tryResumeAcquire($this, _this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, CancellableContinuation)) {
    if (!isInterface(_this__u8e3s4, CancellableContinuation))
      THROW_CCE();
    var token = _this__u8e3s4.j1h(Unit_instance, null, $this.s27_1);
    var tmp_0;
    if (!(token == null)) {
      _this__u8e3s4.k1h(token);
      tmp_0 = true;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    if (isInterface(_this__u8e3s4, SelectInstance)) {
      tmp = _this__u8e3s4.o1t($this, Unit_instance);
    } else {
      var message = 'unexpected: ' + toString(_this__u8e3s4);
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  return tmp;
}
function SemaphoreAndMutexImpl$onCancellationRelease$lambda(this$0) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    this$0.a28();
    return Unit_instance;
  };
}
function createSegment$ref_0() {
  var l = function (p0, p1) {
    return createSegment_0(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
function createSegment$ref_1() {
  var l = function (p0, p1) {
    return createSegment_0(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
function SemaphoreAndMutexImpl(permits, acquiredPermits) {
  this.m27_1 = permits;
  this.o27_1 = atomic$long$1(new Long(0, 0));
  this.q27_1 = atomic$long$1(new Long(0, 0));
  // Inline function 'kotlin.require' call
  if (!(this.m27_1 > 0)) {
    var message = 'Semaphore should have at least 1 permit, but had ' + this.m27_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(0 <= acquiredPermits ? acquiredPermits <= this.m27_1 : false)) {
    var message_0 = 'The number of acquired permits should be in 0..' + this.m27_1;
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var s = new SemaphoreSegment(new Long(0, 0), null, 2);
  this.n27_1 = atomic$ref$1(s);
  this.p27_1 = atomic$ref$1(s);
  this.r27_1 = atomic$int$1(this.m27_1 - acquiredPermits | 0);
  var tmp = this;
  tmp.s27_1 = SemaphoreAndMutexImpl$onCancellationRelease$lambda(this);
}
protoOf(SemaphoreAndMutexImpl).x27 = function () {
  // Inline function 'kotlin.math.max' call
  var a = this.r27_1.kotlinx$atomicfu$value;
  return Math.max(a, 0);
};
protoOf(SemaphoreAndMutexImpl).t27 = function () {
  $l$loop: while (true) {
    var p = this.r27_1.kotlinx$atomicfu$value;
    if (p > this.m27_1) {
      coerceAvailablePermitsAtMaximum(this);
      continue $l$loop;
    }
    if (p <= 0)
      return false;
    if (this.r27_1.atomicfu$compareAndSet(p, p - 1 | 0))
      return true;
  }
};
protoOf(SemaphoreAndMutexImpl).acquireCont = function (waiter) {
  var tmp$ret$1;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.acquire' call
    while (true) {
      var p = decPermits(this);
      if (p > 0) {
        waiter.n1h(Unit_instance, this.s27_1);
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      }
      if (addAcquireToQueue(this, isInterface(waiter, Waiter) ? waiter : THROW_CCE())) {
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      }
    }
    tmp$ret$1 = Unit_instance;
  }
  return tmp$ret$1;
};
protoOf(SemaphoreAndMutexImpl).a28 = function () {
  while (true) {
    var p = this.r27_1.atomicfu$getAndIncrement();
    if (p >= this.m27_1) {
      coerceAvailablePermitsAtMaximum(this);
      // Inline function 'kotlin.error' call
      var message = 'The number of released permits cannot be greater than ' + this.m27_1;
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (p >= 0)
      return Unit_instance;
    if (tryResumeNextFromQueue(this))
      return Unit_instance;
  }
};
function SemaphoreSegment(id, prev, pointers) {
  Segment.call(this, id, prev, pointers);
  this.f28_1 = atomicfu$AtomicRefArray$ofNulls(get_SEGMENT_SIZE_0());
}
protoOf(SemaphoreSegment).o1q = function () {
  return get_SEGMENT_SIZE_0();
};
protoOf(SemaphoreSegment).n1i = function (index, cause, context) {
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.set' call
  var value = get_CANCELLED();
  this.f28_1.atomicfu$get(index).kotlinx$atomicfu$value = value;
  this.l1r();
};
protoOf(SemaphoreSegment).toString = function () {
  return 'SemaphoreSegment[id=' + this.l1i_1.toString() + ', hashCode=' + hashCode(this) + ']';
};
function createSegment_0(id, prev) {
  _init_properties_Semaphore_kt__t514r6();
  return new SemaphoreSegment(id, prev, 0);
}
var properties_initialized_Semaphore_kt_uqcwok;
function _init_properties_Semaphore_kt__t514r6() {
  if (!properties_initialized_Semaphore_kt_uqcwok) {
    properties_initialized_Semaphore_kt_uqcwok = true;
    MAX_SPIN_CYCLES = systemProp('kotlinx.coroutines.semaphore.maxSpinCycles', 100);
    PERMIT = new Symbol('PERMIT');
    TAKEN = new Symbol('TAKEN');
    BROKEN = new Symbol('BROKEN');
    CANCELLED = new Symbol('CANCELLED');
    SEGMENT_SIZE_0 = systemProp('kotlinx.coroutines.semaphore.segmentSize', 16);
  }
}
function createDefaultDispatcher() {
  var tmp;
  if (isJsdom()) {
    tmp = NodeDispatcher_getInstance();
  } else {
    var tmp_0;
    var tmp_1;
    if (!(typeof window === 'undefined')) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = window != null;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = !(typeof window.addEventListener === 'undefined');
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = asCoroutineDispatcher(window);
    } else {
      if (typeof process === 'undefined' || typeof process.nextTick === 'undefined') {
        tmp = SetTimeoutDispatcher_getInstance();
      } else {
        tmp = NodeDispatcher_getInstance();
      }
    }
  }
  return tmp;
}
function isJsdom() {
  return !(typeof navigator === 'undefined') && navigator != null && navigator.userAgent != null && !(typeof navigator.userAgent === 'undefined') && !(typeof navigator.userAgent.match === 'undefined') && navigator.userAgent.match('\\bjsdom\\b');
}
var counter;
function get_DEBUG() {
  return DEBUG;
}
var DEBUG;
function get_classSimpleName(_this__u8e3s4) {
  var tmp0_elvis_lhs = getKClassFromExpression(_this__u8e3s4).pa();
  return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
}
function get_hexAddress(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var result = _this__u8e3s4.__debug_counter;
  if (!(typeof result === 'number')) {
    counter = counter + 1 | 0;
    result = counter;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.__debug_counter = result;
  }
  return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
}
function NodeDispatcher() {
  NodeDispatcher_instance = this;
  SetTimeoutBasedDispatcher.call(this);
}
protoOf(NodeDispatcher).i28 = function () {
  process.nextTick(this.p28_1.n28_1);
};
var NodeDispatcher_instance;
function NodeDispatcher_getInstance() {
  if (NodeDispatcher_instance == null)
    new NodeDispatcher();
  return NodeDispatcher_instance;
}
function ScheduledMessageQueue$processQueue$lambda(this$0) {
  return function () {
    this$0.t28();
    return Unit_instance;
  };
}
function ScheduledMessageQueue(dispatcher) {
  MessageQueue.call(this);
  this.m28_1 = dispatcher;
  var tmp = this;
  tmp.n28_1 = ScheduledMessageQueue$processQueue$lambda(this);
}
protoOf(ScheduledMessageQueue).u28 = function () {
  this.m28_1.i28();
};
protoOf(ScheduledMessageQueue).v28 = function () {
  setTimeout(this.n28_1, 0);
};
protoOf(ScheduledMessageQueue).w28 = function (timeout) {
  setTimeout(this.n28_1, timeout);
};
function w3cSetTimeout(handler, timeout) {
  return setTimeout(handler, timeout);
}
function WindowMessageQueue$lambda(this$0) {
  return function (event) {
    var tmp;
    if (event.source == this$0.i29_1 && event.data == this$0.j29_1) {
      event.stopPropagation();
      this$0.t28();
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function WindowMessageQueue$schedule$lambda(this$0) {
  return function (it) {
    this$0.t28();
    return Unit_instance;
  };
}
function WindowMessageQueue(window_0) {
  MessageQueue.call(this);
  this.i29_1 = window_0;
  this.j29_1 = 'dispatchCoroutine';
  this.i29_1.addEventListener('message', WindowMessageQueue$lambda(this), true);
}
protoOf(WindowMessageQueue).u28 = function () {
  var tmp = Promise.resolve(Unit_instance);
  tmp.then(WindowMessageQueue$schedule$lambda(this));
};
protoOf(WindowMessageQueue).v28 = function () {
  this.i29_1.postMessage(this.j29_1, '*');
};
function w3cSetTimeout_0(window_0, handler, timeout) {
  return setTimeout_0(window_0, handler, timeout);
}
function w3cClearTimeout(window_0, handle) {
  return window_0.clearTimeout(handle);
}
function w3cClearTimeout_0(handle) {
  return clearTimeout(handle);
}
function setTimeout_0(window_0, handler, timeout) {
  return window_0.setTimeout(handler, timeout);
}
function await_0(_this__u8e3s4, $completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.z1i();
  var tmp = await$lambda(cancellable);
  _this__u8e3s4.then(tmp, await$lambda_0(cancellable));
  return cancellable.h1j();
}
function promise(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  return asPromise(async(_this__u8e3s4, context, start, block));
}
function asPromise(_this__u8e3s4) {
  var promise = new Promise(asPromise$lambda(_this__u8e3s4));
  // Inline function 'kotlin.js.asDynamic' call
  promise.deferred = _this__u8e3s4;
  return promise;
}
function await$lambda($cont) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $cont;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
    this_0.y8(tmp$ret$0);
    return Unit_instance;
  };
}
function await$lambda_0($cont) {
  return function (it) {
    var tmp0 = $cont;
    var tmp0_elvis_lhs = it instanceof Error ? it : null;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = tmp0_elvis_lhs == null ? Exception_init_$Create$('Non-Kotlin exception ' + it.toString()) : tmp0_elvis_lhs;
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.y8(tmp$ret$0);
    return Unit_instance;
  };
}
function asPromise$lambda$lambda($this_asPromise, $reject, $resolve) {
  return function (it) {
    var e = $this_asPromise.g1g();
    var tmp;
    if (!(e == null)) {
      tmp = $reject(e);
    } else {
      tmp = $resolve($this_asPromise.d1h());
    }
    return Unit_instance;
  };
}
function asPromise$lambda($this_asPromise) {
  return function (resolve, reject) {
    $this_asPromise.k1f(asPromise$lambda$lambda($this_asPromise, reject, resolve));
    return Unit_instance;
  };
}
function asCoroutineDispatcher(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_elvis_lhs = _this__u8e3s4.coroutineDispatcher;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = new WindowDispatcher(_this__u8e3s4);
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.coroutineDispatcher = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function propagateExceptionFinalResort(exception) {
  console.error(exception.toString());
}
function createEventLoop() {
  return new UnconfinedEventLoop();
}
function UnconfinedEventLoop() {
  EventLoop.call(this);
}
protoOf(UnconfinedEventLoop).h1l = function (context, block) {
  unsupported();
};
function unsupported() {
  throw UnsupportedOperationException_init_$Create$('runBlocking event loop is not supported');
}
function SetTimeoutDispatcher() {
  SetTimeoutDispatcher_instance = this;
  SetTimeoutBasedDispatcher.call(this);
}
protoOf(SetTimeoutDispatcher).i28 = function () {
  this.p28_1.w28(0);
};
var SetTimeoutDispatcher_instance;
function SetTimeoutDispatcher_getInstance() {
  if (SetTimeoutDispatcher_instance == null)
    new SetTimeoutDispatcher();
  return SetTimeoutDispatcher_instance;
}
function SetTimeoutBasedDispatcher$invokeOnTimeout$lambda($block) {
  return function () {
    $block.v1j();
    return Unit_instance;
  };
}
function SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
  return function () {
    // Inline function 'kotlin.with' call
    $continuation.m1h(this$0, Unit_instance);
    return Unit_instance;
  };
}
function SetTimeoutBasedDispatcher() {
  CoroutineDispatcher.call(this);
  this.p28_1 = new ScheduledMessageQueue(this);
}
protoOf(SetTimeoutBasedDispatcher).h1l = function (context, block) {
  this.p28_1.x28(block);
};
protoOf(SetTimeoutBasedDispatcher).p1l = function (timeMillis, block, context) {
  var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$invokeOnTimeout$lambda(block), delayToInt(timeMillis));
  return new ClearTimeout(handle);
};
protoOf(SetTimeoutBasedDispatcher).o1l = function (timeMillis, continuation) {
  var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
  invokeOnCancellation(continuation, new ClearTimeout(handle));
};
function MessageQueue() {
  this.q28_1 = ArrayDeque_init_$Create$();
  this.r28_1 = 16;
  this.s28_1 = false;
}
protoOf(MessageQueue).x28 = function (element) {
  this.y28(element);
  if (!this.s28_1) {
    this.s28_1 = true;
    this.u28();
  }
};
protoOf(MessageQueue).t28 = function () {
  try {
    // Inline function 'kotlin.repeat' call
    var times = this.r28_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = removeFirstOrNull(this);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var element = tmp;
        element.v1j();
      }
       while (inductionVariable < times);
  }finally {
    if (this.p()) {
      this.s28_1 = false;
    } else {
      this.v28();
    }
  }
};
protoOf(MessageQueue).y28 = function (element) {
  return this.q28_1.e(element);
};
protoOf(MessageQueue).e = function (element) {
  return this.y28((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).z28 = function (index, element) {
  this.q28_1.f2(index, element);
};
protoOf(MessageQueue).f2 = function (index, element) {
  return this.z28(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).a29 = function (elements) {
  return this.q28_1.n(elements);
};
protoOf(MessageQueue).n = function (elements) {
  return this.a29(elements);
};
protoOf(MessageQueue).d2 = function () {
  this.q28_1.d2();
};
protoOf(MessageQueue).b29 = function (index, element) {
  return this.q28_1.e2(index, element);
};
protoOf(MessageQueue).e2 = function (index, element) {
  return this.b29(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).g2 = function (index) {
  return this.q28_1.g2(index);
};
protoOf(MessageQueue).q = function (index) {
  return this.q28_1.q(index);
};
protoOf(MessageQueue).x1 = function (fromIndex, toIndex) {
  return this.q28_1.x1(fromIndex, toIndex);
};
protoOf(MessageQueue).p = function () {
  return this.q28_1.p();
};
protoOf(MessageQueue).c29 = function (element) {
  return this.q28_1.u1(element);
};
protoOf(MessageQueue).u1 = function (element) {
  if (!(!(element == null) ? isInterface(element, Runnable) : false))
    return false;
  return this.c29((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).j = function () {
  return this.q28_1.j();
};
protoOf(MessageQueue).d29 = function (elements) {
  return this.q28_1.v1(elements);
};
protoOf(MessageQueue).v1 = function (elements) {
  return this.d29(elements);
};
protoOf(MessageQueue).o = function (index) {
  return this.q28_1.o(index);
};
protoOf(MessageQueue).e29 = function (element) {
  return this.q28_1.w1(element);
};
protoOf(MessageQueue).w1 = function (element) {
  if (!(!(element == null) ? isInterface(element, Runnable) : false))
    return -1;
  return this.e29((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).m = function () {
  return this.q28_1.je_1;
};
function WindowClearTimeout($outer, handle) {
  this.r29_1 = $outer;
  ClearTimeout.call(this, handle);
}
protoOf(WindowClearTimeout).x1h = function () {
  w3cClearTimeout(this.r29_1.t29_1, this.v29_1);
};
function WindowDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
  return function () {
    // Inline function 'kotlin.with' call
    $continuation.m1h(this$0, Unit_instance);
    return Unit_instance;
  };
}
function Runnable$run$ref($boundThis) {
  var l = function () {
    $boundThis.v1j();
    return Unit_instance;
  };
  l.callableName = 'run';
  return l;
}
function WindowDispatcher(window_0) {
  CoroutineDispatcher.call(this);
  this.t29_1 = window_0;
  this.u29_1 = new WindowMessageQueue(this.t29_1);
}
protoOf(WindowDispatcher).h1l = function (context, block) {
  return this.u29_1.x28(block);
};
protoOf(WindowDispatcher).o1l = function (timeMillis, continuation) {
  var handle = w3cSetTimeout_0(this.t29_1, WindowDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
  invokeOnCancellation(continuation, new WindowClearTimeout(this, handle));
};
protoOf(WindowDispatcher).p1l = function (timeMillis, block, context) {
  var handle = w3cSetTimeout_0(this.t29_1, Runnable$run$ref(block), delayToInt(timeMillis));
  return new WindowClearTimeout(this, handle);
};
function delayToInt(timeMillis) {
  return coerceIn(timeMillis, new Long(0, 0), new Long(2147483647, 0)).d1();
}
function ClearTimeout(handle) {
  this.v29_1 = handle;
}
protoOf(ClearTimeout).x1h = function () {
  w3cClearTimeout_0(this.v29_1);
};
protoOf(ClearTimeout).w1h = function (cause) {
  this.x1h();
};
protoOf(ClearTimeout).toString = function () {
  return 'ClearTimeout[' + this.v29_1 + ']';
};
function toDebugString(_this__u8e3s4) {
  return toString(_this__u8e3s4);
}
function get_DefaultDelay() {
  var tmp = Dispatchers_getInstance().a1p_1;
  return isInterface(tmp, Delay) ? tmp : THROW_CCE();
}
function newCoroutineContext(_this__u8e3s4, context) {
  var combined = _this__u8e3s4.h1e().jg(context);
  return !(combined === Dispatchers_getInstance().a1p_1) && combined.a9(Key_instance) == null ? combined.jg(Dispatchers_getInstance().a1p_1) : combined;
}
function get_coroutineName(_this__u8e3s4) {
  return null;
}
function Dispatchers() {
  Dispatchers_instance = this;
  this.a1p_1 = createDefaultDispatcher();
  this.b1p_1 = Unconfined_getInstance();
  this.c1p_1 = new JsMainDispatcher(this.a1p_1, false);
  this.d1p_1 = null;
}
protoOf(Dispatchers).e1p = function () {
  var tmp0_elvis_lhs = this.d1p_1;
  return tmp0_elvis_lhs == null ? this.c1p_1 : tmp0_elvis_lhs;
};
var Dispatchers_instance;
function Dispatchers_getInstance() {
  if (Dispatchers_instance == null)
    new Dispatchers();
  return Dispatchers_instance;
}
function JsMainDispatcher(delegate, invokeImmediately) {
  MainCoroutineDispatcher.call(this);
  this.x29_1 = delegate;
  this.y29_1 = invokeImmediately;
  this.z29_1 = this.y29_1 ? this : new JsMainDispatcher(this.x29_1, true);
}
protoOf(JsMainDispatcher).y1o = function () {
  return this.z29_1;
};
protoOf(JsMainDispatcher).g1l = function (context) {
  return !this.y29_1;
};
protoOf(JsMainDispatcher).h1l = function (context, block) {
  return this.x29_1.h1l(context, block);
};
protoOf(JsMainDispatcher).toString = function () {
  var tmp0_elvis_lhs = this.z1o();
  return tmp0_elvis_lhs == null ? this.x29_1.toString() : tmp0_elvis_lhs;
};
function JobCancellationException(message, cause, job) {
  CancellationException_init_$Init$_0(message, cause, this);
  captureStack(this, JobCancellationException);
  this.a2a_1 = job;
}
protoOf(JobCancellationException).toString = function () {
  return protoOf(CancellationException).toString.call(this) + '; job=' + toString(this.a2a_1);
};
protoOf(JobCancellationException).equals = function (other) {
  var tmp;
  if (other === this) {
    tmp = true;
  } else {
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof JobCancellationException) {
      tmp_2 = other.message == this.message;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = equals(other.a2a_1, this.a2a_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(other.cause, this.cause);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(JobCancellationException).hashCode = function () {
  var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this.a2a_1) | 0, 31);
  var tmp0_safe_receiver = this.cause;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
};
function CancellationException_0(message, cause) {
  return CancellationException_init_$Create$_0(message, cause);
}
function Runnable() {
}
function SchedulerTask() {
}
function AbortFlowException(owner) {
  CancellationException_init_$Init$('Flow was aborted, no more elements needed', this);
  captureStack(this, AbortFlowException);
  this.m23_1 = owner;
}
function SafeCollector$collectContextSize$lambda(count, _unused_var__etf5q3) {
  return count + 1 | 0;
}
function SafeCollector(collector, collectContext) {
  this.p1z_1 = collector;
  this.q1z_1 = collectContext;
  var tmp = this;
  tmp.r1z_1 = this.q1z_1.ig(0, SafeCollector$collectContextSize$lambda);
  this.s1z_1 = null;
}
protoOf(SafeCollector).b1z = function (value, $completion) {
  // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var currentContext = $completion.t8();
  ensureActive(currentContext);
  if (!(this.s1z_1 === currentContext)) {
    checkContext(this, currentContext);
    this.s1z_1 = currentContext;
  }
  return this.p1z_1.b1z(value, $completion);
};
protoOf(SafeCollector).x8 = function () {
};
function identitySet(expectedSize) {
  return HashSet_init_$Create$(expectedSize);
}
function WorkaroundAtomicReference(value) {
  this.w22_1 = value;
}
protoOf(WorkaroundAtomicReference).n18 = function () {
  return this.w22_1;
};
protoOf(WorkaroundAtomicReference).p26 = function (value) {
  this.w22_1 = value;
};
protoOf(WorkaroundAtomicReference).y22 = function (value) {
  var prev = this.w22_1;
  this.w22_1 = value;
  return prev;
};
protoOf(WorkaroundAtomicReference).x22 = function (expected, value) {
  if (this.w22_1 === expected) {
    this.w22_1 = value;
    return true;
  }
  return false;
};
function get_platformExceptionHandlers_() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return platformExceptionHandlers_;
}
var platformExceptionHandlers_;
function get_platformExceptionHandlers() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return get_platformExceptionHandlers_();
}
function DiagnosticCoroutineContextException(context) {
  RuntimeException_init_$Init$_0(toString(context), this);
  captureStack(this, DiagnosticCoroutineContextException);
}
var properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx;
function _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf() {
  if (!properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx) {
    properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx = true;
    // Inline function 'kotlin.collections.mutableSetOf' call
    platformExceptionHandlers_ = LinkedHashSet_init_$Create$();
  }
}
function LockFreeLinkedListHead() {
  LockFreeLinkedListNode.call(this);
}
function LockFreeLinkedListNode() {
  this.l1k_1 = this;
  this.m1k_1 = this;
  this.n1k_1 = false;
}
protoOf(LockFreeLinkedListNode).o1k = function (node, permissionsBitmask) {
  var prev = this.m1k_1;
  var tmp;
  if (prev instanceof ListClosed) {
    tmp = ((prev.e2a_1 & permissionsBitmask) === 0 && prev.o1k(node, permissionsBitmask));
  } else {
    node.l1k_1 = this;
    node.m1k_1 = prev;
    prev.l1k_1 = node;
    this.m1k_1 = node;
    tmp = true;
  }
  return tmp;
};
protoOf(LockFreeLinkedListNode).q1m = function (forbiddenElementsBit) {
  this.o1k(new ListClosed(forbiddenElementsBit), forbiddenElementsBit);
};
protoOf(LockFreeLinkedListNode).p1k = function () {
  if (this.n1k_1)
    return false;
  var prev = this.m1k_1;
  var next = this.l1k_1;
  prev.l1k_1 = next;
  next.m1k_1 = prev;
  this.n1k_1 = true;
  return true;
};
protoOf(LockFreeLinkedListNode).q1k = function (node) {
  if (!(this.l1k_1 === this))
    return false;
  this.o1k(node, -2147483648);
  return true;
};
function ListClosed(forbiddenElementsBitmask) {
  LockFreeLinkedListNode.call(this);
  this.e2a_1 = forbiddenElementsBitmask;
}
function unwrap(exception) {
  return exception;
}
function initCause(_this__u8e3s4, cause) {
}
function recoverStackTrace(exception, continuation) {
  return exception;
}
function recoverStackTrace_0(exception) {
  return exception;
}
function SynchronizedObject() {
}
function systemProp_1(propertyName) {
  return null;
}
function threadContextElements(context) {
  return 0;
}
function CommonThreadLocal() {
  this.e1m_1 = null;
}
protoOf(CommonThreadLocal).n18 = function () {
  var tmp = this.e1m_1;
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(CommonThreadLocal).f1m = function (value) {
  this.e1m_1 = value;
};
function commonThreadLocal(name) {
  return new CommonThreadLocal();
}
//region block: post-declaration
protoOf(JobSupport).m1f = invokeOnCompletion$default;
protoOf(JobSupport).s1f = cancel$default;
protoOf(JobSupport).jg = plus;
protoOf(JobSupport).a9 = get_0;
protoOf(JobSupport).ig = fold;
protoOf(JobSupport).hg = minusKey_0;
protoOf(CoroutineDispatcher).a9 = get;
protoOf(CoroutineDispatcher).hg = minusKey;
protoOf(BufferedChannel).w1w = close$default;
protoOf(BufferedChannel).y1w = cancel$default_0;
protoOf(ChannelCoroutine).w1w = close$default;
defineProp(protoOf(DispatchException), 'cause', function () {
  return this.h1();
});
//endregion
//region block: init
Active_instance = new Active();
Key_instance_1 = new Key_0();
Key_instance_2 = new Key_1();
GlobalScope_instance = new GlobalScope();
Key_instance_3 = new Key_2();
NonDisposableHandle_instance = new NonDisposableHandle();
Key_instance_4 = new Key_3();
counter = 0;
DEBUG = false;
//endregion
//region block: exports
export {
  CoroutineStart_UNDISPATCHED_getInstance as CoroutineStart_UNDISPATCHED_getInstance2fi8udegl4ge1,
  emitAll as emitAllzzmeew3d68ub,
  firstOrNull_0 as firstOrNull3pfaj04seehr5,
  firstOrNull as firstOrNull12rzggh6e86lb,
  await_0 as await3mtczq8ld88gb,
  cancelAndJoin as cancelAndJoinca5q7i6o6enf,
  coroutineScope as coroutineScope327xjtgzh1k2v,
  delay as delay1mo3xq8p6x68f,
  withTimeoutOrNull as withTimeoutOrNull30gvkflmp8gj3,
  _ChannelResult___get_isSuccess__impl__odq1z9 as _ChannelResult___get_isSuccess__impl__odq1z912klyyef6kn9b,
  Key_instance_1 as Key_instancexdagtxajq561,
  Dispatchers_getInstance as Dispatchers_getInstance1nk2l7rcqz5wi,
  GlobalScope_instance as GlobalScope_instance3rq364dcgnf9q,
  Key_instance_3 as Key_instance3o7pj7ik1b183,
  ChannelResult as ChannelResult2y4k69ac6y3du,
  Channel as Channel3r72atmcithql,
  ClosedReceiveChannelException as ClosedReceiveChannelException3ofg6gf5f5b38,
  ClosedSendChannelException as ClosedSendChannelException29m33prpq9jaw,
  ProducerScope as ProducerScopeb3mmhvfa6ll7,
  cancelConsumed as cancelConsumed2i0oizqhmljf6,
  produce_0 as produce1iljho2c8bp6o,
  FlowCollector as FlowCollector26clgpmzihvke,
  MutableSharedFlow as MutableSharedFlow3g4w4npzofx4w,
  MutableStateFlow as MutableStateFlow34bfoyvwu8czu,
  asFlow as asFlow3ngsnn5xpz8pw,
  asSharedFlow as asSharedFlow2buz3fbrowsyg,
  asStateFlow as asStateFlow34rribx643ke5,
  flow as flow3tazazxj2t7g4,
  recoverStackTrace as recoverStackTrace2i3si2i8nvw1k,
  startCoroutineCancellable_1 as startCoroutineCancellable18shtfwdieib,
  Mutex as Mutex16li1l0asjv17,
  CancellableContinuationImpl as CancellableContinuationImpl1cx201opicavg,
  CancellationException_0 as CancellationExceptionjngvjj221x3v,
  CompletableDeferred as CompletableDeferred2lnqvsbvx74d3,
  CompletableJob as CompletableJob1w6swnu15iclo,
  CopyableThrowable as CopyableThrowable1mvc99jcyvivf,
  CoroutineName as CoroutineName2g5zosw74tf0f,
  CoroutineScope_0 as CoroutineScopelux7s7zphw7e,
  CoroutineScope as CoroutineScopefcb5f5dwqcas,
  Job_0 as Job13y4jkazwjho0,
  SupervisorJob as SupervisorJobythnfxkr3jxc,
  async as asyncz02dsa2nb2zt,
  cancel_0 as cancel36mj9lv3a0whl,
  cancel_2 as cancel2en0dn4yvpufo,
  cancel as cancel2ztysw4v4hav6,
  cancel_1 as cancel1xim2hrvjmwpn,
  get_isActive as get_isActivehakov5bm97hw,
  get_job as get_job2zvlvce9o9a29,
  launch as launch1c91vkjzdi9sd,
  promise as promise1ky6tawqaxbt4,
};
//endregion

